import {
    API,
    Designer,
    Endpoints,
    Form,
    FormAPI,
    Group,
    GroupAPI,
    Lang,
    Longread,
    Tag,
    Team,
    TeamAPI,
    UploadFileAPI
} from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import { BaseSyntheticEvent, FC, lazy, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty";
import {
    ProjectEditFrameCreating,
    ProjectEditFrameError,
    ProjectEditFrameForbidden,
    ProjectEditFrameLoading,
    ProjectEditFrameUpdateError
} from "shared/components/error-frames";
import { NavbarCreate } from "shared/components/navbar-elements";
import { CreateLinkTo } from "shared/constants/linkTo";
import {
    AddButton,
    ProjectAuthorsWrapper,
    ProjectEditPageGridLabel,
    ProjectEditPageGridRow
} from "../projectEdit/styles";
import {
    DatePickerTeamWrapper,
    ProjectEditPageGridInput,
    ProjectEditPageGridList
} from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "../projectEdit/ProjectAuthorsEdit";
import { Colors, CommonInput, CommonLabel, FlexBox, GridBox, HintTooltip, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { bTag, LayoutConst, useModal } from "core";
import { useSimpleUploader } from '@brg/uploader';
import { ProjectAddButton } from "../projectEdit/ProjectAddButton";
import { ContentAddContainer } from "../projectEdit/styles";
import { BTag } from "core/components";
import { PageViewportLayout } from "shared/components/template";
import { convertDesignerFromGlobalToLocal } from "../projectEdit/utils";
import { ITeamTab, TeamTabEdit } from "./components/TeamTabEdit";
import { ITeamFilterModel, Item } from "./components/TeamFilterEditView";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import SortableList from "react-easy-sort";

import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { TeamFilterEdit } from "./components/TeamFilterEdit";
import { ReactComponent as PlusSvg } from "../projectEdit/close.svg";
import { BasketIcon } from "../projectEdit/BasketIcon";
import {
    ActionsButton,
    ChannelDescription,
    CommonContainer,
    CompetenceItem,
    CompetenceResult,
    CoverWrapper,
    DefaultButton,
    GridMobileNamed,
    LangBlockWrapper,
    LongreadLinkWrapper,
    MainHeader,
    MainTabsWrapper,
    MobileButtonsWrapper,
    ProjectAvailableLink,
    ProjectAvailableText,
    TableSortWrapper,
    TBody, TeamContextInputWrapper,
    TeamEditLabel,
    TeamsMobGridList,
    TeamUploadText,
    UploaderWrapper
} from "./styles";
import { MagicBoxRow } from "../project/components/toolsStyles";
import { TextAreaLengthCounter } from './components/TextAreaLengthCounter';
import { TeamUploadContainer } from "./components/TeamUploadContainer";
import EditIcon24 from "shared/icons/EditIcon24";
import { getTeamLgId } from "../project/sections/ps-longread";
import { TeamLgEdit } from "./components/TeamLgEdit";
import { computeDataWithLang, computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { useDispatch, useSelector } from "react-redux";
import useQueryState from "shared/hooks/useQueryState";
import { setType } from "shared/reducers/ViewTypeSlice";
import { TeamFormsEdit } from "./components/TeamFormsEdit";
import { useTeamForms } from "shared/hooks/useTeamForms";
import urlApi from "shared/actions/urlApi";
import { ImportGroupsModal } from "./components/ImportGroupsModal";
import {
    createDefaultForm,
    createDefaultGroup,
    createDefaultLangObject
} from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ActionTypes } from "./const/ActionTypes";
import { useTeamGroups } from "shared/hooks/useTeamGroups";
import { TeamGroupEdit } from "./components/TeamGroupEdit";
import { useGetCatalogs } from "../../hooks/api/useGetCatalogs";
import { useGetCollection } from "../../hooks/api/useGetCollection";
//@ts-ignore
import Switch from 'react-input-switch';
import { useBlockPageBeforeUnload } from "shared/hooks/useBlockPageBeforeUnload";
import { SlideNavigation } from "shared/components/slideNavigation";
import { InputType, LangTitleBlock, LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { TEAM_TYPES } from "./const/TeamTypes";
import { Date24Icon } from "../../components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "../../components/tagAdminProjectsSearchBar/date32";
import { CustomDateTimePicker } from "../../../_competition/pages/CreateCompetitionPage/CreateCompetitionPage";
import { COURSE_OPTIONS, CourseTypes } from "./const/CourseTypes";
import TeamTabsBlock, { TabType } from "./components/TeamTabsBlock";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SpecialDropdownButtons } from "./components/SpecialDropdownButtons";
import { HsePolicies } from "shared/constants/HsePolicies";
import 'react-phone-input-2/lib/style.css';
import { LMSCardFormatTypes, LMSCourseDurationTypes, LMSCourseTypes, LMS_CARDFORMAT_OPTIONS, LMS_COURSE_OPTIONS, LMS_DURATION_OPTIONS } from "./const/LMSCourseTypes";
import { addYears } from "date-fns";
import { INIT_ADDITIONAL_CONTENT } from "../projectEdit/components/PresentatitonBlock/PresentatitonBlock";
import { Disciplines } from "./components/Disciplines";
import { ModulesOrder } from "./components/ModulesOrder";
import { TeamDisciplineEdit } from "./components/TeamDisciplineEdit";
import { useLocker } from "shared/hooks/useLocker";
import TeamTopLinksBlock, { ITeamTopLink } from "./components/TeamTopLinksBlock";
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import CheckLongreadRadioButton from "./components/CheckLongreadRadioButton";
import { useProject } from "shared/hooks/api/useProject";
import { ChannelEdit } from "./components/ChannelEdit";
import { HseContextActions } from "shared/reducers/hseCurrentContext";
import DeleteIcon from "shared/icons/DeleteIcon";
import { generateUniqueString } from "shared/utils/generateUniqueString";
import { CHAT_CLOSED_STATUS, ChatPermissionEdit } from "./components/ChatPermissionEdit";
import { isTeamChannel, ModerationType } from "./const/ModerationTypes";
import { FormProvider, useForm } from "react-hook-form";
import { ICourseReadinessForCompletion } from "./types";
import { ARCHIVE_TEAM_STATUS, DRAFT_TEAM_STATUS, PUBLISHED_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { AutoChannelButton, ENTITY_COURSES_TYPE } from "./components/AutoChannelButton";
import { isServer } from "shared/constants/isServer";
import lmsModules from "../exploreHseContextsNew/const/teams/lmsModules";
import { getDefaultChannelCover } from "./components/support/getDefaultChannelCover";
const DraggableTableOriginal = lazy(() => import("./components/DraggableTable"));
import ButtonEditGroup from "./components/ButtonEditGroup";

const DraggableTable = isServer ? FlexBox : DraggableTableOriginal;

const MAX_TEAM_BUTTONS = 4;
const MAX_TABS_COUNT = 15;
const MAX_TOP_LINKS_COUNT = 5;
const MAX_TABS_FOR_LARGE_TABS_VIEW = 2;
const LG_BUTTON = 1;
const CITY_TAGS_COUNT = 1;
const DEFAULT_LG_VIEW_TYPE = 't-shape';
const DEFAULT_TAB = 'about';
const MAX_COURSE_PRICE = 100000000;
export const ALLOWED_CHARACTERS_REG = /[А-Яа-я0-9,?+!@"#№;$%^&*()=]/gi;
export const ALLOWED_CHARACTERS_REG_WITH_NUMBERS = /[А-Яа-я,?+!@"#№;$%^&*()=]/gi;
export const ALLOWED_PHONE_CHARACTERS_REG = /^\+[0-9]{11}$/;
export const REPLACE_LONGREAD_REG = /\/project\/([a-z0-9]+)/;
export const CHANNEL_MAX_SIZE_CONTAINER = 902;
const DEFAULT_MAX_SIZE_CONTAINER = 804;

const INITIAL_PHONE = '+7';
const INITIAL_ANCHOR_LIMIT = 0;

const TABS = [
    {
        name: 'about',
        path: 'about',
    },
    {
        name: 'people',
        path: 'people',
    },
    {
        name: 'projects',
        path: 'projects',
    },
    {
        name: 'lms',
        path: 'lms',
    },
    {
        name: 'marketing',
        path: 'marketing',
    },
];

const DEFAULT_CHANNEL_TAB = {
    about: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    category: '',
    color: "",
    entityType: "",
    filter: {} as ITeamFilterModel,
    gridTitle: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    gridTitleLink: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    href: '',
    isEmpty: false,
    isLinksShow: false,
    isMain: true,
    isSortingHidden: false,
    name: [{ lang: "ru", name: "Основная страница" }, { lang: "en", name: "Main page" }],
    path: generateUniqueString(),
    topLinks: []
}

const DEFAULT_CHANNEL_LMS_TAB = {
    about: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    category: '',
    color: "",
    entityType: "",
    filter: {} as ITeamFilterModel,
    gridTitle: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    gridTitleLink: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    href: '',
    isEmpty: false,
    isLinksShow: false,
    isMain: true,
    isSortingHidden: false,
    name: [{ lang: "ru", name: "Материалы курса" }, { lang: "en", name: "Course materials" }],
    path: generateUniqueString(),
    topLinks: []
}



export interface AddTypeValue {
    specialType?: string
}

export interface ITeamButton extends AddTypeValue {
    type: string;
    text: LangObject[];
    textMobile: LangObject[];
    href: LangObject[];
    actionType: string;
    isRequired: boolean;
    anchor?: { label: string, value: string };
    currentLang?: string;
    hidden?: boolean;
}

export interface IModalSettings {
    mode: 'mainFilter' | 'tab' | 'category' | 'lg' | 'forms' | 'group' | 'shop' | 'discipline' | 'import-groups';
    index: number
    item?: any
}

export const buttonTypesForModer: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' },
    { label: 'anchor-filled', value: 'anchor-filled' },
    { label: 'anchor-hollow', value: 'anchor-hollow' }
];
export const buttonTypes: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' },
];

export const shopButtonTypes: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' }
];

const anchorLimit = [INITIAL_ANCHOR_LIMIT, 1, 2, 3, 4];

export const linkType: { path: string; newTab: boolean } = {
    path: '',
    newTab: false
};

export const cloneValue = (langObj: LangObject[]): LangObject[] => {
    const isEmpty = langObj?.some((i) => i?.name === '');

    if (isEmpty) {
        const lang = langObj?.find((i) => i?.name !== '');
        return langObj?.map((i) => ({ ...i, name: lang?.name || '' })) as LangObject[]
    }

    return langObj
}


export const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    if (value === "") {
        return [
            { lang: 'ru', name: '' },
            { lang: 'en', name: '' }
        ];
    }
    const engValue = current.find(({ lang }) => ['en', 'En']?.includes(lang)) ?? {
        lang: 'en',
        name: '',
    };
    const ruValue = current.find(({ lang }) => ['ru', 'Ru']?.includes(lang)) ?? {
        lang: 'ru',
        name: '',
    };

    if (lang === 'ru') {
        return [{
            lang: 'ru',
            name: value,
        }, engValue];
    } else {
        return [ruValue, {
            lang: 'en',
            name: value,
        }];
    }
}
export const filterMaxLength = (
    text: string,
    maxLength: number,
    toasts: any,
    t: any
): string => {

    if (text?.length > maxLength) {
        toasts.error(t('project_edit.max_title_length_error', { length: maxLength }));
        return text?.slice(0, maxLength);
    }

    return text
}


export const allowedCharacters = (
    ev: any, callback: (val: string) => void) => {
    return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG) === -1 && callback(ev.target.value)
}

export const textAllowed = (
    ev: any, callback: (val: string) => void) => {
    const re = /[0-9A-Za-zА-Яа-я\s]/;
    if (re.test(ev.target.value) || ev.target.value === '') {
        callback(ev.target.value.trimLeft())
        return;
    }
}

export const linkAllowed = (value: string) => {
    const re = /^(http|https)(:\/\/)\w+\.(com|ru|рф)/;
    if (re.test(value)) {
        return true
    }

    return false;
}

export const validateUrlString = (ev: BaseSyntheticEvent, callback: (s: string) => void) => {
    const reg = /^(http:\/\/|https:\/\/)/;
    const prefixArray = [
        '', 'h', 'ht', 'htt', 'http', 'http:','http:/' , 'http://',
        'https', 'https:', 'https:/','https://',
    ];

    if (prefixArray.includes(ev.target.value.toLowerCase()) || reg.test(ev.target.value)) {
        callback(ev.target.value);
        return;
    }
}

export const allowedCharactersWithNumbers = (
    ev: any, callback: (val: string) => void, toasts: any, errorMessage: string) => {
    const newValue = ev.target.value
    if (newValue.length > 300) {
        toasts.error(errorMessage)
        return
    }
    return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG_WITH_NUMBERS) === -1 && callback(ev.target.value)
}

export const allowedPhoneCharacters = (
    ev: any, callback: (val: string) => void) => {
    callback(ev.target.value)
}

export const isNumber = (
    ev: any, callback: (val: string) => void) => {
    return (!!Number(ev?.target?.value) || ev?.target?.value === '') && callback(ev.target.value)
}

export const allowedMaxCount = (n: number, maxCount: number) => n <= maxCount

export const getLGbool = (button: any) => !!button.isRequired /*['longread', 'лонгрид'].includes(name)*/;

const initialColor = Colors.gal;
const initialTitlePosition = 'default';

const fixTimezoneOffsetToShow = (date: Date | undefined): Date => {
    if (!date) return new Date();
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
}

const fixTimezoneOffsetToSave = (date: Date | undefined): Date => {
    if (!date) return new Date();
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}

const translateTags = (copyArray: any[], mainArray: any[], lang: string) => {
    [...copyArray].forEach((x, index) => {
        const tabFilter = {
            ...x.filter,
            tags: null,
            requiredTags: null,
            exceptedTags: null
        };

        if (!!x.filter.tags) {
            const tabFilterTags = [...x.filter.tags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.tags = tabFilterTags;
        }

        if (!!x.filter.requiredTags) {
            const tabFilterRequiredTags = [...x.filter.requiredTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.requiredTags = tabFilterRequiredTags;
        }

        if (!!x.filter.exceptedTags) {
            const tabFilterExceptedTags = [...x.filter.exceptedTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.exceptedTags = tabFilterExceptedTags;
        }

        if (!!x.filter.ownerTags) {
            const tabFilterOwnerTags = [...x.filter.ownerTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.ownerTags = tabFilterOwnerTags;
        }

        mainArray[index].filter = tabFilter;
    });
}
const validateRequiredButtonsFields = (teamButtons: any, currentLang: string): boolean => {
    return teamButtons.every((button: any) => {
        if (!button.isRequired) return true; 
        const isTextValid = button.text.some((t: LangObject) => t.lang === currentLang && t.name.trim() !== '');
        const isAnchorValid = button.type.includes('anchor')
            ? button.anchor.value.trim() !== ''
            : true;
        const isHrefValid = button.actionType === "connect"
            ? true
            : !button.type.includes('anchor')
                ? button.href.some((h: LangObject) => h.lang === currentLang && h.name.trim() !== '')
                : true;

        return isTextValid && isAnchorValid && isHrefValid;
    });
};

const REQUIRED_BUTTONS = [
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Портфолио' }, { lang: 'en', name: 'Portfolio' }],
        textMobile: [{ lang: 'ru', name: 'Портфолио' }, { lang: 'en', name: 'Portfolio' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.longread
    },
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        textMobile: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.showcase
    }
];
const REQUIRED_BUTTONS_LMS = [
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Учебные проекты' }, { lang: 'en', name: 'Educational projects' }],
        textMobile: [{ lang: 'ru', name: 'Учебные проекты' }, { lang: 'en', name: 'Educational projects' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.longread
    },
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        textMobile: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.showcase
    }
];

export const getModerationTypeName = (id: number, t: any) => t(`teams.adminPage.moderationTypes.${id}`);

export const ModerationType_List: {
    label: string;
    value: number;
}[] = Object.entries(ModerationType)
    //@ts-ignore
    .map(([label, value]) => ({ label: '', value: value as number })) // label will be set in TeamEdit
    .filter(x => !isNaN(x.value));

export enum ModuleFormat {
    'FaceToFace' = 0,
    'PreRecorded' = 1,
    'Offline' = 2,
}

const ModuleFormatNames = {
    0: 'face-to-face курсы',
    1: 'предзаписанные курсы',
    2: 'офлайн-курсы',
}


export const ModuleFormatList: {
    label: string;
    value: number;
}[] = Object.entries(ModuleFormat)
    //@ts-ignore
    .map(([label, value]) => ({ label: ModuleFormatNames[value as number], value: value as number }))
    .filter(x => !isNaN(x.value));


export enum TeamProjectsFilter {
    'all' = 0,
    'owners' = 1,
    'participants' = 2
}
export const TeamLongreadType = {
    SelfLongread: 0,
    ReplaceLongread: 1,
};

export enum ShowCaseViewType {
    'showcase' = 0,
    'landing' = 1
}

export enum ShowCaseTitleType {
    'text' = 0,
    'link' = 1
}
export enum ShowCaseFilterType {
    'showcase' = 0,
    'sections' = 1
}

export const TeamProjectsFilter_List_Raw: {
    label: string;
    value: number;
}[] = Object.entries(TeamProjectsFilter)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

const TeamEditComponent: FC = () => {
    const { t, i18n } = useTranslation();
    const profile = useProfile();
    const { id } = useParams<{ id: string }>();
    const throttle = useRef<any>();
    const switchRef = useRef<any>();
    const titleRef = useRef<any>();
    const history = useHistory();
    const modal = useModal();
    const toasts = useToasts();
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const is800 = useBreakpoint(800);
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const is1280 = useBreakpoint(LayoutConst.screen.l_12);
    const is1024 = useBreakpoint(LayoutConst.screen.m_1024);
    const dispatch = useDispatch();

    const [isChangesSaved, setIsChangesSaved] = useState(false);
    const [teamDeleted, setIsTeamDeleted] = useState(false);
    const [isFormFieldsFilled, setIsFormFieldsFilled] = useState(false);

    // ModerationType_List с локализацией
    const ModerationTypeListLocalized = useMemo(() =>
        ModerationType_List.map(item => ({
            ...item,
            label: getModerationTypeName(item.value, t)
        })),
        [t]
    );

    const [team, setTeam] = useState<Team<'Global'> & any>();
    const hasPopulatedFromTeamRef = useRef<boolean>(false);
    const [teamName, setTeamName] = useState<LangObject[]>([]);
    const [teamLongread, setTeamLongread] = useState<Longread>();
    const [teamNameExtra, setTeamNameExtra] = useState<LangObject[]>([]);
    const [teamBGLang, setImageLang] = useState<boolean>(false);
    const [teamAbout, setTeamAbout] = useState<LangObject[]>([]);
    const [teamAboutExtra, setTeamAboutExtra] = useState<LangObject[]>([]);
    const [teamRoute, setTeamRoute] = useState<string>('');
    const [teamPhone, setTeamPhone] = useState<string>('');
    const [teamEmail, setTeamEmail] = useState<string>('');
    const [teamContexts, setTeamContexts] = useState<string[]>([]);
    const [teamCompetences, setTeamCompetences] = useState<Record<string, string>>({});
    const [teamCompetenceYear, setTeamCompetenceYear] = useState<number>(2024);
    const [teamAuthors, setTeamAuthors] = useState<Designer<'Local'>[]>([]);
    const [teamOwners, setTeamOwners] = useState<Designer<'Local'>[]>([]);
    const [teamMembers, setTeamMembers] = useState<Designer<'Local'>[]>([]);
    const [teamContextName, setTeamContextName] = useState<string>('');
    const [teamAnchorLimit, setTeamAnchorLimit] = useState<string>('');
    const [teamModerationType, setTeamModerationType] = useState<{ label: string; value: number; }>(ModerationTypeListLocalized[0]);
    const [teamModerRole, setTeamModerRole] = useState<string>('');
    const [teamTags, setTeamTags] = useState<Tag[]>([]);
    const [teamOwnerTags, setTeamOwnerTags] = useState<Tag[]>([]);
    const [teamManagedTags, setTeamManagedTags] = useState<Tag[]>([]);
    const [teamEducationTags, setTeamEducationTags] = useState<Tag[]>([]);
    const [teamIsCanCreateProject, setTeamIsCanCreateProject] = useState<boolean>(false);
    const [sortingHidden, setSortingHidden] = useState<boolean>(false);
    const [teamIsShopVisible, setTeamIsShopVisible] = useState<boolean>(false);
    const [teamShowQu, setTeamShowQu] = useState<boolean>(false);
    const [teamIsLargeTabs, setTeamIsLargeTabs] = useState<boolean>(false);
    const [teamIsShowEmployeesLink, setTeamIsShowEmployeesLink] = useState<boolean>(false);
    const [teamIsShowGridFirst, setTeamIsShowGridFirst] = useState<boolean>(false);
    const [teamIsShowTeachersCheckbox, setTeamIsShowTeachersCheckbox] = useState<boolean>(false);
    const [teamSwitchButtonVisible, setTeamSwitchButtonVisible] = useState<boolean>(false);
    const [teamIsLongreadDisabled, setTeamIsLongreadDisabled] = useState<boolean>(false);
    const [teamShowLg, setTeamShowLg] = useState<boolean>(false);
    const [teamMainFilter, setTeamMainFilter] = useState<ITeamFilterModel>({} as ITeamFilterModel);
    const [teamButtons, setTeamButtons] = useState<ITeamButton[]>([]);
    const [teamNavButtons, setTeamNavButtons] = useState<ITeamButton[]>([]);
    const [teamTabs, setTeamTabs] = useState<ITeamTab[]>([]);
    const [topLinks, setTopLinks] = useState<ITeamTopLink[]>([]);
    const [teamEntityType, setTeamEntityType] = useState<string>();
    const [teamCategories, setTeamCategories] = useState<ITeamTab[]>([]);
    const [titleIsHidden, setTitleHidden] = useState<boolean>(false);
    const [longread, setLongread] = useState([]);
    const [longreadReady, setLongreadReady] = useState<boolean | null>(null);
    const [hasLongread, setHasLongread] = useState(false);
    const [coverLink, setCoverLink] = useState(linkType);
    const [coverTitle, setCoverTitle] = useState<LangObject[]>([]);
    const { isChannel, channelType } = isTeamChannel(team?.moderationType);

    const [longreadLength, setLongreadLength] = useState(0);
    const [teamLongreadType, setTeamLongreadType] = useState(TeamLongreadType.ReplaceLongread);
    const [longreadEntityLink, setLongreadEntityLink] = useState('');
    const [replaceLongreadId, setReplaceLongreadId] = useState('');
    const [projectId, setProjectId] = useState<string>('');
    const [time, setTime] = useState(Date.now());
    const [projectSource, isProjectLoading, projectError] = useProject(projectId, i18n.language, projectId + time);

    const [blackListIds, setBlackListIds] = useState<string[]>([]);
    const [whiteListIds, setWhiteListIds] = useState<string[]>([]);
    const [channelCommentClosedStatus, setChannelClosedStatus] = useState<CHAT_CLOSED_STATUS>(CHAT_CLOSED_STATUS.open);
    const [channelCommentMsg, setChannelCommentMsg] = useState<LangObject[]>([]);

    const [isCourseCompleted, setIsCourseCompleted] = useState(false);

    const teamBGLangRef = useRef(teamBGLang);
    useEffect(() => {
        teamBGLangRef.current = teamBGLang;
    }, [teamBGLang]);

    const maxFieldSize = useMemo(
        () => (isChannel ? CHANNEL_MAX_SIZE_CONTAINER : DEFAULT_MAX_SIZE_CONTAINER)
        , [isChannel])

    const fetchLongread = useCallback(() => {
        const longreadId = getTeamLgId(team, i18n.language)

        if (longreadId) {
            API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idUser', '2')
                .addQuery('idLongread', longreadId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setLongread(r)
                })
        }
    }, [team, i18n.language])

    const onChangeLongreadLength = useCallback((value: number) => {
        if (longreadLength > 0 && team?.moderationType === ModerationType.LMS) {
            fetchLongread()
        } 
        setLongreadLength(value)
    } , [longreadLength, team])

    const onSetAnchors = useCallback((anchors: any) => {
        //@ts-ignore
        const { visibleAnchorsLimit: limit } = team || {};
        if (anchors?.length) {
            dispatch(HseContextActions.setAnchorLinks({ anchors, limit }))
        }
    }, [dispatch, team])

    useEffect(() => {
        return () => {
            dispatch(HseContextActions.resetAnchorLinks())
        }
    }, [dispatch])


    const TeamProjectsFilter_List = TeamProjectsFilter_List_Raw.map((item: any) => ({ ...item, label: t('teams.adminPage.fields.show_works_' + item.label) }), [t]);
    const [teamProjectsValue, setTeamProjectsFilter] = useState<number>(TeamProjectsFilter_List[0].value);
    const teamProjectsFilter = useMemo(() => {
        const index = TeamProjectsFilter_List.findIndex(i => i?.value === teamProjectsValue)
        return index === -1 ? TeamProjectsFilter_List[0] : TeamProjectsFilter_List[index]
    }, [TeamProjectsFilter_List, teamProjectsValue, t])

    // SHOP
    const [shopAbout, setShopAbout] = useState<LangObject[]>([]);
    const [outOfStockMessage, setOutOfStockMessage] = useState<LangObject[]>([]);
    const [outOfStockLink, setOutOfStockLink] = useState<string>();
    const [isArchiveItemsShop, setIsArchiveItemsShop] = useState<boolean>(false);
    const [hideShopWord, setHideShopWord] = useState<boolean>(false);
    const [isHideParticipantsShop, setIsHideParticipantsShop] = useState<boolean>(false);
    const [isShowTeamEmblem, setIsShowTeamEmblem] = useState(false)
    const [shopNavButtons, setShopNavButtons] = useState<ITeamButton[]>([]);
    const [shopTabs, setShopTabs] = useState<ITeamTab[]>([]);

    const [showCaseViewType, setShowCaseViewType] = useState(ShowCaseViewType.showcase);
    const [feedViewType, setFeedViewType] = useState(0);
    const [showCaseTitleType, setShowCaseTitleType] = useState(ShowCaseTitleType.text);
    const [showCaseFilterType, setShowCaseFilterType] = useState(ShowCaseFilterType.showcase);
    const [isSmallName, setIsSmallName] = useState(false);
    const [isShowFullDescription, setIsShowFullDescription] = useState(false);
    const [isMinimalName, setIsMinimalName] = useState(false);
    const [isMainTitleHidden, setIsMainTitleHidden] = useState(false);
    const [isShowTeamLandingWithProjects, setIsShowTeamLandingWithProjects] = useState(false);
    const [isLinksInsteadTitle, setIsLinksInsteadTitle] = useState(false);
    const [statusText, setStatusText] = useState<string>('');
    const [isCreating, setIsCreating] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isForbidden, setIsForbidden] = useState<boolean>(false);
    const [isUpdateError, setIsUpdateError] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalSettings, setModalSettings] = useState<IModalSettings | null>();
    const [userColor, setUserColor] = useState<string>(initialColor);
    const [userTitlePosition, setUserTitlePosition] = useState<string>(initialTitlePosition);
    const [isPreview, setIsPreview] = useState(false);
    const [currentForm, setCurrentForm] = useState<Form<'Global'>>();
    const [currentGroup, setCurrentGroup] = useState<Group<'Global'>>();
    const [mobileEditorOpen, setMobileEditorOpen] = useState(false);
    const [mobileEditorAction, setMobileEditorAction] = useState<string>('');
    const [mobTextBlockLength, setMobTextBlockLength] = useState<number>(0);
    const [date, setDate] = useState(Date.now());
    const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
    const [additionalContent, setAdditionalContent] = useState(null);
    const [{ tab, idform }, setQueryParams] = useQueryState();
    const [showLoader, setShowLoader] = useState(false);

    const [courseType, setCourseType] = useState<CourseTypes>(CourseTypes.ONLINE);
    const [lmsCourseType, setLmsCourseType] = useState<LMSCourseTypes>(LMSCourseTypes.BachelorsDegree);
    const [lmsCourseTerm, setLmsCourseTerm] = useState<LMSCourseDurationTypes>(LMSCourseDurationTypes.short);
    const [lmsCardFormat, setLmsCardFormat] = useState<LMSCardFormatTypes>(LMSCardFormatTypes.long);
    const [coursePrice, setCoursePrice] = useState<string | undefined>();
    const [courseStartDate, setCourseStartDate] = useState<Date | undefined>();
    const [contextString, setContextsString] = useState('');
    const [competenceString, setCompetenceString] = useState('');
    const [competenceSearchResults, setCompetenceSearchResults] = useState<any[]>([]);
    const [isSearchingCompetences, setIsSearchingCompetences] = useState(false);
    const [competenceSearchError, setCompetenceSearchError] = useState<string | null>(null);
    const [allCompetenceResults, setAllCompetenceResults] = useState<any[]>([]);
    const [showAllResults, setShowAllResults] = useState(false);
    const [useCalendarEnabled, setUseCalendarEnabled] = useState(false);

    const [courseReadinessForCompletion, setCourseReadinessForCompletion] = useState<ICourseReadinessForCompletion | null>(null);

    useLocker();

    const onChangeCoursePrice = useCallback((price: string) => {

        if (Number(price) < 0) {
            toasts.error("Введите валидную стоимость курса");
            return;
        }

        if (Number(price) > MAX_COURSE_PRICE) {
            toasts.error(`Максимальная стоимость курса ${MAX_COURSE_PRICE}`);
            return;
        }

        setCoursePrice(price);

    }, [setCoursePrice, toasts]);

    const searchCompetences = useCallback(async (searchString: string) => {
        if (!searchString || searchString.length < 2) {
            setCompetenceSearchResults([]);
            setCompetenceSearchError(null);
            setAllCompetenceResults([]);
            setShowAllResults(false);
            return;
        }

        setIsSearchingCompetences(true);
        setCompetenceSearchError(null);
        setAllCompetenceResults([]);
        setShowAllResults(false);
        
        try {
            const response = await fetch(`https://api.design.hse.ru/v1.2/competencies?searchString=${encodeURIComponent(searchString)}`);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (Array.isArray(data)) {
                setAllCompetenceResults(data);
                // Ограничиваем количество результатов до 10
                const limitedResults = data.slice(0, 10);
                setCompetenceSearchResults(limitedResults);
                setShowAllResults(false);
                
                if (data.length === 0) {
                    setCompetenceSearchError('Ничего не найдено');
                } else if (data.length > 10) {
                    setCompetenceSearchError(`Найдено ${data.length} результатов. Показаны первые 10.`);
                }
            } else {
                setCompetenceSearchResults([]);
                setCompetenceSearchError('Неверный ответ от сервера');
            }
        } catch (error) {
            console.error('Error searching competences:', error);
            setCompetenceSearchResults([]);
            setCompetenceSearchError('Ошибка при поиске');
        } finally {
            setIsSearchingCompetences(false);
        }
    }, [t]);

    const courseCurrentOption = useMemo(() => COURSE_OPTIONS.find(i => i?.value === courseType) || COURSE_OPTIONS[0], [courseType, COURSE_OPTIONS])
    const lmsCourseCurrentOption = useMemo(() => LMS_COURSE_OPTIONS.find(i => i?.value === lmsCourseType) || LMS_COURSE_OPTIONS[team?.lmsCourseType], [lmsCourseType, LMS_COURSE_OPTIONS])
    const lmsDurationOption = useMemo(() => LMS_DURATION_OPTIONS.find(i => i?.value === lmsCourseTerm) || LMS_DURATION_OPTIONS[team?.lmsCourseTerm], [lmsCourseTerm, LMS_DURATION_OPTIONS])
    const lmsCardTypeOption = useMemo(() => LMS_CARDFORMAT_OPTIONS.find(i => i?.value === lmsCardFormat) || LMS_CARDFORMAT_OPTIONS[team?.lmsCardFormat], [lmsCardFormat, LMS_DURATION_OPTIONS])

    const forms = useTeamForms(team?.teamId, date)

    const { groups, refreshGroups } = useTeamGroups(team?.teamId, date, i18n.language);
    
    const [localGroups, setLocalGroups] = useState<Group<'Global'>[]>([]);
    
    useEffect(() => {
        if (groups?.length) {
            setLocalGroups(groups);
        }
    }, [groups]);

    const computedGroups = useMemo(() => (!!localGroups?.length ? localGroups?.map((g) => API.toLang<Group>(g, i18n.language || 'ru')) : []), [localGroups]);

    const vtype = useSelector((state: any) => state.vt.vtype);

    const hasCurrentUnitAdminPolicy = (p: any, teamId: string) => p && p.rolesList && Array.isArray(p.rolesList)
        && (new ProfileRole(`${HsePolicies.admin_unit_prefix}${teamId}`)).containsIn(p.rolesList);

    const hasAllUnitsAdminPolicy = (p: any) => p && p.rolesList && Array.isArray(p.rolesList)
        && (new ProfileRole(HsePolicies.access_ui_units_admin)).containsIn(p.rolesList);

    const isOwner = useMemo(
        () => profile &&
            ((team?.ownersIDs && team?.ownersIDs?.includes(profile?.accountId)) || hasCurrentUnitAdminPolicy(profile, team?.teamId))
        , [profile, team]);

    const isModer = useMemo(
        () => profile && (bProfile.isModer(profile) || profile?.rolesList?.includes('juniormoder') || hasAllUnitsAdminPolicy(profile))
        , [profile]);

    const hasAccessToTeamsAdmin = isOwner;

    useEffect(() => {
        setIsForbidden(!isModer && !isOwner && !hasAccessToTeamsAdmin)
    }, [isModer, isOwner, hasAccessToTeamsAdmin])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (competenceString && competenceString.length >= 2) {
                searchCompetences(competenceString);
            } else {
                setCompetenceSearchResults([]);
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [competenceString, searchCompetences]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.competences-search-container')) {
                setCompetenceSearchResults([]);
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setCompetenceSearchResults([]);
                setCompetenceString('');
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const unloadSign = useMemo(() => (!isChangesSaved && !isCreating && !teamDeleted), [isChangesSaved, isCreating, teamDeleted]);
    const unloadCallback = (val: boolean) => {
        setIsChangesSaved(val);
    }
    const excluded = [
        `/team-longread-preview`,
        `/preview`,
        `/preview/${id}`,
        `/team-preview`,
        `/team-preview/${id}`,
        `/team-longread-preview/${id}`
    ];
    useBlockPageBeforeUnload(unloadSign, unloadCallback, excluded);

    const sipRef = useRef<any>(null);
    const teamIdRef = useRef<any>();

    const hasTeamBG = useMemo(() => (!!team?.titleImages?.length), [team]);
    const hasTeamBGEn = useMemo(() => (!!team?.titleImages_en?.length), [team]);

    const hasName = useMemo(() => (teamName?.some((i) => i?.name !== '')), [teamName]);
    const hasRoute = useMemo(() => (!!teamRoute?.length), [teamRoute]);
    const hasOwner = useMemo(() => (!!teamOwners?.length), [teamOwners]);
    const hasContext = useMemo(() => (!!teamContextName?.length), [teamContextName]);
    const requiredTopLinks = useMemo(() => (!isLinksInsteadTitle || !!topLinks.filter(topLink => !!topLink?.link?.length && !!topLink?.name?.some(({ name }) => !!name))?.length), [topLinks, isLinksInsteadTitle]);

    const hasCover = useMemo(() => {
        if (!!longread?.length) {
            return longread?.some((post: any) => post?.style === 'as_cover')
        }
    }, [longread, longreadReady]);

    const hasAnnotationPost = useMemo(() => {
        if (!!longread?.length && team?.moderationType === ModerationType.LMS) {
            return longread?.some((post: any) => post?.style === 'annotation')
        }
        return true;
    } , [longread, longreadReady, date, team])

    const canSaveLgText = useMemo(() => {

        if (isChannel) {
            return (hasName && hasOwner)
        }

        if (!requiredTopLinks) {
            return false;
        }
        if (projectError && teamLongreadType === TeamLongreadType.ReplaceLongread) {
            return false
        }
        if (modalSettings?.mode === 'group' && currentGroup) {
            const group = groups?.find((i: Group<'Global'>) => i?.id === currentGroup?.id);
            return group?.name?.some(({ name }) => !!name)
        }
        if (modalSettings?.mode === 'forms') {
            return isFormFieldsFilled
        }
        if (hasCover && !!coverLink?.path?.length) {
            return linkAllowed(coverLink?.path)
        }
        if (modalSettings && (modalSettings.mode === 'lg' || tab === 'lg') && !hasAnnotationPost) {
            return false
        }

        if (teamCategories.length) {
            return teamCategories.every(category => category.path && category.entityType && Lang(category.name, 'ru'))
        }

        if (modalSettings && (modalSettings.mode === 'lg' || tab === 'lg') && hasCover) {
            return true;
        }

        if (hasLongread && !hasAnnotationPost) {
            return false;
        }

        if (hasName && hasOwner && hasContext && teamRoute && validateRequiredButtonsFields(teamButtons, i18n.language)) {
            return true;
        }

        if (!!mobileEditorOpen && mobTextBlockLength === 0 && modalSettings && (modalSettings.mode === 'lg' || tab === 'lg')) {
            return false;
        }

        return false;
    }, [isChannel, hasAnnotationPost, hasLongread, mobTextBlockLength, isFormFieldsFilled, currentGroup, projectError, teamLongreadType, modalSettings, teamRoute, teamButtons, isMobile, tab, mobileEditorOpen, coverLink, hasName, hasRoute, hasOwner, hasCover, hasContext, requiredTopLinks, teamCategories])

    const errors = useMemo(() => {
        const errors = [];

        if (modalSettings?.mode === 'group') {
            const group = groups?.find((i: Group<'Global'>) => i?.id === currentGroup?.id);
            const emptyName = group?.name?.every(({ name }) => !name)

            if (emptyName) {
                errors.push(`${t('teams.adminPage.errors.group_name')}`);
            }
        }

        if (modalSettings?.mode === 'lg') {
            if (!hasAnnotationPost) {
                errors.push(`${t('teams.adminPage.errors.annotation_post')}`);
            }
        }
        if (modalSettings?.mode === 'forms') return [];
        if (teamCategories.length) {
            if (!teamCategories.every(category => category.path && category.entityType && Lang(category.name, 'ru'))) {
                errors.push(`${t('teams.adminPage.errors.section')}`);
            }
        }
        if (hasLongread && !hasAnnotationPost) {
            errors.push(`${t('teams.adminPage.errors.annotation_post')}`);
        }
        if (!hasContext) {
            errors.push(`${t('teams.adminPage.errors.context')}`);
        }
        if (!hasName) {
            errors.push(`${t('teams.adminPage.errors.name')}`);
        }
        if (projectError) {
            errors.push(`${t('teams.adminPage.errors.landing_link')}`);
        }
        if (!requiredTopLinks) {
            errors.push(`${t('teams.adminPage.errors.required_top_links')}`);
        }
        if (!hasOwner) {
            errors.push(`${t('teams.adminPage.errors.owners')}`);
        }
        if (hasCover && !!coverLink?.path?.length && !linkAllowed(coverLink?.path)) {
            errors.push(`${t('teams.adminPage.errors.link')}`);
        }
        return errors;
    }, [hasName, hasRoute, hasAnnotationPost, hasLongread, groups, currentGroup, hasOwner, projectError, t, modalSettings, coverLink, hasCover, longread, hasContext, requiredTopLinks, teamCategories])

    const maxButtonsCount = useMemo(() => {
        const hasLgButton = teamButtons.some((i) => !!i?.isRequired);

        if (!hasLgButton && teamButtons?.length === MAX_TEAM_BUTTONS) return true;

        else if (!!hasLgButton && teamButtons?.length + 1 > (MAX_TEAM_BUTTONS + LG_BUTTON)) return true;

        return false;

    }, [teamButtons])

    const maxShopButtonsCount = useMemo(() => {
        return shopNavButtons?.length + 1 > MAX_TEAM_BUTTONS;
    }, [shopNavButtons])

    const maxLGButtonsCount = useMemo(() => {
        return hasLongread ? MAX_TEAM_BUTTONS : MAX_TEAM_BUTTONS - 1;
    }, [hasLongread]);



    useEffect(() => {
        setIsChangesSaved(false);
    }, [
        team,
        teamName,
        coverTitle,
        teamNameExtra,
        teamAbout,
        teamRoute,
        teamContexts,
        showCaseViewType,
        feedViewType,
        showCaseTitleType,
        showCaseFilterType,
        teamAuthors,
        teamOwners,
        teamMembers,
        teamContextName,
        teamModerationType,
        teamProjectsFilter,
        teamSwitchButtonVisible,
        teamModerRole,
        teamTags,
        teamOwnerTags,
        teamManagedTags,
        teamEducationTags,
        teamIsCanCreateProject,
        sortingHidden,
        titleIsHidden,
        teamIsLargeTabs,
        teamIsShowEmployeesLink,
        teamIsShowGridFirst,
        teamIsShopVisible,
        teamIsShowTeachersCheckbox,
        teamAnchorLimit,
        teamButtons,
        teamTabs,
        topLinks,
        coverLink,
        teamCategories,
        hasLongread,
        teamMainFilter,
        teamLongread,
        isSmallName,
        isMinimalName,
        isMainTitleHidden,
        isShowTeamLandingWithProjects,
        isLinksInsteadTitle,
        // currentForm,
        teamShowLg,
        userColor,
        vtype,
    ])

    const [updatedTeam, setUpdatedTeam] = useState(false)
    
    const refreshTeamData = useCallback(() => {
        if (id) {
            TeamAPI.Get({ idTeam: id })
                .then(res => res.json())
                .then(data => {
                    setTeam(data);
                    setUpdatedTeam(false);
                    setDate(Date.now());
                })
                .catch((reason) => {
                    console.error('Error refreshing team data:', reason);
                });
        }
    }, [id]);

    const onFeedViewTypeChange = (value: any) => {
        setFeedViewType(Number(value))
    }
    
    useEffect(() => {
        if (!updatedTeam) return;
        refreshTeamData();
    }, [updatedTeam, refreshTeamData]);


    useEffect(() => {
        if (profile) {
            if (id) {
                
                TeamAPI.Get({ idTeam: id })
                    .then((value) => value.json() as Promise<Team<'Global'>>)
                    .then((value) => {
                        if (value.teamId) {
                            setTeam(value);
                            setIsError(false);
                        } else {
                            setTeam(undefined);
                            setIsError(true);
                        }
                    })
                    .catch((reason) => {
                        console.error(reason);
                        setTeam(undefined);
                        setIsError(true);
                    });
            } else {
                setIsCreating(true);
                TeamAPI.Add({
                    name: createEmptyLangObject('', ['ru', 'en']),
                    initialTab: ''
                } as Team<'Global'> & any)
                    .then((res) => res.json())
                    .then((res: any) => {
                        setTimeout(() => {
                            setIsCreating(false);
                            history.replace(CreateLinkTo.teamEdit(res));
                        }, 800);
                    });
            }
        }
    }, [id, profile, history, date]);

    useEffect(() => {
        if (team?.teamId) {
            API.request()
                .endpoint(Endpoints.geograffee)
                .url("/api/lms/IsCourseCompleted")
                .get()
                .addQuery("teamId", team.teamId)
                .send()
                .then((r) => r.json())
                .then((r) => {
                    console.log("IsCourseCompleted", r);
                    setIsCourseCompleted(r);
                })
                .catch((e) => console.error(e));
        } 
    }, [team]);

    useEffect(() => {
        if (team?.teamId) {
            teamIdRef.current = team?.teamId
        }
    }, [team])

    useEffect(() => {
        if (tab === 'lg') {
            onModalStateChange(true, { mode: "lg", index: 2 })
        }
        if (tab === 'forms' && idform?.length) {
            onModalStateChange(true, { mode: "forms", index: 2 })
            setCurrentForm(forms?.filter((i) => i?.formId === idform)[0])
        }
        if (tab === 'people') {
            setCurrentTab('people')
        }
    }, [tab, forms, idform])

    useEffect(() => {
        if (team && team.teamId && !hasPopulatedFromTeamRef.current) {
            setTeamName(team.name?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamLongread(team?.longread)
            setTeamNameExtra(!!team.nameExtra?.length ? team.nameExtra : createDefaultLangObject(''));
            setTeamAbout(team.about?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamAboutExtra(team.aboutExtra?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamRoute(team.route);
            setTeamPhone(team.phone || INITIAL_PHONE);
            setTeamEmail(team.email);
            setTeamContexts(team.contexts);
            setTeamCompetences(team?.competences ? team.competences : {});
            setTeamCompetenceYear(team?.competenceYear || 0);
            //@ts-ignore
            setTeamAuthors(team.lmsCourseAuthors ? [...team.lmsCourseAuthors].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)) : []);
            setTeamOwners([...team.owners].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)));
            setTeamMembers([...team.members].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)));
            setTeamContextName(team.contextName);
            setTitleHidden(team.isTitleHidden);

            if (isChannel) {
                setBlackListIds(team.channelCommentBlackListIds)
                setWhiteListIds(team.channelCommentWhiteListIds)
                setChannelClosedStatus(team.channelCommentClosedStatus)
                setChannelCommentMsg(team.channelCommentMsg)
            }

            //@ts-ignore
            setIsSmallName(team.isSmallName);
            //@ts-ignore
            setIsShowFullDescription(team.isShowFullDescription);
            //@ts-ignore
            setIsMinimalName(team.isMinimalName);
            //@ts-ignore
            setIsMainTitleHidden(team.isMainTitleHidden);
            //@ts-ignore
            setIsShowTeamLandingWithProjects(team.isShowTeamLandingWithProjects);
            setIsLinksInsteadTitle(team.isLinksInsteadTitle);
            setTeamModerRole(team.moderRole);
            setTeamIsCanCreateProject(team.isCanCreateProject);
            setSortingHidden(team.isSortingHidden);
            setTeamIsLargeTabs(team.isLargeTabs);
            setTeamIsShowEmployeesLink(team.isShowEmployeesLink);
            setTeamSwitchButtonVisible(team.isSwitchButtonVisible);

            //@ts-ignore
            setTeamIsLongreadDisabled(team.isLongreadDisabled);
            //@ts-ignore
            setTeamIsShowGridFirst(team.isShowGridFirst);
            //@ts-ignore
            setTeamIsShopVisible(team.isShopVisible);
            //@ts-ignore
            setTeamShowQu(team.showQu);
            //@ts-ignore
            setTeamEntityType(team.mainEntityType);
            //@ts-ignore
            setIsShowTeamEmblem(team?.isShowTeamEmblem)

            //@ts-ignore
            setOutOfStockLink(team.outOfStockLink);
            //@ts-ignore
            setIsArchiveItemsShop(team.isArchiveItemsShop);
            //@ts-ignore
            setHideShopWord(team.hideShopWord);
            //@ts-ignore
            setIsHideParticipantsShop(team?.isHideParticipantsShop);
            //@ts-ignore
            setShopNavButtons([...team?.shopNavButtons].sort((a, b) => b.isRequired ? -1 : 1)?.map((button) => computeDataWithLang(button)));
            //@ts-ignore
            const shopTabs = [...team.shopTabs];
            translateTags([...team.shopTabs], shopTabs, i18n.language);
            setShopTabs(shopTabs?.map((tab) => ({ ...computeDataWithLang(tab), entityType: tab?.entityType || '' })));
            //@ts-ignore
            setOutOfStockMessage(team?.outOfStockMessage);
            //@ts-ignore
            setShopAbout(team?.shopAbout);

            //@ts-ignore
            setCourseType(team.lmsModuleFormat);
            //@ts-ignore
            setLmsCourseType(team.lmsCourseType);
            //@ts-ignore
            setLmsCourseTerm(team.lmsCourseTerm)
            //@ts-ignore
            setLmsCardFormat(team.lmsCover)
            //@ts-ignore
            setCoursePrice(team?.lmsModulePrice.toString());
            //@ts-ignore
            setTeamLongreadType(team?.longreadType || TeamLongreadType.SelfLongread);
            //@ts-ignore
            setLongreadEntityLink(team?.longreadEntityLink || '');
            //@ts-ignore
            setReplaceLongreadId(team?.replaceLongreadId || '');
            //@ts-ignore
            setCourseStartDate(fixTimezoneOffsetToShow(new Date(team?.lmsModuleStartDate || Date.now())));

            setShowCaseViewType(team.isShowGridFirst ? ShowCaseViewType.showcase : team?.isShowLongread ? ShowCaseViewType.landing : ShowCaseViewType.showcase)
            //@ts-ignore
            setFeedViewType(team?.moderationType === ModerationType.Channel ?  (!!team?.isShowFeed ? 1 : 0) : 0)
            setTeamIsShowTeachersCheckbox(team.isShowTeachersCheckbox);
            setUserColor(team?.additionalInfo?.color || initialColor);
            setUserTitlePosition(team?.additionalInfo?.titlePosition || initialTitlePosition);
            setTeamButtons([...team.buttons].sort((a, b) => b.isRequired ? 1 : -1)?.map((button) => computeDataWithLang(button)));
            setTeamNavButtons(team.navButtons?.map((button: any) => computeDataWithLang(button)));

            setTeamShowLg(team?.isShowLongread);
            setTeamAnchorLimit(team?.visibleAnchorsLimit);
            setCoverLink(team?.coverLink ?? linkType);
            setCoverTitle(!!team.coverTitle?.length ? team.coverTitle : createDefaultLangObject(''));

            setAdditionalContent(isChannel ? INIT_ADDITIONAL_CONTENT : (team?.additionalContent || INIT_ADDITIONAL_CONTENT))

            const moderationType = ModerationTypeListLocalized.find(x => x.value === team.moderationType);
            if (moderationType) {
                setTeamModerationType(moderationType);
            }

            const projectsFilter = TeamProjectsFilter_List.find(x => x.value === team.teamProjectsFilter);
            if (projectsFilter) {
                setTeamProjectsFilter(projectsFilter);
            }

            fetchLongread();

            const tags = [...team.tags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const ownerTags = [...team.ownerTags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const managedTags = [...team.managedTags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const educationTags = [...(team.educationTags || [])].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            setTeamTags(tags);
            setTeamOwnerTags(ownerTags);
            setTeamManagedTags(managedTags);
            setTeamEducationTags(educationTags);
            setUseCalendarEnabled(team?.mainFilter?.useCalendar)

            const mainFilter = {
                ...team.mainFilter,
                tags: null,
                requiredTags: null,
                exceptedTags: null,
            };

            if (!!team.mainFilter.tags) {
                const mainFilterTags = [...team.mainFilter.tags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.tags = mainFilterTags;
            }

            if (!!team.mainFilter.requiredTags) {
                const mainFilterRequiredTags = [...team.mainFilter.requiredTags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.requiredTags = mainFilterRequiredTags;
            }

            if (!!team.mainFilter.exceptedTags) {
                const mainFilterExceptedTags = [...team.mainFilter.exceptedTags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.exceptedTags = mainFilterExceptedTags;
            }

            setTeamMainFilter(mainFilter);


            const tabs = [...team.tabs];
            const categories = [...team.categories];
            const teamTopLinks = [...(team?.topLinks || [])];

            translateTags([...team.tabs], tabs, i18n.language);
            translateTags([...team.categories], categories, i18n.language);

            dispatch(setType(team?.longread?.viewType || DEFAULT_LG_VIEW_TYPE))
            setTeamTabs(tabs?.map((tab) => ({ ...computeDataWithLang(tab), entityType: tab?.entityType || '' })));
            setTopLinks(teamTopLinks?.map((teamTopLink) => ({ ...computeDataWithLang(teamTopLink) })));
            setTeamCategories(categories?.map((category) => ({ ...computeDataWithLang(category), entityType: category?.entityType || '' })));

            if (isChannel && !tabs?.length) {
                setTeamTabs([(channelType === ModerationType.ChannelGroupOrCourse) ? DEFAULT_CHANNEL_LMS_TAB : DEFAULT_CHANNEL_TAB])
            }
            hasPopulatedFromTeamRef.current = true;
        }
    }, [team, dispatch, longreadReady]);


    const updateLg = async () => {
        await API.request('/api/Longread/Update')
            .endpoint(Endpoints.longread)
            .post()
            .body({
                ...teamLongread,
                viewType: vtype,
            })
            .send()
    }

    const entityList = useMemo(() => {
        if (!isModer) {
            return [
                {
                    label: t('teams.adminPage.entities.projects'),
                    value: 'projects'
                },
                {
                    label: t('teams.adminPage.entities.teams'),
                    value: 'organizations',
                },
                {
                    label: t('teams.adminPage.entities.modules'),
                    value: 'modules',
                }
            ]
        }
        return [{
            label: t('teams.adminPage.entities.projects'),
            value: 'projects'
        }, {
            label: t('teams.adminPage.entities.cached_projects'),
            value: 'main'
        }, {
            label: t('teams.adminPage.entities.teams'),
            value: 'organizations',
        }, {
            label: t('teams.adminPage.entities.competitions'),
            value: 'competitions_new',
        }, {
            label: t('teams.adminPage.entities.modules'),
            value: 'modules',
        }, {
            label: t('teams.adminPage.entities.people'),
            value: 'people',
        }
        ]
    }, [t, isModer])

    useEffect(() => {
        if (team && team.teamId && isChangesSaved) {
            if (throttle.current) {
                clearTimeout(throttle.current);
                throttle.current = null;
            }

            setStatusText(t('saving'));

            throttle.current = setTimeout(() => {
                if (team && team.teamId) {
                    const courseActualPrice = coursePrice && Number(coursePrice?.replace(/\s/g, ''))
                    const computeModerationType = channelType === ModerationType.Channel ?
                        ModerationType.Channel : teamModerationType.value;
                    const computeContext = channelType === ModerationType.Channel ?
                        ['channels'] : channelType === ModerationType.ChannelGroupOrCourse ?
                            ['channel_course_and_groups']
                            : teamContexts
                    const computeEntityType = channelType === ModerationType.Channel ?
                        'channels' : channelType === ModerationType.ChannelGroupOrCourse ?
                            'channel_course_and_groups'
                            : teamEntityType
                    const copy: Team<'Global'> = { ...team };


                    copy.name = cloneValue(teamName)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    //@ts-ignore
                    copy.nameExtra = cloneValue(teamNameExtra)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    // //@ts-ignore
                    // copy.longread = teamLongread;
                    copy.about = cloneValue(teamAbout)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    //@ts-ignore
                    copy.aboutExtra = cloneValue(teamAboutExtra)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    copy.route = teamRoute;
                    //@ts-ignore
                    copy.phone = (teamPhone !== INITIAL_PHONE ? teamPhone : '');
                    //@ts-ignore
                    copy.email = teamEmail;
                    //@ts-ignore
                    copy.contexts = computeContext
                    //@ts-ignore
                    copy.lmsCourseAuthorIds = teamAuthors.map(x => x.designerId);
                    copy.ownersIDs = teamOwners.map(x => x.designerId);
                    copy.membersIDs = teamMembers.map(x => x.designerId);
                    //@ts-ignore
                    copy.isTitleHidden = titleIsHidden;
                    //@ts-ignore
                    copy.contextName = isChannel ? team?.teamId : teamContextName;
                    //@ts-ignore
                    copy.moderationType = computeModerationType;
                    //@ts-ignore
                    copy.teamProjectsFilter = teamProjectsFilter.value;
                    //@ts-ignore
                    copy.lmsModuleFormat = courseType;
                    //@ts-ignore
                    copy.lmsCourseType = lmsCourseType;
                    //@ts-ignore
                    copy.lmsCourseTerm = lmsCourseTerm;
                    //@ts-ignore
                    copy.lmsCover = lmsCardFormat;
                    //@ts-ignore
                    copy.lmsModulePrice = courseActualPrice;
                    //@ts-ignore
                    copy.lmsModuleStartDate = fixTimezoneOffsetToSave(courseStartDate);
                    //@ts-ignore
                    copy.moderRole = teamModerRole;
                    copy.tagIds = teamTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.ownerTagIds = teamOwnerTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.managedTagIds = teamManagedTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.educationTagIds = teamEducationTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.isCanCreateProject = teamIsCanCreateProject;
                    //@ts-ignore
                    copy.isSortingHidden = sortingHidden;
                    //@ts-ignore
                    copy.isShowTeamEmblem = isChannel ? true : isShowTeamEmblem;
                    //@ts-ignore
                    copy.isLargeTabs = teamIsLargeTabs;
                    //@ts-ignore
                    copy.isShowEmployeesLink = teamIsShowEmployeesLink;
                    //@ts-ignore
                    copy.isShowTeachersCheckbox = teamIsShowTeachersCheckbox;
                    copy.isSwitchButtonVisible = teamSwitchButtonVisible;
                    //@ts-ignore
                    copy.isShopVisible = teamIsShopVisible;
                    //@ts-ignore
                    copy.showQu = teamShowQu;
                    //@ts-ignore
                    copy.initialTab = '';
                    //@ts-ignore
                    copy.isLongreadDisabled = teamIsLongreadDisabled;
                    //@ts-ignore
                    copy.isShowLongread = showCaseViewType === ShowCaseViewType.landing;
                    //@ts-ignore
                    copy.isShowFeed = channelType === ModerationType.Channel ? (feedViewType === 1) : Boolean(0)
                    //@ts-ignore
                    copy.isShowGridFirst = showCaseViewType === ShowCaseViewType.showcase;
                    //@ts-ignore
                    copy.visibleAnchorsLimit = teamAnchorLimit || INITIAL_ANCHOR_LIMIT;
                    //@ts-ignore
                    copy.coverLink = coverLink;
                    //@ts-ignore
                    copy.coverTitle = cloneValue(coverTitle)?.map((i) => ({ ...i, name: i?.name?.trim() }));;
                    //@ts-ignore
                    copy.isSmallName = isSmallName;
                    //@ts-ignore
                    copy.isShowFullDescription = isShowFullDescription;
                    //@ts-ignore
                    copy.isMinimalName = isMinimalName;
                    //@ts-ignore
                    copy.isMainTitleHidden = isMainTitleHidden;
                    //@ts-ignore
                    copy.isShowTeamLandingWithProjects = isShowTeamLandingWithProjects;
                    //@ts-ignore
                    copy.isLinksInsteadTitle = isLinksInsteadTitle;
                    //@ts-ignore
                    copy.mainFilter = {
                        ...teamMainFilter,
                        contexts: !!teamMainFilter.contexts?.length ? teamMainFilter.contexts : null,
                        globalTypes: !!teamMainFilter.globalTypes?.length ? teamMainFilter.globalTypes : null,
                        tagIds: !!teamMainFilter.tags?.length ? teamMainFilter.tags.map(t => t.tagId) : null,
                        requiredTagIds: !!teamMainFilter.requiredTags?.length ? teamMainFilter.requiredTags.map(t => t.tagId) : null,
                        exceptedTagIds: !!teamMainFilter.exceptedTags?.length ? teamMainFilter.exceptedTags.map(t => t.tagId) : null,
                        tags: null,
                        requiredTags: null,
                        exceptedTags: null,
                        useCalendar: teamMainFilter.useCalendar,
                    };
                    //@ts-ignore
                    copy.additionalInfo = { 
                        ...team?.additionalInfo, 
                        color: userColor, 
                        titlePosition: userTitlePosition,
                    };
                    //@ts-ignore
                    copy.buttons = teamButtons;
                    //@ts-ignore
                    copy.competences = teamCompetences;
                    //@ts-ignore
                    copy.competenceYear = teamCompetenceYear;
                    //@ts-ignore
                    copy.navButtons = teamNavButtons;
                    //@ts-ignore
                    copy.coverLink = coverLink;
                    //@ts-ignore
                    copy.mainEntityType = computeEntityType

                    //@ts-ignore
                    copy.outOfStockLink = outOfStockLink;
                    //@ts-ignore
                    copy.isArchiveItemsShop = isArchiveItemsShop;
                    //@ts-ignore
                    copy.hideShopWord = hideShopWord;
                    //@ts-ignore
                    copy.isHideParticipantsShop = isHideParticipantsShop;
                    //@ts-ignore
                    copy.shopNavButtons = shopNavButtons;
                    //@ts-ignore
                    copy.outOfStockMessage = outOfStockMessage;
                    //@ts-ignore
                    copy.shopAbout = shopAbout;
                    //@ts-ignore
                    copy.longreadType = teamLongreadType;
                    //@ts-ignore
                    copy.longreadEntityLink = longreadEntityLink;
                    //@ts-ignore
                    copy.replaceLongreadId = replaceLongreadId;

                    //@ts-ignore
                    copy.additionalContent = additionalContent;
                    //@ts-ignore
                    copy.shopTabs = shopTabs.map(x => {
                        return {
                            ...x,
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null
                            }
                        };
                    });

                    //@ts-ignore
                    copy.topLinks = topLinks.map(x => {
                        return {
                            ...x,
                        };
                    });

                    //@ts-ignore
                    copy.tabs = teamTabs?.filter((tab) => {
                        return tab?.name?.some((i) =>  i?.name !== '')
                    }).map(x => {
                        return {
                            ...x,
                            //@ts-ignore
                            color: x.color || '',
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                ownerTagIds: !!x.filter.ownerTags?.length ? x.filter.ownerTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null,
                                ownerTags: null,
                                useCalendar: x.filter.useCalendar,
                            }
                        };
                    });

                    //@ts-ignore
                    copy.categories = teamCategories.map(x => {
                        return {
                            ...x,
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null
                            }
                        };
                    });

                    if (isChannel) {
                        copy.channelCommentBlackListIds = blackListIds
                        copy.channelCommentWhiteListIds = whiteListIds
                        copy.channelCommentClosedStatus = channelCommentClosedStatus
                        copy.channelCommentMsg = channelCommentMsg
                    }

                    updateLg();

                    TeamAPI.Update(copy)
                        .then((e) => {
                            if (e.status !== 200) {
                                setIsUpdateError(true)
                            }
                            else {
                                if (localGroups?.length && groups?.length) {
                                    const hasOrderChanged = localGroups.some((localGroup, index) => {
                                        const originalGroup = groups[index];
                                        return !originalGroup || localGroup.id !== originalGroup.id;
                                    });
                                    
                                    if (hasOrderChanged) {
                                    const groupsToUpdate = localGroups.map((group, index) => ({ id: group.id, position: index }));
                                    
                                     const updatePromises = localGroups.map((group, index) => 
                                         //@ts-ignore
                                         GroupAPI.Update({ ...group, position: index })
                                     );
                                     
                                     Promise.all(updatePromises)
                                         .then(() => {
                                             refreshGroups();
                                         })
                                         .catch((error: any) => {
                                             console.error('Error updating group positions:', error);
                                             refreshGroups();
                                         });
                                    }
                                }
                                
                                setTimeout(() => {
                                    setStatusText(t('editing_saved'))
                                    setUpdatedTeam(true)
                                    setTeamName(copy.name)
                                }, 1000);
                            }
                        })
                        .catch(() => setIsUpdateError(true));
                }
            }, 1000);
        }
    }, [
        t,
        team,
        teamName,
        teamNameExtra,
        teamAbout,
        teamAboutExtra,
        teamRoute,
        teamContexts,
        feedViewType,
        showCaseViewType,
        coverTitle,
        teamAuthors,
        teamOwners,
        teamMembers,
        teamContextName,
        teamModerationType,
        isChannel,
        teamProjectsFilter,
        additionalContent,
        teamSwitchButtonVisible,
        teamModerRole,
        teamPhone,
        teamEmail,
        teamTags,
        teamOwnerTags,
        teamManagedTags,
        teamEducationTags,
        teamIsCanCreateProject,
        sortingHidden,
        useCalendarEnabled,
        isShowTeamEmblem,
        titleIsHidden,
        teamIsLargeTabs,
        teamIsShowEmployeesLink,
        teamIsShowGridFirst,
        teamIsShopVisible,
        teamShowQu,
        teamIsShowTeachersCheckbox,
        teamAnchorLimit,
        teamButtons,
        teamNavButtons,
        teamTabs,
        topLinks,
        teamCategories,
        coverLink,
        hasLongread,
        teamMainFilter,
        teamEntityType,
        isSmallName,
        isMinimalName,
        isMainTitleHidden,
        isShowTeamLandingWithProjects,
        isLinksInsteadTitle,
        // currentForm,
        teamShowLg,
        teamCompetenceYear,
        teamCompetences,
        userColor,
        userTitlePosition,
        vtype,
        isChangesSaved,
        courseType,
        lmsCourseType,
        lmsCourseTerm,
        lmsCardFormat,
        coursePrice,
        courseStartDate,
        teamIsLongreadDisabled,
        outOfStockLink,
        isArchiveItemsShop,
        hideShopWord,
        canSaveLgText,
        isHideParticipantsShop,
        shopNavButtons,
        shopTabs,
        outOfStockMessage,
        shopAbout,
        replaceLongreadId,
        longreadEntityLink,
        teamLongreadType
    ]);

    const anchorTypes = useMemo(() => {
        if (!!longread?.length) {
            //@ts-ignore
            return longread?.filter((post) => !!post?.anchorText?.length)?.reduce((acc, val) => {
                //@ts-ignore
                return [...acc, { label: val.anchorText, value: val?.postId }]
            }, [])
        }
    }, [longread])

    //@ts-ignore
    const hasAnchors = useMemo(() => (!!anchorTypes?.length), [longread, anchorTypes])

    const onChannelDelete = () => {
        const confirmation = window.confirm('Вы действительно хотите удалить канал?');

        if (confirmation) {
            API.request('/api/Team/UpdateStatus')
                .endpoint(Endpoints.geograffee)
                .post()
                .body({
                    "teamId": team?.teamId,
                    "status": ARCHIVE_TEAM_STATUS
                })
                .send()
                .then((r) => {
                    setIsTeamDeleted(true)
                    toasts.info('Успешно')
                    history.replace(CreateLinkTo.designer(team.ownersIDs?.[0] || ''))
                }).catch((err) => toasts.error('Возникли проблемы'))
        }
    }

    const onToggleChannelStatus = async (canPublish?: boolean) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": team?.teamId,
            "status": canPublish ? PUBLISHED_TEAM_STATUS : DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
        .catch((err) => toasts.error('Возникли проблемы'))
    }

    const onBackClick = () => {
        onModalStateChange(false, null);
        setQueryParams({ tab: null })
    }

    const backToLongread = () => {
        setQueryParams({ tab: 'lg', idform: undefined })
        onModalStateChange(true, { mode: "lg", index: 2 })
    }

    const getRedirectIfBackClick = useCallback(() => {
        if (!!mobileEditorOpen) {
            setMobileEditorAction('close');
            setMobTextBlockLength(0);
            onModalStateChange(true, { mode: "lg", index: 2 })
            setTimeout(() => {
                setMobileEditorAction('');
                setMobileEditorOpen(false);
            }, 1000)
            return;
        }

        switch (modalSettings?.mode) {
            case 'mainFilter':
            case 'tab':
            case 'category':
            case 'group':
            case 'discipline':
            case 'import-groups':
                return onModalStateChange(false, null);
            case 'lg':
            case 'shop':
                return onBackClick()
            case 'forms':
                return idform?.length ? backToLongread() : onModalStateChange(false, null);
            default:
                if (isOwner) {
                    history.push(`/teams/${teamContextName || ''}`);
                } else {
                    history.push(CreateLinkTo.teamAdmin());
                }
                return;
        }
    }, [
        idform,
        isOwner,
        history,
        modalSettings,
        mobileEditorOpen,
        teamContextName,
        onBackClick,
        backToLongread,
    ]);

    const onChannelQuit = useCallback(() => {
        history.push('/teams/' + team?.teamId)
    } , [canSaveLgText, team])


    const primaryButtonClick = useCallback((): void => {
        if (profile) {
            if (!!mobileEditorOpen) {
                setMobileEditorAction('add');
                setMobTextBlockLength(0)
                setTimeout(() => {
                    setMobileEditorAction('');
                    setMobileEditorOpen(false);
                }, 1000);
                return;
            }
            setStatusText(t('save'));
            toasts.info(t('teams.admin.msg.save'));
            setIsChangesSaved(true);

            if (!!idform?.length) {
                setTimeout(() => backToLongread(), 1000)
            }
            if (isChannel) {
                onToggleChannelStatus(true)
                setShowLoader(true);
                setTimeout(() => {
                    setShowLoader(false);
                    window.open(window.location.origin + '/teams/' + team?.teamId, '_SELF')
                }, 3000)
            }
        }
    }, [profile, history, t, mobileEditorOpen, isChannel, idform]);

    const secondaryButtonText = useMemo(() => {
        switch (modalSettings?.mode) {
            case 'lg':
            case 'tab':
            case 'category':
            case 'mainFilter':
            case 'forms':
            case 'import-groups':
                return t("nav.back")
            default:
                return t("nav.exit_other")
        }
    }, [isMobile, modalSettings, t])

    const statusPfx = useMemo(() => (modalSettings?.mode === 'lg'), [modalSettings]);

    const previewButtonVisible = useMemo(
        () => ((modalSettings?.mode === 'lg' || !modalSettings) && (isOwner || isModer || hasAccessToTeamsAdmin))
        , [modalSettings, isOwner, isModer, hasAccessToTeamsAdmin]);

    const previewButtonEnabled = useMemo(
        () => {
            const hasName = teamName?.every(({ name }) => !!name)
            return hasName;

        }, [teamName, teamAbout, hasTeamBG, hasTeamBGEn])

    const onPreviewClick = useCallback(() => {
        if (previewButtonVisible) {
            !modalSettings
                ? history.push(`/team-preview/${team.teamId}`)
                : history.push(CreateLinkTo.previewTeamLongread(team.teamId))
            setIsPreview(true)
        }
    }, [previewButtonVisible, modalSettings, history, team, hasLongread, teamContextName])


    const canEditSelfLG = useMemo
        (() => (hasLongread && teamLongreadType === TeamLongreadType.SelfLongread)
            , [hasLongread, team?.longreadEntityLink, teamLongreadType])

    const PortalMenu = useMemo(() => {
        const outer = document.getElementById('navbar-portal');

        if (!outer) {
            return null;
        }

        return createPortal(
            <NavbarCreate
                previewButtonVisible={isChannel ? false : previewButtonVisible}
                previewButtonEnabled={previewButtonEnabled}
                primaryButtonEnabled={canSaveLgText}
                primaryButtonText={t('save')}
                secondaryButtonText={secondaryButtonText}
                mobileEditorOpen={mobileEditorOpen}
                errors={errors}
                toggleMobileEditor={setMobileEditorOpen}
                stateText={statusText}
                onSecondaryClick={getRedirectIfBackClick}
                onPrimaryClick={primaryButtonClick}
                showStatusPfx={statusPfx}
                viewTypeVisible={modalSettings?.mode === 'lg'}
                onPreviewClick={onPreviewClick}
                isLMSModule={team?.moderationType == ModerationType.LMS}
                primaryButtonVisible={!isChannel}
                secondaryButtonVisible={!isChannel}
            />,
            outer,
        );
    }, [isChannel, getRedirectIfBackClick, statusText, canSaveLgText, previewButtonEnabled, mobileEditorOpen, primaryButtonClick, t, secondaryButtonText, statusPfx, modalSettings, errors]);

    const onTeamAuthorsChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamAuthors(authors);
    };

    const onTeamOwnersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamOwners(authors);
    };

    const onTeamMembersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamMembers(authors);
        setIsChangesSaved(true);
    };

    const onTeamButtonAdd = useCallback(() => {
        if (maxButtonsCount) {
            const hasLgButton = teamButtons.some((i) => !!i?.isRequired);
            toasts.error(`Максимальное количество кнопок - ${hasLgButton ? MAX_TEAM_BUTTONS + LG_BUTTON : MAX_TEAM_BUTTONS}`);
            setTeamButtons(teamButtons.slice(0, 4));
            return;
        }
        const buttons = [...teamButtons];
        buttons.push({
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        });
        setTeamButtons(btns => [
            ...btns,
            {
                type: 'filled',
                text: createEmptyLangObject('', ['ru', 'en']),
                textMobile: createEmptyLangObject('', ['ru', 'en']),
                href: createEmptyLangObject('', ['ru', 'en']),
                isRequired: false,
                actionType: '',
                anchor: { label: '', value: '' },
            }
        ]);
    }, [teamButtons, maxButtonsCount, toasts]);

    const onTeamNavButtonAdd = useCallback(() => {
        const buttons = [...teamNavButtons];
        if (buttons.length === 0) {
            buttons.push({
                type: 'filled',
                text: createEmptyLangObject('', ['ru', 'en']),
                textMobile: createEmptyLangObject('', ['ru', 'en']),
                href: createEmptyLangObject('', ['ru', 'en']),
                isRequired: false,
                actionType: '',
                anchor: { label: '', value: '' },
            });
            setTeamNavButtons(buttons);
        }

    }, [teamButtons, maxButtonsCount, toasts]);

    const onShopNavButtonAdd = useCallback(() => {

        const buttons = [...shopNavButtons];
        buttons.push({
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        });
        setShopNavButtons(buttons.sort((a, b) => b.isRequired ? -1 : 1));

        if (maxShopButtonsCount) {
            toasts.error('Максимальное количество кнопок - 3');
            setShopNavButtons(shopNavButtons.slice(0, 4));
            return;
        }

    }, [shopNavButtons, maxShopButtonsCount, toasts]);

    const onTeamButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...teamButtons];
        buttons[index] = button;
        setTeamButtons(buttons);
    }, [teamButtons]);

    const onTeamNavButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...teamNavButtons];
        buttons[index] = button;
        setTeamNavButtons(buttons);
    }, [teamNavButtons]);

    const onShopNavButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...shopNavButtons];
        buttons[index] = button;
        setShopNavButtons(buttons);
    }, [shopNavButtons]);

    const onTeamButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...teamButtons];
            buttons.splice(index, 1);
            setTeamButtons(buttons);
        }
    }, [teamButtons]);

    const onTeamNavButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...teamNavButtons];
            buttons.splice(index, 1);
            setTeamNavButtons(buttons);
        }
    }, [teamNavButtons]);

    const onShopNavButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...shopNavButtons];
            buttons.splice(index, 1);
            setShopNavButtons(buttons);
        }
    }, [shopNavButtons]);


    const { catalogs, isLoading: isCatalogsLoading } = useGetCatalogs("brnd", teamOwners?.length > 0 ? teamOwners[0]?.accountId : '')
    const [colT, setColT] = useState(Date.now());
    const [isCreateColButtonDisabled, setIsCreateColButtonDisabled] = useState(false);
    const { collection, isLoading: isCollectionLoading } = useGetCollection(team?.teamId, colT)

    const onTeamTabChange = useCallback((type: TabType, tab: ITeamTab, index: number) => {
        const tabIndex: any = {
            [TabType.tab]: teamTabs,
            [TabType.category]: teamCategories,
            [TabType.shop]: shopTabs,
        };
        const editedTabs: ITeamTab[] = tabIndex[type];

        const tabs = (tab.isMain && !editedTabs[index].isMain)
            ? editedTabs.map((x, i) => ({
                ...x,
                isMain: i === index || (x.isMain && x.category !== tab.category)
            }))
            : [...editedTabs];

        tabs[index] = tab;

        if (type === TabType.tab) {
            setTeamTabs(tabs);
        }
        if (type === TabType.category) {
            setTeamCategories(tabs);
        }
        if (type === TabType.shop) {
            setShopTabs(tabs);
        }
    }, [teamTabs, teamCategories, shopTabs, teamIsLargeTabs]);



    const onTeamCoverLinkChange = ({ target }: any) => {
        const { value } = target;
        setCoverLink({ ...coverLink, path: value })
    };

    const onTeamLinkTabToggle = () => setCoverLink({ ...coverLink, newTab: !coverLink?.newTab })

    const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        setTeamTabs(arrayMoveImmutable(teamTabs, oldIndex, newIndex));
    }, [teamTabs]);

    const onGroupDragEnd = useCallback((result: any) => {
        if (!result.destination || !localGroups?.length || result.source.index === result.destination.index) {
            return;
        }
        
        const newGroups = arrayMoveImmutable(localGroups, result.source.index, result.destination.index);
        setLocalGroups(newGroups);
        
        setIsChangesSaved(false);
    }, [localGroups]);

    const onTeamTabDelete = useCallback((index: number) => {
        if (window.confirm('Вы действительно хотите удалить вкладку?')) {
            setTeamTabs(teamTabs.filter((_, i) => i !== index));
        }
    }, [teamTabs]);

    /**
     * ПОКА ЧТО ОСТАВИТЬ, ЧТОБЫ МОЖНО БЫЛО УДАЛИТЬ ФОРМУ ИЗ ЛОНГРИДА
     */
    // const onDeleteLongreadFormPost = (id: string) => {
    //     //@ts-ignore
    //     const post = longread?.find((lg) => !!lg?.additionalInfo?.length ? lg?.additionalInfo?.[0]?.value === id : undefined);
    //     console.log('TEST', post)
    //     //@ts-ignore
    //     if (post?.postId) {
    //         //@ts-ignore
    //         urlApi().deleteLgPost(post?.postId)
    //     } 
    // }

    // useEffect(() => {
    //     onDeleteLongreadFormPost("7b05540b85704343866e52dbf07922d2")
    // } , [longread])
    const actualForms = forms;

    const onFormDelete = useCallback((id: string) => {
        if (window.confirm('Вы действительно хотите удалить форму и пост в лонгриде?')) {
            //@ts-ignore
            FormAPI.Delete({ formId: id }).then(() => {
                //@ts-ignore
                const post = longread?.find((lg) => lg?.additionalInfo?.[0]?.value === id);
                //@ts-ignore
                if (post?.postId) {
                    //@ts-ignore
                    urlApi().deleteLgPost(post.postId).then(() => setDate(Date.now()));
                }
                setDate(Date.now());
            });
        }
    }, [longread]);

    const onGroupDelete = (id: string) => {
        if (window.confirm('Вы действительно хотите удалить группу?')) {
            //@ts-ignore
            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/Group/Delete')
                .post()
                .addQuery('id', id)
                .send()
                .then(() => {
                    setDate(Date.now());
                    //@ts-ignore
                    onModalStateChange(undefined);
                    toasts.info('Группа удалена');
                });
        }
    }

    const onCoverLinkDelete = () => {
        if (window.confirm('Вы действительно хотите удалить ссылку для обложки?')) {
            setCoverLink(linkType);
        }
    }

    const onModalStateChange = (show: boolean, settings: IModalSettings | null) => {
        if (show && !settings) {
            setIsError(true);
        }
        else {
            window.scrollTo(0, 0);
            !show && setShowModal(show);
            setModalSettings(settings);
            show && setShowModal(show);
        }
    };
    const idRef = useRef(id);

    useEffect(() => {
        idRef.current = id;
    }, [id]);

    const updateTeam = useCallback(() => {
        if (!idRef.current) {
            console.error('No ID provided');
            return;
        }

        TeamAPI.Get({ idTeam: idRef.current })
            .then((value) => value.json() as Promise<Team<'Global'>>)
            .then((value) => {
                if (value.teamId) {
                    setTeam(value);
                    setIsError(false);
                } else {
                    setTeam(undefined);
                    setIsError(true);
                }
            })
            .catch((reason) => {
                console.error(reason);
                setTeam(undefined);
                setIsError(true);
            });
    }, []);


    const uploaderCallback = useCallback(
        // @ts-ignore
        (fileId) => {
            if (!fileId) {
                return null;
            }

            const localization = teamBGLangRef.current ? 'en' : i18n.language;

            return UploadFileAPI.Upload({
                fileId,
                profileId: teamIdRef?.current,
                service: 'geography',
                entityType: 'geographyteamavatar',
                localization,
            })
                .then((res) => {
                    sipRef.current.uploader.uploader.uppy.reset();
                    updateTeam();
                    return res;
                });
        },
        [teamIdRef, i18n.language, teamBGLang, updateTeam]
    );

    const createNewForm = () => {
        //@ts-ignore
        urlApi().createForm({ ...createDefaultForm(), teamId: team?.teamId ?? '' }).then((r) => r.json()).then((formId) => {
            setDate(Date.now())
            //@ts-ignore
            FormAPI.GetList({ teamIds: [team?.teamId], limit: 100, page: 1 })
            .then((r) => {
                return r.json()
            })
            .then((r) => {
                //@ts-ignore
                setCurrentForm(r.data.find(form => form.formId === formId))
                onModalStateChange(true, { mode: "forms", index: -1 })
            })
        })
    }

    useEffect(() => {
        if (!team) return;

        let buttons = (team.buttons as ITeamButton[]).map(btn =>
            computeDataWithLang(btn)
        );

        if (hasLongread) {
            const missing = (team?.moderationType == ModerationType.LMS ? REQUIRED_BUTTONS_LMS : REQUIRED_BUTTONS)
                .filter(rb => !team.buttons.some(b => b.actionType === rb.actionType))
                .map(rb => computeDataWithLang(rb));
            buttons = [...missing, ...buttons];
        } else {
            buttons = buttons.filter(btn => !btn.isRequired);
        }

        buttons = buttons.slice(0, hasLongread ? MAX_TEAM_BUTTONS : MAX_TEAM_BUTTONS - 1);

        setTeamButtons(buttons);
    }, [team, i18n.language, hasLongread]);

    const createGroup = () => {
        //@ts-ignore
        GroupAPI.Add({ ...createDefaultGroup(), ownerTeamId: team.teamId })
            .then((r) => r.json()).then((r) => {
                setCurrentGroup(r)
                setTimeout(() => {
                    onModalStateChange(true, { mode: "group", index: 4 });
                    setDate(Date.now())
                } , 1000)
            })
    }

    const onLandingVisibleChange = () => {
        if (teamIsShowGridFirst) {
            setTeamShowLg(true);
            setTeamIsShowGridFirst(false);
            setShowCaseViewType(ShowCaseViewType.landing);
        } else {
            setTeamIsShowGridFirst(true);
            setTeamShowLg(false);
            setShowCaseViewType(ShowCaseViewType.showcase);
        }
    }
    const onTitleVisibleChange = useCallback(() => {
        if (showCaseTitleType) {
            setShowCaseTitleType(ShowCaseTitleType.text);
            setIsLinksInsteadTitle(false);
        } else {
            setShowCaseTitleType(ShowCaseTitleType.link);
            setIsLinksInsteadTitle(true);
            if (topLinks?.length === 0) {
                setTopLinks([{
                    name: createEmptyLangObject('', ['ru', 'en']),
                    link: ''
                }]);
            }
        }
    }, [showCaseTitleType, topLinks]);

    const onToggleLgView = () => {
        modal.show('artz-legals-load', { text: "Сохранение данных" })

        setIsChangesSaved(true)

        setTimeout(() => {
            setDate(Date.now())
            modal.hide();
            onModalStateChange(true, { mode: "lg", index: 2 })
        }, 3000)
    }

    const onToggleCourseCompletionModal = () => {
        modal.show('confirmCourseCompletionModal', 
            { 
                teamId: team.teamId, 
                handleClose: () => modal.hide(), 
                handleComplete: () => {
                    API.request()
                    .endpoint(Endpoints.geograffee)
                    .url("/api/lms/CompleteCourse")
                    .get()
                    .addQuery("teamId", team.teamId)
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        modal.hide()
                        toasts.info(t('teams.adminPage.modal.confirmCourseCompletion.course_completed'))
                        setIsCourseCompleted(true);
                    })
                    .catch((e) => console.error(e));
                } 
            });
    }

    const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));

    const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
            dimensions?: boolean;
            size?: boolean;
            ratio?: boolean;
            type?: boolean;
        } = {};

        if (!isOwner && !isModer && !hasAccessToTeamsAdmin) return false;

        const loadFile = () => new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = function () { // file is loaded
                const img = new Image();

                img.onload = function () {
                    const {
                        width,
                        height,
                    } = img;
                    resolve({
                        width,
                        height,
                    })
                };

                //@ts-ignore
                img.src = fr.result; // is the data URL because called with readAsDataURL
            };
            fr.readAsDataURL(files[0]);
        })

        //@ts-ignore
        const { height, width } = await loadFile();

        if (!['image/jpeg'].includes(files?.[0]?.type)) {
            toasts.error('Допустимые форматы: jpg');
            failedChecks.size = true;
        }

        const {
            size: failedSize,
            dimensions: failedDimensions,
            ratio: failedRatio,
        } = failedChecks;

        if (failedSize || failedDimensions || failedRatio) {
            sipRef.current.uploader.inputRef.current.value = '';

            return false;
        }

        return true;
    }, [isOwner, isModer, hasAccessToTeamsAdmin]);

    const sip = useSimpleUploader(uploaderCallback, uploadValidator);
    sipRef.current = sip;

    const mainHeader = useMemo(
        () => {
            if (isChannel) {
                return t('teams.adminPage.channel_settings')
            } else if (modalSettings && modalSettings.mode === 'mainFilter') {
                return t('teams.adminPage.main_filter')
            }

            return t('teams.adminPage.main_header')

        }, [modalSettings, t, isChannel])

    const showAddDescription = useMemo(() => (modalSettings && modalSettings.mode === 'mainFilter'), [modalSettings])

    const onDeleteBG = () => {
        modal.show('confirmDeleteCoverModal', {
            teamId: team.teamId,
            teamBGLang,
            onDelete: updateTeam,
            handleClose: modal.hide,
        });
    }

    const teamBG = useMemo(() => {
        if (hasTeamBG || (teamBGLang && hasTeamBGEn)) {
            return (
                <CoverWrapper justify="flex-start" direction="column" directionMobile="column" align={'flex-start'} alignMobile="flex-start">
                    <FlexBox className={'cover-container'} direction={'row'} directionMobile="row" offsetTopMobile={10}>
                        {teamBGLang ? <TeamUploadText>{team?.titleImages_en?.[0]?.url?.split('/')?.slice(-1)}</TeamUploadText> : <TeamUploadText>{team?.titleImages?.[0]?.url?.split('/')?.slice(-1)}</TeamUploadText>}
                        <FlexBox direction="row" directionMobile="row" offsetLeft={12} offsetLeftMobile={12} style={{ position: 'relative', cursor: 'pointer' }}>
                            <EditIcon24 />
                            {/*@ts-ignore*/}
                            <TeamUploadContainer team={team} teamId={team?.teamId ?? ''} fileInput={sip} />
                        </FlexBox>
                        <FlexBox offsetLeft={8} offsetLeftMobile={8}>
                            <DeleteIcon fill={'#909090'} onClick={onDeleteBG} />
                        </FlexBox>
                    </FlexBox>

                    {!isChannel && <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetLeftMobile={0}>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isShowTeamEmblem}
                            label={''}
                            onClick={() => setIsShowTeamEmblem(!isShowTeamEmblem)}
                            isTeamEdit
                        />
                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_team_emlem')}</span>
                    </FlexBox>}

                </CoverWrapper>
            )
        }
    }, [isChannel, hasTeamBG, team, sip, teamBGLang, hasTeamBGEn]);

    const tabList = useMemo(() => {
        return TABS.filter(tab => teamModerationType?.value !== 3 ? tab.name !== 'lms' : true).reduce((res: any, { name, path }: any) => {
            return {
                ...res,
                [path]: t(`teams.adminPage.tabs.${name}`),
            }
        }, {})
    }, [TABS, t, teamModerationType]);

    const channelTabsList = useMemo(() => {
        const isPersonalChat = channelType === ModerationType.Channel
        const tabs = [{ name: 'main', path: 'about' }, { name: isPersonalChat ? 'feed' :'chat', path: isPersonalChat ? 'feed' :'chat' }];
        return tabs?.reduce((res: any, { name, path }: any) => {
            return {
                ...res,
                [path]: t(`teams.adminPage.tabs.${name}`),
            }
        }, {})
    }, [TABS, t, teamModerationType, channelType]);

    const teamContextsTypes = useMemo(() => {
        //@ts-ignore
        return teamContexts?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
    }, [teamContexts])

    const anchorLimitTypes = useMemo(() => {
        //@ts-ignore
        return anchorLimit?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
    }, [])


    const moderTypeBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <CommonInput
                    label={t('teams.adminPage.fields.moder_type')}
                    orientation="wide"
                    type={INPUT_TYPES.dropdown}
                    options={ModerationTypeListLocalized.filter(item => item.value !== 7) as any}
                    value={teamModerationType as any}
                    onChange={(item: any) => setTeamModerationType(item)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerationType, ModerationTypeListLocalized])

    const handleSetContext = (item) => {
        const slicedTeamRoute = teamRoute.split('/').pop();
        const currentContexts = item.value === 1 ? 'hsedesign' : slicedTeamRoute;
        const currentContextName = slicedTeamRoute;

        const defaultEntity = item.value === 3 ? 'modules' : 'projects';

        setTeamMainFilter({ ...teamMainFilter, contexts: [currentContexts || ''] })
        setTeamContextName(currentContextName || team?.contextName || '')
        setTeamModerationType(item)
        setTeamEntityType(defaultEntity)
    }
    const contentBlock = useMemo(() => {
        const filteredOptions = ModerationTypeListLocalized.filter(item =>
            item.value === 1 ||
            item.value === 5 ||
            item.value === 3 ||
            item.value === 6
        ).map(item => {

            let tooltipText = '';
            switch (item.value) {
                case 1:
                    tooltipText = 'Любой контент – размещение любых проектов на страницу (витрину) организации';
                    break;
                case 5:
                    tooltipText = 'Свой контент – размещение проектов администраторов и участников организации. Для организации создается собственный тег организации';
                    break;
                case 3:
                    tooltipText = 'Свои учебные курсы – размещение курсов доп. образования, т.е. проектов специального формата (учебные модули с возможностью добавлять занятия, домашние задания, экзамены и т.п.)';
                    break;
                case 6:
                    tooltipText = 'Свой контент (без тега юнита) – формат, аналогичный "Своему контенту", но без создания тега организации';
                    break;
                default:
                    tooltipText = '';
            }

            return {
                ...item,
                label: (
                    <HintTooltip
                        positionY="default"
                        text={tooltipText}
                        z={6}
                        onWhiteBg
                    >
                        <span>{item.label}</span>
                    </HintTooltip>
                )
            };
        });

        const dropdownValueOptions = ModerationTypeListLocalized.filter(item =>
            item.value === 1 ||
            item.value === 5 ||
            item.value === 3 ||
            item.value === 6
        );

        const currentValue = dropdownValueOptions.find(item => item.value === teamModerationType?.value) || dropdownValueOptions[0];

    return (
        <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
            <CommonLabel 
                label={t('teams.adminPage.fields.content_type')}
                required
            />
            <ProjectEditPageGridInput isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    options={filteredOptions as any}
                    value={currentValue as any}
                    onChange={(item: any) => handleSetContext(item)}
                />
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    )
}, [isS, t, teamModerationType, team])
    
    const coverBlock = useMemo(() => {        
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>

                <CommonLabel 
                    label={t('teams.adminPage.fields.cover')}
                    onLanguageChange={() => setImageLang(!teamBGLang)}
                    lang={teamBGLang ? 'en' : 'ru'}
                    useLangSwitcher={!isChannel}
                    {...(!isChannel ? { infoText: t('teams.adminPage.additionalFields.image_msg'), onWhiteBG: true} : { fixedHeight: true })}
                />
                <ProjectEditPageGridInput  isTeamEdit>
                    {hasTeamBG && !teamBGLang ? teamBG : teamBGLang && hasTeamBGEn ? teamBG : (
                        <UploaderWrapper onClick={() => setIsChangesSaved(true)} width={195} widthMobile={195} style={{ position: 'relative' }}>
                            <DefaultButton wh={195} whMob={195} style={{ ...(isChannel && isMobile && { marginTop: 8 }) }}>
                                {t('teams.adminPage.buttons.load')}
                            </DefaultButton>
                            {/*@ts-ignore*/}
                            <TeamUploadContainer team={team} teamId={team?.teamId ?? ''} fileInput={sip} />
                        </UploaderWrapper>
                    )}
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasTeamBG, hasTeamBGEn, teamBGLang, isChannel, isS, sip, t, team, teamBG])

    const coverLinkBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
                    {is1024 ? (
                        <ProjectEditPageGridInput gyMobile={16}  isTeamEdit directionMobile="column" justifyMobile="start" alignMobile="start">
                            <CommonInput
                                type={INPUT_TYPES.text}
                                label={t('teams.adminPage.fields.cover_link')}
                                infoText={t('teams.adminPage.additionalFields.cover_msg')} 
                                value={coverLink?.path}
                                placeholder={t('teams.adminPage.placeholders.adress')}
                                onChange={onTeamCoverLinkChange}
                            />
                            <FlexBox justify={'flex-start'}>
                                <MagicBoxRow
                                    className="checkbox checkbox-with-label"
                                    //@ts-ignore
                                    checked={coverLink?.newTab}
                                    label={t('teams.adminPage.additionalFields.new_tab')}
                                    onClick={() => onTeamLinkTabToggle()}
                                    isTeamEdit

                                />
                            </FlexBox>
                        </ProjectEditPageGridInput>
                    ) : (
                        <JustTable isTeamEdit>
                            <tr>
                                <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                        <CommonInput 
                                            type={INPUT_TYPES.text}
                                            label={t('teams.adminPage.fields.cover_link')}
                                            infoText={t('teams.adminPage.additionalFields.cover_msg')}
                                            value={coverLink?.path}
                                            placeholder={t('teams.adminPage.placeholders.adress')}
                                            onChange={onTeamCoverLinkChange}
                                        />
                                    </TableSortWrapper>
                                </td>
                                <td style={{ width: isS ? '70px' : '140px' }}>
                                    <FlexBox justify={'center'}>
                                        <MagicBoxRow
                                            className="checkbox checkbox-with-label"
                                            //@ts-ignore
                                            checked={coverLink?.newTab}
                                            label={t('teams.adminPage.additionalFields.new_tab')}
                                            onClick={() => onTeamLinkTabToggle()}
                                            isTeamEdit

                                        />
                                    </FlexBox>
                                </td>
                                <td style={{ width: isS ? '56px' : '336px' }}>
                                    <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                        {isS ? (
                                            <FlexBox offsetLeftMobile={8}>
                                                <BasketIcon fill={'#838382'} onClick={() => onCoverLinkDelete()} />
                                            </FlexBox>
                                        ) : (
                                            <DefaultButton wh={131} whMob={107} onClick={() => onCoverLinkDelete()}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                        )}

                                    </FlexBox>
                                </td>
                            </tr>
                        </JustTable>
                    )}

                </ProjectEditPageGridList>
            </ProjectEditPageGridRow>
        )
    }, [coverLink?.newTab, coverLink?.path, hasTeamBG, is1024, isMobile, isS, onTeamCoverLinkChange, onTeamLinkTabToggle, t])

    const coverTitleBlock = useMemo(() => {

        return (
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'}>
                <ProjectEditPageGridRow isTeamEdit style={{ width: '100%' }}>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        orientation="wide"
                        label={t('teams.adminPage.fields.cover_title')}
                        placeholder={''}
                        useLangSwitcher
                        //@ts-ignore
                        value={coverTitle}
                        onChange={(ev: any, lang?: string) => {
                            textAllowed(ev, (val) => setCoverTitle(
                                //@ts-ignore
                                setTextByLang(coverTitle, lang, val)
                            ))
                        }}
                    />
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [coverTitle, isS, t])

    const officeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} align="flex-start" center={!!teamTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.office')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamTags(tagsRaw);
                            },
                            ctx: ['cities'],
                            max: CITY_TAGS_COUNT,
                            isEdit: true,
                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={
                                !!teamTags?.length
                                    ? t('project_edit.change_cities')
                                    : t('project_edit.add_city')
                            }
                            reverse
                        />
                    </AddButton>

                    {!!teamTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        key={value.tagId}
                                        educational={value?.isEducationTag}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamTags])

    const phoneBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.phone')}
                    orientation="wide"
                    type={INPUT_TYPES.phone}
                    value={teamPhone}
                    onChange={(formattedValue: any) => {
                        setTeamPhone(formattedValue as string)
                    }}
                /> 
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamPhone])

    const emailBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.email')}
                    orientation="wide"
                    value={teamEmail}
                    onChange={(ev: any) => setTeamEmail(ev.target.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamEmail])

    const typeUnitBlock = useMemo(() => {

        if (isModer) {
            return (
                <ProjectEditPageGridRow isTeamEdit style={{marginTop: isS ? 24 : 40}} center={false} align={'flex-start'} alignMobile="flex-start">
                    <TeamContextInputWrapper 
                        direction={'row'} 
                        directionMobile="row" 
                        style={{ flexWrap: 'wrap' }}
                    >
                        <FlexBox direction="row" directionMobile="row" width={'100%'} align="center" alignMobile="center">
                            <CommonInput 
                                type={INPUT_TYPES.text}
                                value={contextString}
                                onChange={(ev: any) => setContextsString(ev.target.value)}
                                orientation="wide"
                                label={t('teams.adminPage.fields.type')}
                                resultComponent={<>
                                    {!!teamContextsTypes?.length && (
                                        <FlexBox direction='row' wrap={'wrap'} width={'100%'} offsetTop={24} offsetTopMobile={16} >
                                            {/*@ts-ignore*/}
                                            {teamContextsTypes?.map((item) =>
                                                <Item
                                                    
                                                    text={item?.value}
                                                    onClick={() => {
                                                        //@ts-ignore
                                                        setTeamContexts(
                                                        //@ts-ignore
                                                        teamContextsTypes?.map(({ value }) => value)?.filter((i: any) => {
                                                            return i !== item?.value
                                                        })
                                                        )
                                                    }}
                                                />
                                            )}
                                    </FlexBox>
                                )}
                            </>}
                            />
                            {!!contextString?.length && (
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                //@ts-ignore
                                setTeamContexts(
                                    //@ts-ignore
                                    [...(teamContextsTypes ? Object.values(teamContextsTypes)?.map(({ value }) => value) : []), contextString]
                                );
                                setContextsString('');
                            }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                            )}
                        </FlexBox>
                    </TeamContextInputWrapper>
                </ProjectEditPageGridRow>
            )
        }

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <TeamEditLabel isTeamEdit>
                    {t('teams.adminPage.fields.type')}
                </TeamEditLabel>
                <ProjectEditPageGridInput direction="column" directionMobile="column" isTeamEdit>
                    <Input.Dropdown
                        isMulti
                        value={teamContextsTypes}
                        onChange={(ev: any) => setTeamContexts(ev?.map((ctx: any) => ctx.value))}
                        options={TEAM_TYPES}
                        placeholder={t('teams.adminPage.fields.select_placeholder')}
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamContextsTypes, contextString])

    const handlePathBlur = useCallback(() => {
        if (!teamRoute) return;

        let newRoute = teamRoute.trim();

        if (/^https?:\/\//.test(newRoute)) {
            setTeamRoute(newRoute);
            return;
        }

        const currentBaseUrl = !isModer ? `https://${window.location.host}/teams/` : `https://`;

        if (!newRoute.startsWith(currentBaseUrl)) {
            const cleanPath = newRoute.replace(/^https?:\/\//, '').replace(/^\//, '');
            newRoute = currentBaseUrl + cleanPath;
        }

        setTeamRoute(newRoute);
    }, [teamRoute, setTeamRoute, isModer]);

    const pathBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    maxLength={1000}
                    label={t('teams.adminPage.fields.path')}
                    orientation="wide"
                    placeholder={t('teams.adminPage.placeholders.route')}
                    value={teamRoute}
                    onChange={(ev: any) => allowedCharactersWithNumbers(ev, setTeamRoute, toasts, t('teams.adminPage.errors.url_too_long'))}
                    onBlur={handlePathBlur}
                />
            </ProjectEditPageGridRow>
        )
    }, [handlePathBlur, isS, t, teamRoute, toasts])

    const privateBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.private')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamSwitchButtonVisible}
                        label={isS ? '' : t('teams.adminPage.additionalFields.private_msg')}
                        onClick={() => setTeamSwitchButtonVisible(!teamSwitchButtonVisible)}
                        component={isS ? '' : <InfoIcon msg={t('teams.adminPage.additionalFields.private_info')} stc />}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, t, teamSwitchButtonVisible])

    const disabledBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.longread_disabled')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsLongreadDisabled}
                        label={''}
                        onClick={() => setTeamIsLongreadDisabled(!teamIsLongreadDisabled)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, t, teamIsLongreadDisabled])


    const anchorLimitBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.anchor_limit')}
                    value={{ label: teamAnchorLimit, value: teamAnchorLimit }}
                    onChange={(ev: any) => setTeamAnchorLimit(ev.value)}
                    options={anchorLimitTypes as any}
                    orientation="wide"
                />
            </ProjectEditPageGridRow>
        )
    }, [anchorLimitTypes, hasLongread, isS, t, teamAnchorLimit])

    const teamContextBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.team_context')}
                    orientation="wide"
                    infoText={t('teams.adminPage.additionalFields.team_context_msg')}
                    value={teamContextName}
                    onChange={(value: any) => {
                        if (value.target.value.length > 300) {
                            toasts.error(t('teams.adminPage.errors.teamContextName_too_long'))
                            return
                        }
                        setTeamContextName(value.target.value)
                    }}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamContextName, toasts])

    const showWorksBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.show_works')}
                    orientation="wide"
                    options={TeamProjectsFilter_List}
                    value={teamProjectsFilter}
                    onChange={(item: any) => setTeamProjectsFilter(item?.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerationType.value, teamProjectsFilter, TeamProjectsFilter_List])

    const moderRoleBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.moder_role')}
                    orientation="wide"
                    value={teamModerRole}
                    onChange={(value: any) => setTeamModerRole(value.target.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerRole])

    const tagAppoitmentBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} align="flex-start" center={!teamOwnerTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <TeamEditLabel isTeamEdit style={{ whiteSpace: 'normal' }} align={'start'} alignMobile={'start'} offsetBottomMobile={!!teamOwnerTags?.length ? 0 : 16} className={'required-label'}>
                    {t('teams.adminPage.fields.tag_appoitment')}
                </TeamEditLabel>
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamOwnerTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamOwnerTags(tagsRaw);
                            },
                            isEdit: true,
                            global: true,
                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                        />
                    </AddButton>

                    {!!teamOwnerTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamOwnerTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamOwnerTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamOwnerTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        educational={value?.isEducationTag}
                                        key={value.tagId}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamOwnerTags])

    const tagForAddTeamBlock = useMemo(() => {
        const disabled = !isModer && teamModerationType.value === 1
        const handleClick = () => {
            if (disabled) return;
            modal.show('tags', {
                value: [...teamManagedTags],
                onChange: (tagsRaw: Tag[]) => {
                    setTeamManagedTags(tagsRaw);
                },
                isEdit: true,
                global: true,
            });
        };

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} center={!teamManagedTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.tag_for_add_team')} 
                    fixedHeight
                    onWhiteBG 
                    infoText={t('teams.adminPage.additionalFields.tag_msg')}
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={handleClick}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit

                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                            disable={disabled}
                        />
                    </AddButton>

                    {!!teamManagedTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamManagedTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamManagedTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamManagedTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        key={value.tagId}
                                        educational={value?.isEducationTag}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamManagedTags, teamModerationType, isModer])
    
    const competencesBlock = useMemo(() => {
        return (
            <FlexBox 
              offsetTop={24} 
              direction="column" 
              directionMobile="column" 
              width={'100%'} 
              align="center" 
              alignMobile="center"
              className="competences-search-container"
            >
              <FlexBox width={'100%'} gx={16}>
                <FlexBox direction="column" width="100%">
                  <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.competences')}
                    value={competenceString}
                    orientation="wide"
                    placeholder={'Начните вводить название компетенции для поиска...'}
                    onChange={(ev: any) => {
                      setCompetenceString(ev.target.value);
                      if (competenceSearchError) {
                        setCompetenceSearchError(null);
                      }
                      if (allCompetenceResults.length > 0) {
                        setAllCompetenceResults([]);
                        setShowAllResults(false);
                      }
                    }}
                  />
                  {isSearchingCompetences && (
                    <span style={{ 
                      fontSize: '12px', 
                      color: '#666', 
                      marginTop: '4px',
                      fontStyle: 'italic'
                    }}>
                    Поиск...
                    </span>
                  )}
                </FlexBox>
              </FlexBox>
              
              {!!competenceSearchResults?.length && (
                <FlexBox width={'100%'} offsetTop={16} direction="column">
                  <FlexBox width={'100%'} align="center" gy={8}>
                    {allCompetenceResults.length > 10 && (
                        <DefaultButton 
                            wh={120} 
                            whMob={120}
                            onClick={() => setShowAllResults(!showAllResults)}
                        >
                            {showAllResults ? 'Скрыть' : 'Показать все'}
                        </DefaultButton>
                    )}
                  </FlexBox>
                  <FlexBox width={'100%'} offsetTop={8} direction="column" gy={8}>
                    {(showAllResults ? allCompetenceResults : competenceSearchResults).map((competence, index) => (
                      <CompetenceResult 
                        key={competence.id || index} 
                        width={'100%'} 
                        gx={8} 
                        align="center"
                        onClick={() => {
                          setTeamCompetences({ ...teamCompetences, [competence.id]: competence.name });
                          setCompetenceString('');
                          setCompetenceSearchResults([]);
                          setCompetenceSearchError(null);
                          setAllCompetenceResults([]);
                          setShowAllResults(false);
                          setStatusText(t('save'));
                          toasts.info(t('teams.admin.msg.save'));
                          setIsChangesSaved(true);
                        }}
                      >
                        <span style={{ flex: 1, fontSize: '14px' }}>{competence.name}</span>
                        <span style={{ fontSize: '12px', color: '#666' }}>+</span>
                      </CompetenceResult>
                    ))}
                  </FlexBox>
                </FlexBox>
              )}
              
              {competenceSearchError && (
                <FlexBox width={'100%'} offsetTop={16} align="center">
                  <span style={{ fontSize: '14px', color: '#d32f2f' }}>
                    {competenceSearchError}
                  </span>
                </FlexBox>
              )}
              
              {!!Object.keys(teamCompetences).length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <FlexBox wrap="wrap" style={{gap: '10px'}}>
                    {Object.entries(teamCompetences).map(([id, name], index) =>
                      <CompetenceItem
                        key={id}
                        onClick={() => {
                          const newCompetences = { ...teamCompetences };
                          delete newCompetences[id];
                          setTeamCompetences(newCompetences);
                          setStatusText(t('save'));
                          toasts.info(t('teams.admin.msg.save'));
                          setIsChangesSaved(true);
                        }}><FlexBox justify="space-between" gx={12}>
                            <span>{name}</span>
                            <span style={{ fontSize: '12px', color: '#909090' }}>x</span>
                        </FlexBox></CompetenceItem>
                    )}
                  </FlexBox>
                </FlexBox>
              )}
            </FlexBox>
        )
    }, [isS, t, teamCompetences, competenceString, competenceSearchResults, isSearchingCompetences, competenceSearchError, allCompetenceResults, showAllResults])
    
    const addCompetenceYearBlock = (ev: any) => {
        const inputValue = ev.target.value;
        if (inputValue === '' || /^\d+$/.test(inputValue)) {
          setTeamCompetenceYear(inputValue);
          if ( inputValue.trim() <= new Date().getFullYear() && inputValue.trim() > 2000) {
            setStatusText(t('save'));
            toasts.info(t('teams.admin.msg.save'));
            setIsChangesSaved(true);
            }
        }
    }
    const competenceYearBlock = useMemo(() => {
        return (
             <FlexBox offsetTop={24} direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
              <FlexBox width={'100%'} gx={24} gxMobile={16}>
                <CommonInput
                  type={INPUT_TYPES.text}
                  label={t('teams.adminPage.fields.competenceYear')}
                  value={teamCompetenceYear}
                  orientation="wide"
                  onChange={addCompetenceYearBlock}
                    onKeyPress={(ev: React.KeyboardEvent<HTMLInputElement>) => {
                        if (!/^\d$/.test(ev.key)) {
                            ev.preventDefault();
                        }
                    }}
                />
              </FlexBox>
            </FlexBox>
        )
    }, [isS, t, teamCompetenceYear])

    const [isImportLoading, setIsImportLoading] = useState(false);
    const [importGroups, setImportGroups] = useState<string[]>([]);


    const handleCheckImportTTData = useCallback(async () => {
        if (!team?.teamId) {
            return;
        }

        setIsImportLoading(true);
        try {
            const response = await API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/CheckImportTTData')
                .get()
                .addQuery('teamId', team.teamId)
                .send();

            const data = await response.json();
            
            if (data && Array.isArray(data)) {
                setImportGroups(data);
                onModalStateChange(true, { mode: 'import-groups', index: 0, item: { groups: data } });
            } else if (data?.status === 200 || data?.success) {
                toasts.info(t('teams.adminPage.import.success'));
            } else {
                toasts.error(t('teams.adminPage.import.error') || 'Ошибка при проверке импорта');
            }
        } catch (error) {
            console.error('Error checking import TT data:', error);
            toasts.error(t('teams.adminPage.import.error') || 'Ошибка при проверке импорта');
        } finally {
            setIsImportLoading(false);
        }
    }, [team?.teamId, toasts, t]);

    const importBlock = useMemo(() => {
        return (
             <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit align="flex-start">
                  <CommonLabel 
                    label={t('teams.adminPage.import.title')} 
                    fixedHeight
                    onWhiteBG 
                />
                    <ProjectEditPageGridInput>
                        <DefaultButton wh={195} whMob={195} onClick={handleCheckImportTTData} disabled={isImportLoading}>
                            {isImportLoading ? (t('teams.adminPage.import.loading') || 'Загрузка...') : (t('teams.adminPage.import.startButton') || 'Начать импорт')}
                        </DefaultButton>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
        )
    }, [isS, t, teamCompetenceYear, teamModerationType?.value])
    const tagEducationTagBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} align="flex-start" center={!teamEducationTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.tag_education_tab')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamEducationTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamEducationTags(tagsRaw);
                            },
                            isEdit: true,
                            global: true,
                            maxEducationalTags: 1,
                            max: 1,
                            educational: true,
                            requiredTags: false,
                            projectTags: false,
                            maxProjectTags: 0,
                            maxPlacesTags: 0,

                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                        />
                    </AddButton>

                    {!!teamEducationTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamEducationTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamEducationTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamEducationTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        educational={value?.isEducationTag}
                                        key={value.tagId}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamEducationTags])


    const courseEndBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.course_completion')}
                    fixedHeight
                    onWhiteBG
                />

                <DefaultButton wh={195} whMob={160} hasLongread disabled={isCourseCompleted} onClick={onToggleCourseCompletionModal}>
                    {t('teams.adminPage.buttons.complete_course')}
                </DefaultButton>
                
            </ProjectEditPageGridRow>
        )
    }, [courseStartDate, i18n.language, isMobile, isS, t, isCourseCompleted])

    const canCreateProjectBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.can_create_project')}
                    fixedHeight
                    onWhiteBG
                    infoText={t('teams.adminPage.additionalFields.can_create_project_msg')}
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamModerationType.value === ModerationType.LMS ? false : teamIsCanCreateProject}
                        label={''}
                        onClick={() => setTeamIsCanCreateProject(!teamIsCanCreateProject)}
                        isTeamEdit
                        disabled={teamModerationType.value === ModerationType.LMS}
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsCanCreateProject, teamModerationType.value])

    const employeesFilterBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.employees_filter')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsShowTeachersCheckbox}
                        label={is800 ? '' : t('teams.adminPage.additionalFields.employees_filter_info')}
                        onClick={() => setTeamIsShowTeachersCheckbox(!teamIsShowTeachersCheckbox)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [is800, isS, t, teamIsShowTeachersCheckbox])

    const tabEntityBlock = useMemo(() => {
        const entityListWithTooltips = entityList.map(item => {
            let tooltipText = '';
            switch (item.value) {
                case 'projects':
                    tooltipText = 'список проектов';
                    break;
                case 'organizations':
                    tooltipText = 'список организаций на странице';
                    break;
                case 'modules':
                    tooltipText = 'учебные модули для образовательных курсов';
                    break;
                default:
                    tooltipText = '';
            }

            return {
                ...item,
                label: (
                    <HintTooltip
                        positionY="default"
                        text={tooltipText}
                        z={6}
                        onWhiteBg
                    >
                        <span>{item.label}</span>
                    </HintTooltip>
                )
            };
        });
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.tab_entity')}
                    required
                    onWhiteBG
                    infoText={t('teams.adminPage.additionalFields.entity_msg')}
                    options={entityListWithTooltips as any}
                    value={entityList.find(({ value }) => value === teamEntityType)}
                    onChange={(item: any) => setTeamEntityType(item?.value)}
                    placeholder={t('teams.adminPage.fields.select_placeholder')}
                    orientation={'wide'}
                />
            </ProjectEditPageGridRow>
        )
    }, [entityList, isS, t, teamEntityType, isModer])

    const handleFilterTypeChange = (type: ShowCaseFilterType) => {
        setShowCaseFilterType(type);
    };

    const filterTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: 24}} isTeamEdit switchValue={showCaseFilterType} >
                <CommonLabel 
                    label={'Структура страницы'}
                    infoText={t('teams.adminPage.additionalFields.structure_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                <span className={'input-span'}> Витрина организации</span>
                                <Switch className={'showcase-switcher'} value={showCaseFilterType} onChange={handleFilterTypeChange} />
                                <span className={'input-span'}> Разделы страницы</span>
                            </FlexBox>
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, handleFilterTypeChange, showCaseFilterType, t])




    const canSortingProject = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.sorting')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={sortingHidden}
                        label={''}
                        onClick={() => setSortingHidden(!sortingHidden)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, sortingHidden])

    const courseTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.course_type')}
                    orientation="wide"
                    type={INPUT_TYPES.dropdown}
                    value={courseCurrentOption as any}
                    onChange={(ev: any) => {
                        setCourseType(ev?.value)
                    }}
                    options={COURSE_OPTIONS as any}

                />
            </ProjectEditPageGridRow>
        )
    }, [courseCurrentOption, isS, t])

    const courseLevelBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.course_level')}
                    value={lmsCourseCurrentOption as any}
                    onChange={(ev: any) => {
                        setLmsCourseType(ev?.value)
                    }}
                    options={LMS_COURSE_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsCourseCurrentOption, t])

    const handleDateChange = (value: Date) => {
        setCourseStartDate(value);
    };

    const onAdditionalContentChange = (data: any) => {
        setAdditionalContent(data)
    }

    const handleBlur = useCallback(() => {
        if (courseStartDate === undefined) {
            setCourseStartDate(fixTimezoneOffsetToShow(new Date(team?.lmsModuleStartDate || Date.now())));
        }
    }, [courseStartDate]);

    const courseStartBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.course_start')}
                    fixedHeight
                    onWhiteBG
                />
                <DatePickerTeamWrapper>
                    <CustomDateTimePicker
                        value={courseStartDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon /> : <Date32Icon />}
                        clearIcon={null}
                        format="dd-MM-yyyy"
                        maxDate={addYears(new Date(), 5)}
                        locale={i18n.language}
                        onChange={handleDateChange}
                        onCalendarClose={handleBlur}
                    />
                </DatePickerTeamWrapper>
            </ProjectEditPageGridRow>
        )
    }, [courseStartDate, handleBlur, i18n.language, isMobile, isS, t])

    const coursePriceBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.course_price')}
                    orientation="wide"
                    type={INPUT_TYPES.text}
                    maxLength={9}
                    placeholder={'0'}
                    value={coursePrice || ''}
                    onChange={(ev: any) => onChangeCoursePrice(ev?.target?.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [coursePrice, isS, onChangeCoursePrice, t])

    const courseDurationBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.course_duration')}
                    infoText={t('teams.adminPage.additionalFields.lms_duration_msg')}
                    value={lmsDurationOption as any}
                    onChange={(ev: any) => {
                        setLmsCourseTerm(ev?.value)
                    }}
                    options={LMS_DURATION_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsDurationOption, t])

    const courseCardCover = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.card_format')}
                    infoText={t('teams.adminPage.additionalFields.lms_cardType_msg')}
                    value={lmsCardTypeOption as any}
                    onChange={(ev: any) => {
                        setLmsCardFormat(ev?.value)
                    }}
                    options={LMS_CARDFORMAT_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsCardTypeOption, t])



    const ownersAndParticipantsBlock = useMemo(() => {

        return (
            <ProjectAuthorsWrapper isTeamEdit direction={"column"} directionMobile={"column"} style={{ marginTop: isS ? 24 : 40 }} className={'author-wrapper mobile-block-2'}>

                <ProjectAuthorsEdit
                    label={t('teams.adminPage.fields.authors')}
                    value={teamAuthors}
                    onChange={onTeamAuthorsChange}
                    placeholder={t('search_by_name')}
                    isTeamEdit
                    isAdminPage
                    orientation="wide"
                    errorMsg={t('teams.adminPage.errors.equal_owners')}
                    teamModerationType={teamModerationType.value}
                />
                <FlexBox style={{ marginTop: 24, justifyContent: 'space-between' }} align="flex-start" alignMobile="flex-start">
                    <ProjectAuthorsEdit
                        label={t('teams.adminPage.fields.owners')}
                        value={teamOwners}
                        required
                        onChange={onTeamOwnersChange}
                        placeholder={t('search_by_name')}
                        isTeamEdit
                        isAdminPage
                        orientation="wide"
                        errorMsg={t('teams.adminPage.errors.equal_owners')}
                        teamModerationType={teamModerationType.value}
                    />
                </FlexBox>
                <FlexBox style={{ marginTop: 24, justifyContent: 'space-between' }} align="flex-start" alignMobile="flex-start">
                    <ProjectAuthorsEdit
                        label={t('teams.adminPage.fields.members')}
                        value={teamMembers}
                        isTeamMembers
                        orientation="wide"
                        onChange={onTeamMembersChange}
                        placeholder={t('search_by_name')}
                        isTeamEdit
                        isAdminPage
                        errorMsg={t('teams.adminPage.errors.equal_participants')}
                        teamModerationType={teamModerationType.value}
                    // showList
                    />
                </FlexBox>
            </ProjectAuthorsWrapper>
        )
    }, [isS, t, teamMembers, teamModerationType.value, teamAuthors, teamOwners])

    const linkParticipantsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.link_for_participants')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsShowEmployeesLink}
                        label={isS ? '' : t('teams.adminPage.additionalFields.link_for_participants_info')}
                        onClick={() => setTeamIsShowEmployeesLink(!teamIsShowEmployeesLink)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsShowEmployeesLink])

    const channelsParams = useMemo(() => {
        return {
            lmsGroupChannelsIds: team?.additionalInfo?.lmsGroupChannelsIds,
            courseChannelId: team?.additionalInfo?.courseChannelId,
            getChannelid: (id: string) => {
                const groupList = team?.additionalInfo?.lmsGroupChannelsIds ?
                    JSON.parse(team?.additionalInfo?.lmsGroupChannelsIds || '{}') : {}
                return groupList[id]
            },
        }
    }, [team])

    const getAutoChannelButton = useCallback((id: string) => {
        if (channelType !== ModerationType.LMS) return null;
        return <AutoChannelButton
            type={ENTITY_COURSES_TYPE.group}
            entityId={id} 
            channelId={channelsParams?.getChannelid(id)}
            onUpdate={() => setDate(Date.now())}
        />
    } , [channelsParams, channelType, date, status])

    const groupsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.groups')}
                    fixedHeight
                    onWhiteBG
                />
                {!!teamOwners?.length ? (
                    <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
                        <ProjectEditPageGridInput isTeamEdit direction={!!computedGroups?.length ? 'column' : 'row'}
                            // @ts-ignore
                            style={{ flexDirection: isMobile ? 'column' : '' }}>
                            {!!computedGroups?.length && (
                                <JustTable isTeamEdit style={{ userSelect: 'none' }}>
                                    <thead style={{ userSelect: 'none' }}>
                                        <tr>
                                            <th style={{ width: '45%', paddingTop: 0, userSelect: 'none' }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                                            <th style={{ width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0, userSelect: 'none' }}></th>
                                            {!isS && (
                                                <th style={{ width: isS ? 0 : '30%', paddingTop: 0, userSelect: 'none' }}></th>
                                            )}
                                        </tr>
                                    </thead>
                                    <DraggableTable 
                                        computedGroups={computedGroups}
                                        onGroupDragEnd={onGroupDragEnd}
                                        getAutoChannelButton={getAutoChannelButton}
                                        onModalStateChange={onModalStateChange}
                                        setCurrentGroup={setCurrentGroup}
                                        groups={groups}
                                    />
                                </JustTable>
                            )}
                            <FlexBox style={{ marginTop: !groups?.length ? 0 : isSmallMob ? 10 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => {
                                    createGroup();

                                    onModalStateChange(true, { mode: "group", index: -1 });
                                }}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridInput>
                    </FlexBox>
                ) : (
                    <span style={{ paddingTop: 8 }}>{t('teams.adminPage.additionalFields.add_owner_info')}</span>
                )}

            </ProjectEditPageGridRow>
        )
    }, [computedGroups, createGroup, groups, date, i18n.language, isMobile, isS, isSmallMob, onGroupDragEnd, t, teamOwners?.length, setCurrentGroup])

    const feedbackFormsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.forms')}
                    infoText={t('teams.adminPage.additionalFields.form_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction="column" directionMobile="column" justify={ !forms?.length ? 'center' : 'normal'}>
                    <ProjectEditPageGridInput  isTeamEdit direction={!!forms?.length ? 'column' : 'row'} directionMobile="column">
                        {!!forms?.length && (
                            <JustTable isTeamEdit>
                                <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
                                    {actualForms?.map((form, index: number) => {
                                        //@ts-ignore
                                        const name = Lang(form.techName, i18n.language) || form.formId;
                                        return (
                                            <tr>
                                                <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                        <CommonInput 
                                                            type={INPUT_TYPES.text}
                                                            value={name}
                                                            disable={true}
                                                            onChange={() => null}
                                                        />
                                                    </TableSortWrapper>
                                                </td>
                                                <td style={{ width: isS ? '56px' : '336px' }}>
                                                    <FlexBox align={'center'} alignMobile="center" direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                        {isS ? (
                                                            <EditIcon24 onClick={() => {
                                                                onModalStateChange(true, { mode: "forms", index: index })
                                                                //@ts-ignore
                                                                setCurrentForm(forms?.filter((i) => i?.formId === form?.formId)[0])
                                                            }} />
                                                        ) : (
                                                            <DefaultButton wh={181} whMob={157} onClick={() => {
                                                                onModalStateChange(true, { mode: "forms", index: index });
                                                                //@ts-ignore
                                                                setCurrentForm(forms?.filter((i) => i?.formId === form?.formId)[0])
                                                            }}>
                                                                {t('teams.adminPage.buttons.edit')}
                                                            </DefaultButton>
                                                        )}
                                                        {isS ? (
                                                            <FlexBox offsetLeftMobile={8}>
                                                                <BasketIcon fill={'#838382'} onClick={() => onFormDelete(form?.formId)} />
                                                            </FlexBox>
                                                        ) : (
                                                            <DefaultButton wh={131} whMob={107} onClick={() => onFormDelete(form?.formId)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                        )}

                                                    </FlexBox>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </SortableList>
                            </JustTable>
                        )}
                        <FlexBox style={{ marginTop: !forms?.length ? 0 : 14 }}>
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                createNewForm();
                            }}>
                                <PlusSvg />
                                {t('teams.adminPage.buttons.add')}
                            </DefaultButton>
                        </FlexBox>
                    </ProjectEditPageGridInput>
                </FlexBox>


            </ProjectEditPageGridRow>
        )
    }, [actualForms, createNewForm, forms, i18n.language, isMobile, isS, onFormDelete, onTeamTabSortEnd, t])

    const showQuBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.show_qu')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamShowQu}
                        label={''}
                        onClick={() => setTeamShowQu(!teamShowQu)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamShowQu])

    const goodsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: !(teamModerationType?.value === 2 && (isModer || hasAccessToTeamsAdmin)) ? 0 : isS ? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.goods')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit>
                    <FlexBox gx={isMobile ? 0 : 26} directionMobile={"column"} gy={isMobile ? 16 : 0} align="center">
                        {!collection && !isCollectionLoading && !isCatalogsLoading && <DefaultButton wh={214} whMob={107} onClick={() => {
                            if (isCreateColButtonDisabled) return;
                            setIsCreateColButtonDisabled(true)
                            API.request()
                                .endpoint(Endpoints.cardsMnePw)
                                .url('/api/Collection/Add')
                                .post()
                                .body({
                                    referenceCollectionId: catalogs?.length > 0 ? catalogs[0]?.cardCollectionId : "",
                                    cardCollectionId: team?.teamId,
                                    artistId: teamOwners?.length > 0 ? teamOwners[0]?.accountId : "",
                                    name: teamName,
                                })
                                .send()
                                .then((r) => r.json())
                                .then((r) => {
                                    setColT(Date.now());
                                    setIsCreateColButtonDisabled(false);
                                })
                                .catch((e) => console.error(e))
                        }}>
                            {t('teams.adminPage.buttons.create_collection')}
                        </DefaultButton>}
                        {collection && !isCollectionLoading && <DefaultButton wh={131} whMob={107} onClick={() => {
                            API.request()
                                .endpoint(Endpoints.cardsMnePw)
                                .url('/api/Card/AddCard')
                                .post()
                                .body({
                                    typeCard: "product",
                                    museumId: team?.teamId,
                                    userId: teamOwners?.length > 0 ? teamOwners[0]?.accountId : "",
                                })
                                .send()
                                .then((r) => r.json())
                                .then((r) => {
                                    setTimeout(() => {
                                        window.open(process.env.REACT_APP_URL_GALLERY + '/card/' + r + '?shouldForcedLogin=true&saveLoginUrl=true', '_blank')
                                    })
                                })
                                .catch((e) => console.error(e))
                        }}>
                            {t('teams.adminPage.buttons.create')}
                        </DefaultButton>}
                        <DefaultButton wh={159} whMob={107} onClick={() => {
                            history.push(`/teams/${team?.teamId}/shop`)
                        }}>
                            {t('teams.adminPage.buttons.view')}
                        </DefaultButton>
                        {//кнопка к товарам, раскомментить, когда появится айдишник магазина
                        /* <DefaultButton wh={369} whMob={369} onClick={() => {
                            history.push(`/teams/${team?.teamId}/shop`)
                        }}>
                            {t('teams.adminPage.buttons.go_to_shop')}
                        </DefaultButton> */}
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [catalogs, collection, hasAccessToTeamsAdmin, history, isCatalogsLoading, isCollectionLoading, isCreateColButtonDisabled, isMobile, isModer, isS, t, teamModerationType, team?.moderationType, team?.teamId, teamName, teamOwners])

    const showShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.show_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamIsShopVisible}
                        label={''}
                        onClick={() => setTeamIsShopVisible(!teamIsShopVisible)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsShopVisible])

    const mainFilterBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.main_filter')}
                    infoText={t('teams.adminPage.additionalFields.main_filter_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput  isTeamEdit>
                    <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} align="center" alignMobile="center">
                        <DefaultButton wh={195} whMob={195} onClick={() => onModalStateChange(true, { mode: "mainFilter", index: -1 })}>
                            {t('teams.adminPage.buttons.edit')}
                        </DefaultButton>
                        <span className="text">{t('teams.adminPage.additionalFields.main_filter_info')}</span>
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t])

    useEffect(() => {
        const match = longreadEntityLink.match(/\/project\/(([a-z0-9]+\-)*([a-z0-9]+))/);
        if (match) {
            setProjectId(match[1]);
        } else {
            setProjectId(longreadEntityLink);
        }
    }, [longreadEntityLink]);

    useEffect(() => {
        if (projectSource) {
            setReplaceLongreadId(projectSource?.longreadId)
        }
    }, [projectSource]);

    useEffect(() => {
        const longreadSign = (
            REPLACE_LONGREAD_REG.test(longreadEntityLink) &&
            teamLongreadType === TeamLongreadType.ReplaceLongread)
            || longread?.length > 0
            ;

        setHasLongread(longreadSign)
    }, [longreadEntityLink, longread, teamLongreadType])

    const titleTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseTitleType} >
            <CommonLabel 
                label={t('teams.adminPage.additionalFields.header_show')}
                fixedHeight
                onWhiteBG
            />
                <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_text')}</span>
                                <Switch className={'showcase-switcher'} value={showCaseTitleType} onChange={onTitleVisibleChange} />
                                <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_link')}</span>
                            </FlexBox>
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, onTitleVisibleChange, showCaseTitleType, t])

    const feedOrMediaBlock = useMemo(() => {

        if (channelType !== ModerationType.Channel) return null;

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40, placeItems: 'baseline'}} isTeamEdit switchValue={feedViewType} >
            <CommonLabel 
                label={t('teams.adminPage.fields.default_page')}
                fixedHeight
                onWhiteBG
            />
            <FlexBox direction="column">
                <FlexBox direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                    <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                        <span className={'input-span'}> {t('teams.adminPage.additionalFields.media')}</span>
                        <Switch className={'showcase-switcher'} value={feedViewType} onChange={onFeedViewTypeChange} />
                        <span className={'input-span'}> {t('teams.adminPage.additionalFields.feed')}</span>
                    </FlexBox>
                </FlexBox>
            </FlexBox>
            </ProjectEditPageGridRow>
        )
    } , [feedViewType, t, i18n.language, channelType])

    const longreadBlock = useMemo(() => {

        return (
                <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseViewType} >
                    <CommonLabel 
                        label={t('teams.adminPage.fields.longread')}
                        fixedHeight
                        onWhiteBG
                    />
                    <FlexBox direction="column">
                        <FlexBox ref={switchRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                 <HintTooltip positionY="top" text={'Сетка – страница в виде "плитки" проектов'} z={6} onWhiteBg={true}>
                                    <span className={'input-span'}> {t('teams.adminPage.additionalFields.grid')}</span>
                                 </HintTooltip>
                                <Switch className={'showcase-switcher'} value={showCaseViewType} onChange={onLandingVisibleChange} />
                                <HintTooltip positionY="top" text={'Лендинг – страница в виде лонгрида'} z={6} onWhiteBg={true}>
                                    <span className={'input-span'}> {t('teams.adminPage.additionalFields.landing')}</span>
                                </HintTooltip>
                            </FlexBox>
                        </FlexBox>
                        {/* {showCaseViewType ? */}
                        <FlexBox direction="column" style={{maxWidth: '600px'}}>
                            <div style={{marginTop: '8px', color: '#909090'}}>{t('teams.adminPage.fields.link_description')}</div>
                            <FlexBox align="center">
                                <FlexBox direction={'column'} offsetTop={8} offsetRight={32}>
                                    <CheckLongreadRadioButton
                                        onChange={() => setTeamLongreadType(TeamLongreadType.ReplaceLongread)}
                                        name="longreadLink"
                                        title={t('teams.adminPage.fields.enter_link')}
                                        checked={teamLongreadType === TeamLongreadType.ReplaceLongread}
                                    />
                                    <CheckLongreadRadioButton
                                        onChange={() => setTeamLongreadType(TeamLongreadType.SelfLongread)}
                                        name="longreadLink"
                                        title={t('teams.adminPage.fields.create_link')}
                                        checked={teamLongreadType === TeamLongreadType.SelfLongread}
                                    />
                                </FlexBox>
                                {
                                    teamLongreadType === TeamLongreadType.ReplaceLongread ?
                                    <LongreadLinkWrapper>
                                        <Input.Text
                                            //@ts-ignore
                                            value={longreadEntityLink}
                                            placeholder={t('teams.adminPage.fields.placeholder_link')}
                                            onChange={(ev: any) => setLongreadEntityLink(ev.target.value)}
                                        />
                                        {isProjectLoading && (
                                            <span className={'loading-text'}>{t('teams.adminPage.fields.loading_link')}</span>
                                        )}
                                        {projectError && !isProjectLoading && (
                                            <span className={'not-allowed-text'}>{t('teams.adminPage.fields.error_link')}</span>
                                        )}
                                    </LongreadLinkWrapper>
                                    :
                                    <>
                                        {canEditSelfLG ? (
                                            <DefaultButton wh={215} hasLongread onClick={onToggleLgView}>
                                                {t('teams.adminPage.buttons.edit_lg')}
                                            </DefaultButton>
                                        ) : (
                                            <DefaultButton wh={195} whMob={160} hasLongread onClick={onToggleLgView}>
                                                {t('teams.adminPage.buttons.add_lg')}
                                            </DefaultButton>
                                        )}
                                    </>
                            }
                        </FlexBox>
                        <FlexBox offsetTop={12} direction="row" directionMobile="row" justify="flex-start" align="center">
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={isShowTeamLandingWithProjects}
                                label={''}
                                onClick={() => setIsShowTeamLandingWithProjects(!isShowTeamLandingWithProjects)}
                                isTeamEdit
                            />
                            <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_team_project_list')}</span>
                        </FlexBox>
                        {isShowTeamLandingWithProjects && !!team?.teamLandingProjectId && (
                            <FlexBox offsetTop={8}>
                                <ProjectAvailableText>{t('teams.adminPage.additionalFields.project_available_text')}</ProjectAvailableText>
                                <ProjectAvailableLink
                                    onClick={() => {
                                        window.open(CreateLinkTo.project(team?.teamLandingProjectId), '_blank');
                                    }}
                                >
                                    {t('teams.adminPage.additionalFields.project_available_link')}
                                </ProjectAvailableLink>
                            </FlexBox>
                        )}
                    </FlexBox>
                    {/* : null} */}


                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, showCaseViewType, longreadEntityLink, projectId, setLongreadEntityLink, projectSource, onLandingVisibleChange, onToggleLgView, showCaseViewType, t, isShowTeamLandingWithProjects])

    const onSetIsLinksInsteadTitle = useCallback((val: any) => {
        if (val && topLinks?.length === 0) setTopLinks([{
            name: createEmptyLangObject('', ['ru', 'en']),
            link: ''
        }])
        setIsLinksInsteadTitle(val)
    }, [topLinks])

    const onTeamNameChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamName(
            setTextByLang(
                teamName,
                lang || 'ru',
                filterMaxLength(val, 100, toasts, t)
            )
        ))
    }, [teamName])

    const onTeamAboutChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamAbout(
            setTextByLang(
                teamAbout,
                lang || 'ru',
                filterMaxLength(val, 1000, toasts, t)
            )
        ))
    }, [teamAbout])

    const onTeamAboutExtraChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamAboutExtra(
            setTextByLang(
                teamAboutExtra,
                lang || 'ru',
                filterMaxLength(val, 1500, toasts, t)
            )
        ))
    }, [teamAboutExtra])

    const teamNameBlock = useMemo(() => {
        return (
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                <ProjectEditPageGridRow style={{ width: '100%' }} isTeamEdit>
                    <ProjectEditPageGridInput style={{ width: '100%' }} isTeamEdit direction="column" directionMobile="column">
                        {!isLinksInsteadTitle && <>
                            <CommonInput
                                type={INPUT_TYPES.text}
                                placeholder={''}
                                orientation='wide'
                                label={t('teams.adminPage.fields.name')}
                                value={teamName}
                                required
                                useLangSwitcher
                                onChange={(ev: any, lang?: string) => onTeamNameChange(ev, lang)}
                            />

                            {!isChannel && <FlexBox justify="space-between" width={'100%'} direction="row">
                                <FlexBox style={{ width: 'calc(100% - 585px)' }} />
                                <FlexBox direction="column" justify="flex-start" style={{ width: '600px' }}>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isSmallName}
                                            label={''}
                                            onClick={() => setIsSmallName(!isSmallName)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.small_title_info')}</span>
                                    </FlexBox>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isMinimalName}
                                            label={''}
                                            onClick={() => setIsMinimalName(!isMinimalName)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.minimalism_title_info')}</span>
                                    </FlexBox>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center">
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isMainTitleHidden}
                                            label={''}
                                            onClick={() => setIsMainTitleHidden(!isMainTitleHidden)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.hide_title')}</span>
                                    </FlexBox>
                                </FlexBox>
                            </FlexBox>}

                        </>}
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [onSetIsLinksInsteadTitle, isLinksInsteadTitle, teamName, isChangesSaved, isSmallName, isMinimalName, isMainTitleHidden, isShowTeamLandingWithProjects, isChannel])

    const aboutBlock = useMemo(() => {

        return (
            <>
                <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                    <CommonInput
                        type={INPUT_TYPES.textarea}
                        placeholder={''}
                        orientation='wide'
                        infoText={t('teams.adminPage.additionalFields.about_msg')}
                        label={t('teams.adminPage.fields.about')}
                        value={teamAbout}
                        maxLength={1000}
                        minHeight={285}
                        onWhiteBG
                        useLangSwitcher
                        onChange={(ev: any, lang?: string) => onTeamAboutChange(ev, lang)}
                    />
                </LangBlockWrapper>
                <ProjectEditPageGridRow>
                    <FlexBox />
                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isShowFullDescription}
                            label={''}
                            onClick={() => setIsShowFullDescription(!isShowFullDescription)}
                            isTeamEdit
                        />
                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_full_description')}</span>
                    </FlexBox>
                </ProjectEditPageGridRow>
            </>
        )
    }, [teamAbout, isMobile, isS, isShowFullDescription])

    const aboutExtraBlock = useMemo(() => {

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                <CommonInput 
                    type={INPUT_TYPES.textarea}
                    useLangSwitcher
                    label={t('teams.adminPage.fields.about_extra')}
                    onChange={(ev: any, lang?: string) => onTeamAboutExtraChange(ev, lang)}
                    value={teamAboutExtra}
                    infoText={t('teams.adminPage.additionalFields.about_extra_msg')}
                    maxLength={1500}
                    placeholder={''}
                    orientation="wide"
                />
            </LangBlockWrapper>
        )
    }, [teamAboutExtra, isMobile, isS])

    // SHOP
    const shopButtonsBlock = useMemo(() => {
        const currentLang = shopNavButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
                <CommonLabel 
                    label={t('teams.adminPage.fields.navButtons_shop')}
                    useLangSwitcher
                    lang={currentLang}
                    onLanguageChange={() => onLocalLangChange(shopNavButtons, currentLang, (val) => setShopNavButtons(val))}
                />
                <ProjectEditPageGridRow directionMobile={!!shopNavButtons?.length ? "column" : 'row'} isTeamEdit>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        {!shopNavButtons?.length && (
                            <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !shopNavButtons?.length ? 0 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => onShopNavButtonAdd()}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                        {(!!shopNavButtons?.length) && (
                            <>
                                {isMobile ? (
                                    <>
                                        {shopNavButtons.map((button, index) => {
                                            return (
                                                <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                                    {isS && (
                                                        <GridMobileNamed>
                                                            <span>{`Кнопка ${index + 1}`}</span>
                                                            {!getLGbool(button) && (
                                                                <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)} isTablet>Удалить</DefaultButton>
                                                            )}
                                                        </GridMobileNamed>
                                                    )}
                                                    <TeamsMobGridList cols={repeat(2, '306.5px')}>
                                                        <FlexBox directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                orientation="column"
                                                                value={{ label: button.type, value: button.type }}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                options={shopButtonTypes}
                                                                label={t('teams.adminPage.additionalFields.td_style')}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                orientation="column"
                                                                label={t('teams.adminPage.additionalFields.td_text')}
                                                                value={Lang(button.text, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                                orientation="column"
                                                                value={Lang(button.textMobile, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column" style={{ marginBottom: 8}}>
                                                            <CommonLabel 
                                                                label={t('teams.adminPage.additionalFields.td_href')}
                                                                fixedHeight
                                                                onWhiteBG
                                                                
                                                            />
                                                                {button.type?.includes('anchor') ? (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.dropdown}
                                                                        value={{ label: button.type, value: button.type }}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                        options={shopButtonTypes}
                                                                    />
                                                                ) : (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.href, currentLang)}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, href: setTextByLang(button.href, currentLang, value.target.value) }, index)}
                                                                    />
                                                                )}
                                                        </FlexBox>
                                                    </TeamsMobGridList>
                                                    {!isS && !getLGbool(button) && (
                                                        <FlexBox alignMobile="end">
                                                            <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)}>Удалить</DefaultButton>
                                                        </FlexBox>
                                                    )}
                                                </MobileButtonsWrapper>
                                            )
                                        })}
                                    </>
                                ) : (
                                    <JustTable isTeamEdit>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '20%' }}>{t('teams.adminPage.additionalFields.td_style')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_href')}</th>
                                            </tr>
                                        </thead>
                                        <TBody>
                                            {shopNavButtons.map((button, index) => {
                                                return (
                                                    <tr>
                                                        <td style={{width: '195px'}}>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                value={{ label: button.type, value: button.type }}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                options={shopButtonTypes}
                                                            />
                                                        </td>
                                                        <td style={{width: '180px'}}>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                value={Lang(button.text, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                value={Lang(button.textMobile, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                                            />
                                                        </td>
                                                        <>
                                                            <td>
                                                                {button.type?.includes('anchor') ? (
                                                                    <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                                ) : (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={!!button?.isRequired ? '' : Lang(button.href, currentLang)}
                                                                        disable={!!button?.isRequired}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, href: setTextByLang(button.href, currentLang, value.target.value)}, index)}
                                                                    />
                                                                )}
                                                            </td>

                                                            <td>
                                                                {!!button?.isRequired ? (
                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                ) : (
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                )}
                                                            </td>
                                                        </>
                                                    </tr>
                                                );
                                            })}
                                        </TBody>
                                    </JustTable>
                                )}
                            </>
                        )}
                        {!!shopNavButtons?.length && (
                            <FlexBox style={{ marginTop: !shopNavButtons?.length ? 0 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => onShopNavButtonAdd()}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [shopNavButtons, isS, is1280])

    const ShopAboutBlock = useMemo(() => {
        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    label={t('teams.adminPage.fields.shop_about')}
                    useLangSwitcher
                    orientation="wide"    
                    type={INPUT_TYPES.textarea}
                    maxLength={800}
                    value={shopAbout}
                    onChange={(value: any, lang?: any) => setShopAbout(setTextByLang(shopAbout, lang, value.target.value))}
                />
            </LangBlockWrapper>
        )
    }, [shopAbout, isS, t, isMobile])

    const OutOfStockMessageBlock = useMemo(() => {
        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    useLangSwitcher
                    label={t('teams.adminPage.fields.out_of_stock_message')}
                    value={outOfStockMessage}
                    onChange={(ev: any, lang?: string) => setOutOfStockMessage(setTextByLang(outOfStockMessage, lang ?? 'ru', filterMaxLength(ev.target.value, 100, toasts, t)))}
                />
            </LangBlockWrapper>
        )
    }, [outOfStockMessage, isS, t, toasts])

    const OutOfStockLinkBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    label={t('teams.adminPage.fields.out_of_stock_link')}
                    placeholder={t('teams.adminPage.placeholders.route')}
                    value={outOfStockLink}
                        // @ts-ignore
                    onChange={(ev: any) => allowedCharactersWithNumbers(ev, setOutOfStockLink)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, outOfStockLink])

    const IsArchiveItemsShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.is_archive_items_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isArchiveItemsShop}
                        label={''}
                        onClick={() => setIsArchiveItemsShop(!isArchiveItemsShop)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isArchiveItemsShop, isS, t])

    const HideShopWordBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.hide_shop_word')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={hideShopWord}
                        label={''}
                        onClick={() => setHideShopWord(!hideShopWord)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hideShopWord, isS, t])

    const IsHideParticipantsShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.is_hide_participants_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isHideParticipantsShop}
                        label={''}
                        onClick={() => setIsHideParticipantsShop(!isHideParticipantsShop)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isHideParticipantsShop, isS, t])

    const additionalNameBlock = useMemo(() => {
        return (
            <LangBlockWrapper gyMobile={isS ? 8 : 0} align="center" offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <ProjectEditPageGridRow isTeamEdit style={{ width: '100%' }}>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.additional_name')}
                        orientation='wide'
                        placeholder={''}
                        useLangSwitcher
                        infoText={t('teams.adminPage.additionalFields.additionalName_msg')}
                        onChange={(value: any, lang?: string) => textAllowed(value, (val) => setTeamNameExtra(
                            setTextByLang(teamNameExtra, lang || 'ru', filterMaxLength(val, 100, toasts, t))) 
                        ) }
                        value={teamNameExtra}
                        onWhiteBG
                    />
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [isS, t, teamNameExtra, toasts])

    const buttonsBlock = useMemo(() => {
        const currentLang = teamButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
                <CommonLabel 
                    label={t('teams.adminPage.fields.page_buttons')}
                    onLanguageChange={() => onLocalLangChange(teamButtons, currentLang, (val) => setTeamButtons(val))}
                    lang={currentLang}
                    useLangSwitcher={!!teamButtons?.length}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridRow directionMobile={!!teamButtons?.length ? "column" : 'row'} isTeamEdit>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        <ButtonEditGroup
                            buttons={teamButtons}
                            currentLang={currentLang}
                            buttonTypes={isModer ? buttonTypesForModer : buttonTypes}
                            onChange={onTeamButtonChange}
                            OnDelete={onTeamButtonDelete}
                            OnAdd={onTeamButtonAdd}
                            forms={actualForms}
                            hasAnchors={hasAnchors}
                            anchorTypes={anchorTypes}
                        />
                        {!!teamButtons?.length && teamButtons?.length < maxLGButtonsCount && (
                            <FlexBox style={{ marginTop: !teamButtons?.length ? 0 : 24 }}>
                                <HintTooltip positionY="default" text={'Вы можете добавить до 3-х кнопок под Описанием компании'} z={6} onWhiteBg>
                                    <DefaultButton wh={195} whMob={195} onClick={() => onTeamButtonAdd()}>
                                        <PlusSvg />
                                        {t('teams.adminPage.buttons.add')}
                                    </DefaultButton>
                                </HintTooltip>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [teamButtons, isS, is1280, anchorTypes, isModer, maxLGButtonsCount])

    const navButtonsBlock = useMemo(() => {
        const currentLang = teamNavButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
          <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
              <CommonLabel 
                label={t('teams.adminPage.fields.navButtons')} 
                lang={currentLang}
                onLanguageChange={() => {
                    onLocalLangChange(teamNavButtons, currentLang, (val) => setTeamNavButtons(val))
                }}
                useLangSwitcher={!!teamNavButtons?.length}
                infoText={t('teams.adminPage.additionalFields.navButtons_msg')}
                fixedHeight
                onWhiteBG
              />
              <ProjectEditPageGridRow directionMobile={!!teamNavButtons?.length ? "column" : 'row' } isTeamEdit>
                  <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                    <ButtonEditGroup
                      buttons={teamNavButtons}
                      currentLang={currentLang}
                      buttonTypes={isModer ? buttonTypesForModer : buttonTypes}
                      onChange={onTeamNavButtonChange}
                      OnDelete={onTeamNavButtonDelete}
                      OnAdd={onTeamNavButtonAdd}
                      forms={actualForms}
                      anchorTypes={anchorTypes}
                      createButtonText={t('teams.adminPage.buttons.add')}
                    />
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [teamNavButtons, isS, is1280, anchorTypes])

    const onSetTeamTabs = useCallback((val: any) => {
        if (val?.length > MAX_TABS_COUNT && val) {
            toasts.error(`Максимальное количество вкладок: ${MAX_TABS_COUNT}`);
            return;
        }
        if (val?.length > MAX_TABS_FOR_LARGE_TABS_VIEW || !val?.length) {
            setTeamIsLargeTabs(false)
        }
        setTeamTabs(val)
    }, [])

    const onSetTopLinks = useCallback((val: any) => {
        if (val?.length > MAX_TOP_LINKS_COUNT && val) {
            toasts.error(`Максимальное количество заглавных ссылок: ${MAX_TOP_LINKS_COUNT}`);
            return;
        }
        setTopLinks(val)
    }, [])

    const tabsBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.tab}
                isChannel={isChannel}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={teamTabs}
                setTabs={onSetTeamTabs}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
                onTabChange={(tab: ITeamTab, index: number) => onTeamTabChange(TabType.tab, tab, index)}
                hasHint
                hintMgs={t('teams.adminPage.additionalFields.tabs_msg')}
            />
        )
    }, [teamTabs, isMobile, isS, is1280, onSetTeamTabs, isChannel])

    const topLinksBlock = useMemo(() => {
        return (
            <TeamTopLinksBlock
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                topLinks={topLinks}
                setTopLinks={onSetTopLinks}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
            />
        )
    }, [topLinks, isMobile, isS, is1280, onSetTopLinks])

    const categoriesBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.category}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={teamCategories}
                setTabs={setTeamCategories}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
                hasHint
                hintMgs={t('teams.adminPage.additionalFields.categories_msg')}
            />
        )
    }, [teamCategories, isMobile, isS, is1280])

    const shopTabsBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.shop}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={shopTabs}
                setTabs={setShopTabs}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
            />
        )
    }, [shopTabs, isMobile, isS, is1280])

    const sectionsBlock = useMemo(() => {

        if (showCaseFilterType === ShowCaseFilterType.showcase) return;
        if (showCaseFilterType === ShowCaseFilterType.sections) return (
            <>
                {categoriesBlock}
            </>
        );

    }, [categoriesBlock, mainFilterBlock, showCaseFilterType, tabsBlock]);

    const aboutTab = useMemo(() => {

        if (isModer) return <>
            {moderTypeBlock}
            {teamNameBlock}
            {titleTypeBlock}
            {isLinksInsteadTitle && topLinksBlock}
            {!isLinksInsteadTitle && aboutBlock}
            {aboutExtraBlock}
            {!isLinksInsteadTitle && additionalNameBlock}
            {coverTitleBlock}
            {coverBlock}
            {hasTeamBG && coverLinkBlock}
            {officeBlock}
            {phoneBlock}
            {emailBlock}
            {navButtonsBlock}

            {typeUnitBlock}
            {pathBlock}
            {longreadBlock}
            {canEditSelfLG && privateBlock}
            {hasLongread && disabledBlock}
            {canEditSelfLG && anchorLimitBlock}
            {feedbackFormsBlock}
            {showQuBlock}
            {buttonsBlock}
        </>

        return <>
            {teamNameBlock}
            {titleTypeBlock}
            {isLinksInsteadTitle && topLinksBlock}
            {!isLinksInsteadTitle && aboutBlock}
            {aboutExtraBlock}
            {!isLinksInsteadTitle && additionalNameBlock}
            {coverTitleBlock}
            {coverBlock}
            {hasTeamBG && coverLinkBlock}
            {officeBlock}
            {phoneBlock}
            {emailBlock}

            {pathBlock}
            {longreadBlock}
            {canEditSelfLG && anchorLimitBlock}
            {feedbackFormsBlock}
            {showQuBlock}
            {buttonsBlock}
        </>
    }, [aboutBlock, topLinksBlock, additionalNameBlock, anchorLimitBlock, buttonsBlock, coverBlock, coverLinkBlock, isLinksInsteadTitle, showCaseTitleType,
        disabledBlock, hasLongread, canEditSelfLG, hasTeamBG, isModer, longreadBlock, moderTypeBlock, navButtonsBlock,
        officeBlock, pathBlock, phoneBlock, privateBlock, teamNameBlock, titleTypeBlock, typeUnitBlock, feedbackFormsBlock, showQuBlock])

    const projectsTab = useMemo(() => {

        if (isModer) return <>
            {teamContextBlock}
            {[ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(teamModerationType.value) && showWorksBlock}
            {moderRoleBlock}
            {tagForAddTeamBlock}
            {canCreateProjectBlock}
            {employeesFilterBlock}
            {tabEntityBlock}
            {canSortingProject}
            {mainFilterBlock}
            {tabsBlock}
            {categoriesBlock}
        </>

        return <>
            {contentBlock}
            {tagForAddTeamBlock}
            {tabEntityBlock}
            {filterTypeBlock}
            {mainFilterBlock}
            {sectionsBlock}
            {tabsBlock}
        </>
    }, [canCreateProjectBlock, contentBlock, filterTypeBlock, sectionsBlock, categoriesBlock, employeesFilterBlock, isModer, mainFilterBlock, moderRoleBlock,
        showWorksBlock, tabEntityBlock, tabsBlock, tagAppoitmentBlock, tagForAddTeamBlock, canSortingProject,
        teamContextBlock, teamModerationType.value])

    const lmsTab = useMemo(() => {
        return <>
            {courseTypeBlock}
            {courseLevelBlock}
            {courseStartBlock}
            {coursePriceBlock}
            {courseDurationBlock}
            {courseCardCover}
            <Disciplines onModalStateChange={onModalStateChange} teamId={team?.teamId ?? ''} />
            <ModulesOrder onModalStateChange={onModalStateChange} teamId={team?.teamId ?? ''} />
            {competencesBlock}
            {competenceYearBlock}
            {importBlock}
            {tagEducationTagBlock}
            {/* {courseEndBlock} */}
        </>
    }, [courseLevelBlock, coursePriceBlock, courseDurationBlock, competencesBlock, competenceYearBlock, courseCardCover, courseStartBlock, courseTypeBlock, tagEducationTagBlock, team?.teamId])

    const peopleTab = useMemo(() => {

        if (isModer) return <>
            {ownersAndParticipantsBlock}
            {linkParticipantsBlock}
            {groupsBlock}
        </>

        return <>
            {ownersAndParticipantsBlock}
            {linkParticipantsBlock}
            {groupsBlock}
        </>
    }, [groupsBlock, isModer, linkParticipantsBlock, ownersAndParticipantsBlock])

    const marketingTab = useMemo(() => {

        if (isModer) return <>
            {teamModerationType.value === 2 && (isModer || hasAccessToTeamsAdmin) && goodsBlock}
            {teamModerationType.value === 2 && (isModer || hasAccessToTeamsAdmin) && showShopBlock}
            {shopTabsBlock}
            {shopButtonsBlock}
            {ShopAboutBlock}
            {OutOfStockMessageBlock}
            {OutOfStockLinkBlock}
            {IsArchiveItemsShopBlock}
            {HideShopWordBlock}
            {IsHideParticipantsShopBlock}
        </>

        return <>
            {teamModerationType?.value === 2 && (isModer || hasAccessToTeamsAdmin) && goodsBlock}
        </>
    }, [HideShopWordBlock, IsArchiveItemsShopBlock, IsHideParticipantsShopBlock, OutOfStockLinkBlock, OutOfStockMessageBlock,
        ShopAboutBlock, goodsBlock, hasAccessToTeamsAdmin, isModer, shopButtonsBlock, shopTabsBlock,
        showShopBlock, teamModerationType?.value])

    const onChannelChatPermissionChange = (data: any, fieldName?: string) => {

        if (fieldName === 'whiteListIds') {
            const dublicate = data?.find((i: string) => blackListIds?.includes(i))

            if (dublicate) {
                setBlackListIds(blackListIds?.filter((i) => i !== dublicate))
            }
            setWhiteListIds(data)
        }
        if (fieldName === 'blackListIds') {
            const dublicate = data?.find((i: string) => whiteListIds?.includes(i))

            if (dublicate) {
                setWhiteListIds(whiteListIds?.filter((i) => i !== dublicate))
            }
            setBlackListIds(data)
        }

        switch (fieldName) {
            case 'channelCommentMsg':
                return setChannelCommentMsg(data)
            case 'status':
                return setChannelClosedStatus(data)
            default:
                return
        }
    }

    const channelTab = useMemo(() => {

        if (['main', 'about']?.includes(currentTab)) {
            return (
                <>
                    {teamNameBlock}
                    {aboutBlock}
                    {feedOrMediaBlock}
                    {coverBlock}
                    {tabsBlock}
                </>
            )
        }

        return <>
            <ChatPermissionEdit
                channelType={channelType}
                whiteListIds={whiteListIds}
                blackListIds={blackListIds}
                status={channelCommentClosedStatus}
                channelCommentsMsg={channelCommentMsg}
                onChange={onChannelChatPermissionChange}
            />
        </>

    }, [teamNameBlock, feedOrMediaBlock, channelType, aboutBlock, whiteListIds, blackListIds, channelCommentMsg, coverBlock, channelCommentClosedStatus, currentTab, tabsBlock])

    const tabsWrapper = useMemo(() => {
        const tabs = {
            'about': aboutTab,
            'projects': projectsTab,
            'lms': lmsTab,
            'people': peopleTab,
            'marketing': marketingTab,
        }

        const currentTabKey = currentTab as keyof typeof tabs;

        return <FlexBox direction="column" directionMobile="column" offsetBottom={104} style={{ maxWidth: 804 }}>
            {tabs?.[currentTabKey] || null}
        </FlexBox>
    }, [aboutTab, currentTab, lmsTab, marketingTab, peopleTab, projectsTab])

    if (isUpdateError) {
        return <ProjectEditFrameUpdateError id={id} />;
    }

    if (isError) {
        return <ProjectEditFrameError id={id} />;
    }

    if (isCreating) {
        return <ProjectEditFrameCreating id={id} />;
    }


    if (!team || !profile || !team.teamId) {
        return <ProjectEditFrameLoading id={id} />;
    }

    if (isForbidden) {
        return <ProjectEditFrameForbidden id={id} />;
    }

    if (showModal && modalSettings) {
        const { mode } = modalSettings;
        if (mode === 'mainFilter') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <TeamFilterEdit
                        filter={teamMainFilter}
                        onChange={setTeamMainFilter}
                        isMainFilter
                        isModer={isModer || hasAccessToTeamsAdmin}
                    />
                </PageViewportLayout>
            );
        }
        else if (['tab', 'category', 'shop'].includes(mode)) {
            const tabsIndex: any = {
                tab: teamTabs,
                category: teamCategories,
                shop: shopTabs,
            }
            const tabs = tabsIndex[mode];
            if (!!tabs[modalSettings.index]) {
                return (
                    <PageViewportLayout offsetTop={40}>
                        {PortalMenu}
                        <TeamTabEdit
                            isModer={isModer || hasAccessToTeamsAdmin}
                            type={mode as TabType}
                            categories={teamCategories}
                            tab={tabs[modalSettings.index]}
                            tabIndex={modalSettings.index}
                            teamId={team?.teamId}
                            team={team}
                            anchorTypes={anchorTypes}
                            actualForms={actualForms}
                            maxLGButtonsCount={maxLGButtonsCount}
                            updateTeam={updateTeam}
                            setIsChangesSaved={setIsChangesSaved}
                            onChange={(tab: ITeamTab) => onTeamTabChange(mode as TabType, tab, modalSettings.index)}
                        />
                    </PageViewportLayout>
                );
            }
        }
        else if (modalSettings.mode === 'forms') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <TeamFormsEdit
                        form={currentForm}
                        onUpdate={(val: any) => setDate(val)}
                        onStatusSet={(val: string) => setStatusText(val)}
                        isChangesSaved={isChangesSaved}
                        setIsFormFieldsFilled={setIsFormFieldsFilled}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'discipline') {
            return (
                <PageViewportLayout isDiscipline style={{ width: 'auto' }} offsetTop={40}>
                    {PortalMenu}
                    <TeamDisciplineEdit
                        discipline={modalSettings?.item || null}
                        onUpdate={(val: any) => setDate(val)}
                        onStatusSet={(val: string) => setStatusText(val)}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'import-groups') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <ImportGroupsModal 
                        groups={modalSettings?.item?.groups || []} 
                        teamId={team?.teamId || ''}
                        onClose={() => onModalStateChange(false, null)}
                        onGroupsChange={() => {}}
                        onUpdate={(val: any) => setDate(val)}
                        onTeamDataRefresh={refreshTeamData}
                        onGroupsRefresh={refreshGroups}
                    />
                </PageViewportLayout>
            );
        }
        else if ((modalSettings.mode === 'group' || tab === 'group') && currentGroup) {
            return (
                <PageViewportLayout offsetTop={40}>
                    <TeamGroupEdit
                        // teamModerationType={teamModerationType}
                        channelType={channelType}
                        teamId={team?.teamId}
                        actualTeamOwners={teamOwners}
                        actualTeamMembers={teamMembers}
                        group={currentGroup}
                        channelId={channelsParams?.getChannelid(currentGroup?.id)}
                        mobileEditorOpen={mobileEditorOpen}
                        onUpdate={(val: any) => {
                            setShowModal(false)
                            setDate(val)
                        }}
                        onResetGroup={() => setCurrentGroup(undefined)}
                        onDelete={onGroupDelete}
                        onBackClick={() => {
                            onModalStateChange(false, null)
                            setShowModal(false)
                        }}
                        onStatusSet={(val: string) => setStatusText(val)}
                        status={statusText}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'lg' || tab === 'lg') {

            return (
                <PageViewportLayout offsetTop={0} vtype={'fluid-wide'}>
                    {PortalMenu}
                    <TeamLgEdit
                        team={computeTeam(team)}
                        teamFilter={teamMainFilter}
                        managedTags={teamManagedTags}
                        teamTags={teamTags}
                        hasCover={hasCover}
                        onTagsChange={setTeamTags}
                        onManagedTagChange={setTeamManagedTags}
                        onAdditionalContentChange={onAdditionalContentChange}
                        tab={teamTabs[modalSettings.index]}
                        // @ts-ignore
                        additionalContent={additionalContent}
                        onChange={(tab: ITeamTab) => onTeamTabChange(TabType.tab, tab, modalSettings.index)}
                        changeColor={(val: any) => setUserColor(val)}
                        changeTitlePosition={(val: any) => setUserTitlePosition(val)}
                        titlePosition={userTitlePosition}
                        color={{
                            userColor: userColor
                        }}
                        longreadLength={longreadLength}
                        titleIsHidden={titleIsHidden}
                        onTitleHiddenClick={(val: boolean) => setTitleHidden(val)}
                        onSetLgLength={(val: number) => {
                            setHasLongread(val > 0)
                            onChangeLongreadLength(val)
                        }}
                        onSetMobTextLength={setMobTextBlockLength}
                        onSetMobileEditor={(val: boolean) => setMobileEditorOpen(val)}
                        mobileEditorAction={mobileEditorAction}
                        isPreview={isPreview}
                        longreadReady={longreadReady}
                        setLongreadReady={setLongreadReady}
                        isModer={isModer || hasAccessToTeamsAdmin}
                        vtype={team?.longread?.viewType}
                        onUpdate={(val: number) => setDate(val)}
                        onSetAnchors={onSetAnchors}
                    />
                </PageViewportLayout>
            );
        }
        else {
            return <ProjectEditFrameError id={id} />;
        }
    }

    if (isChannel) {
        return <PageViewportLayout offsetTop={16} offsetTopMobile={24}>
            {PortalMenu}
            {!showLoader && (
                <CommonContainer isTeamPage>
                    <ProjectEditPageGridRow style={{ placeItems: 'center' }} width={'100%'} justify="space-between" align={'center'} offsetBottomMobile={8}>
                        <MainHeader>{mainHeader}</MainHeader>
                        {channelType === ModerationType.Channel && (
                            <ChannelDescription
                                style={{
                                    cursor: 'pointer',
                                    ...(isMobile && { marginBottom: 8 })
                                }
                                }
                                onClick={onChannelDelete}
                            >
                                {t('teams.adminPage.additionalFields.channel_delete')}
                            </ChannelDescription>
                        )}

                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow offsetBottom={16} offsetBottomMobile={8}>
                        <ChannelDescription >
                            {t('teams.adminPage.additionalFields.channel_title')}
                        </ChannelDescription>
                    </ProjectEditPageGridRow>

                    <ProjectEditPageGridRow>
                        <MainTabsWrapper>
                            <SlideNavigation
                                activeIndexKey={currentTab}
                                onChange={(tab) => {
                                    setCurrentTab(tab as string);
                                    setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                                    sessionStorage.setItem('lastTab', tab)
                                }}
                                items={channelTabsList}
                                dropdownWhiteTheme
                                isLoading={false}
                            />
                        </MainTabsWrapper>
                    </ProjectEditPageGridRow>

                </CommonContainer>
            )}

            <ChannelEdit 
                channelTab={channelTab} 
                isLoading={showLoader} 
                onCancel={onChannelQuit} 
                onSave={primaryButtonClick} 
                canSaveLgText={canSaveLgText} 
                setIsTeamDeleted={setIsTeamDeleted} 
            />
        </PageViewportLayout>
    }

    return (
        <PageViewportLayout offsetTop={16} offsetTopMobile={24}>
            {PortalMenu}
            <CommonContainer isTeamPage>
                <ProjectEditPageGridRow offsetBottom={56} offsetBottomMobile={24}>
                    <MainHeader>{mainHeader}</MainHeader>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow>
                    <MainTabsWrapper>
                        <SlideNavigation
                            activeIndexKey={currentTab}
                            onChange={(tab) => {
                                setCurrentTab(tab as string);
                                setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                                sessionStorage.setItem('lastTab', tab)
                            }}
                            items={tabList}
                            dropdownWhiteTheme
                            isLoading={false}
                        />
                    </MainTabsWrapper>
                </ProjectEditPageGridRow>

                {tabsWrapper}

            </CommonContainer>
        </PageViewportLayout>
    );
};


export const TeamEdit = (props: any) => {
    const formMethods = useForm();
    const { handleSubmit } = formMethods;

    const onSubmit = () => {}

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <TeamEditComponent {...props} />
            </form>
        </FormProvider>
    )
}

export default TeamEdit;import {
    API,
    Designer,
    Endpoints,
    Form,
    FormAPI,
    Group,
    GroupAPI,
    Lang,
    Longread,
    Tag,
    Team,
    TeamAPI,
    UploadFileAPI
} from "@brg/api";
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { ProfileRole, bProfile, useProfile } from "@brg/auth";
import { BaseSyntheticEvent, FC, lazy, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty";
import {
    ProjectEditFrameCreating,
    ProjectEditFrameError,
    ProjectEditFrameForbidden,
    ProjectEditFrameLoading,
    ProjectEditFrameUpdateError
} from "shared/components/error-frames";
import { NavbarCreate } from "shared/components/navbar-elements";
import { CreateLinkTo } from "shared/constants/linkTo";
import {
    AddButton,
    ProjectAuthorsWrapper,
    ProjectEditPageGridLabel,
    ProjectEditPageGridRow
} from "../projectEdit/styles";
import {
    DatePickerTeamWrapper,
    ProjectEditPageGridInput,
    ProjectEditPageGridList
} from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "../projectEdit/ProjectAuthorsEdit";
import { Colors, CommonInput, CommonLabel, FlexBox, GridBox, HintTooltip, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { bTag, LayoutConst, useModal } from "core";
import { useSimpleUploader } from '@brg/uploader';
import { ProjectAddButton } from "../projectEdit/ProjectAddButton";
import { ContentAddContainer } from "../projectEdit/styles";
import { BTag } from "core/components";
import { PageViewportLayout } from "shared/components/template";
import { convertDesignerFromGlobalToLocal } from "../projectEdit/utils";
import { ITeamTab, TeamTabEdit } from "./components/TeamTabEdit";
import { ITeamFilterModel, Item } from "./components/TeamFilterEditView";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import SortableList from "react-easy-sort";

import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import { TeamFilterEdit } from "./components/TeamFilterEdit";
import { ReactComponent as PlusSvg } from "../projectEdit/close.svg";
import { BasketIcon } from "../projectEdit/BasketIcon";
import {
    ActionsButton,
    ChannelDescription,
    CommonContainer,
    CompetenceItem,
    CompetenceResult,
    CoverWrapper,
    DefaultButton,
    GridMobileNamed,
    LangBlockWrapper,
    LongreadLinkWrapper,
    MainHeader,
    MainTabsWrapper,
    MobileButtonsWrapper,
    ProjectAvailableLink,
    ProjectAvailableText,
    TableSortWrapper,
    TBody, TeamContextInputWrapper,
    TeamEditLabel,
    TeamsMobGridList,
    TeamUploadText,
    UploaderWrapper
} from "./styles";
import { MagicBoxRow } from "../project/components/toolsStyles";
import { TextAreaLengthCounter } from './components/TextAreaLengthCounter';
import { TeamUploadContainer } from "./components/TeamUploadContainer";
import EditIcon24 from "shared/icons/EditIcon24";
import { getTeamLgId } from "../project/sections/ps-longread";
import { TeamLgEdit } from "./components/TeamLgEdit";
import { computeDataWithLang, computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { useDispatch, useSelector } from "react-redux";
import useQueryState from "shared/hooks/useQueryState";
import { setType } from "shared/reducers/ViewTypeSlice";
import { TeamFormsEdit } from "./components/TeamFormsEdit";
import { useTeamForms } from "shared/hooks/useTeamForms";
import urlApi from "shared/actions/urlApi";
import { ImportGroupsModal } from "./components/ImportGroupsModal";
import {
    createDefaultForm,
    createDefaultGroup,
    createDefaultLangObject
} from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ActionTypes } from "./const/ActionTypes";
import { useTeamGroups } from "shared/hooks/useTeamGroups";
import { TeamGroupEdit } from "./components/TeamGroupEdit";
import { useGetCatalogs } from "../../hooks/api/useGetCatalogs";
import { useGetCollection } from "../../hooks/api/useGetCollection";
//@ts-ignore
import Switch from 'react-input-switch';
import { useBlockPageBeforeUnload } from "shared/hooks/useBlockPageBeforeUnload";
import { SlideNavigation } from "shared/components/slideNavigation";
import { InputType, LangTitleBlock, LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { TEAM_TYPES } from "./const/TeamTypes";
import { Date24Icon } from "../../components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "../../components/tagAdminProjectsSearchBar/date32";
import { CustomDateTimePicker } from "../../../_competition/pages/CreateCompetitionPage/CreateCompetitionPage";
import { COURSE_OPTIONS, CourseTypes } from "./const/CourseTypes";
import TeamTabsBlock, { TabType } from "./components/TeamTabsBlock";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SpecialDropdownButtons } from "./components/SpecialDropdownButtons";
import { HsePolicies } from "shared/constants/HsePolicies";
import 'react-phone-input-2/lib/style.css';
import { LMSCardFormatTypes, LMSCourseDurationTypes, LMSCourseTypes, LMS_CARDFORMAT_OPTIONS, LMS_COURSE_OPTIONS, LMS_DURATION_OPTIONS } from "./const/LMSCourseTypes";
import { addYears } from "date-fns";
import { INIT_ADDITIONAL_CONTENT } from "../projectEdit/components/PresentatitonBlock/PresentatitonBlock";
import { Disciplines } from "./components/Disciplines";
import { ModulesOrder } from "./components/ModulesOrder";
import { TeamDisciplineEdit } from "./components/TeamDisciplineEdit";
import { useLocker } from "shared/hooks/useLocker";
import TeamTopLinksBlock, { ITeamTopLink } from "./components/TeamTopLinksBlock";
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import CheckLongreadRadioButton from "./components/CheckLongreadRadioButton";
import { useProject } from "shared/hooks/api/useProject";
import { ChannelEdit } from "./components/ChannelEdit";
import { HseContextActions } from "shared/reducers/hseCurrentContext";
import DeleteIcon from "shared/icons/DeleteIcon";
import { generateUniqueString } from "shared/utils/generateUniqueString";
import { CHAT_CLOSED_STATUS, ChatPermissionEdit } from "./components/ChatPermissionEdit";
import { isTeamChannel, ModerationType } from "./const/ModerationTypes";
import { FormProvider, useForm } from "react-hook-form";
import { ICourseReadinessForCompletion } from "./types";
import { ARCHIVE_TEAM_STATUS, DRAFT_TEAM_STATUS, PUBLISHED_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { AutoChannelButton, ENTITY_COURSES_TYPE } from "./components/AutoChannelButton";
import { isServer } from "shared/constants/isServer";
import lmsModules from "../exploreHseContextsNew/const/teams/lmsModules";
import { getDefaultChannelCover } from "./components/support/getDefaultChannelCover";
const DraggableTableOriginal = lazy(() => import("./components/DraggableTable"));
import ButtonEditGroup from "./components/ButtonEditGroup";

const DraggableTable = isServer ? FlexBox : DraggableTableOriginal;

const MAX_TEAM_BUTTONS = 4;
const MAX_TABS_COUNT = 15;
const MAX_TOP_LINKS_COUNT = 5;
const MAX_TABS_FOR_LARGE_TABS_VIEW = 2;
const LG_BUTTON = 1;
const CITY_TAGS_COUNT = 1;
const DEFAULT_LG_VIEW_TYPE = 't-shape';
const DEFAULT_TAB = 'about';
const MAX_COURSE_PRICE = 100000000;
export const ALLOWED_CHARACTERS_REG = /[А-Яа-я0-9,?+!@"#№;$%^&*()=]/gi;
export const ALLOWED_CHARACTERS_REG_WITH_NUMBERS = /[А-Яа-я,?+!@"#№;$%^&*()=]/gi;
export const ALLOWED_PHONE_CHARACTERS_REG = /^\+[0-9]{11}$/;
export const REPLACE_LONGREAD_REG = /\/project\/([a-z0-9]+)/;
export const CHANNEL_MAX_SIZE_CONTAINER = 902;
const DEFAULT_MAX_SIZE_CONTAINER = 804;

const INITIAL_PHONE = '+7';
const INITIAL_ANCHOR_LIMIT = 0;

const TABS = [
    {
        name: 'about',
        path: 'about',
    },
    {
        name: 'people',
        path: 'people',
    },
    {
        name: 'projects',
        path: 'projects',
    },
    {
        name: 'lms',
        path: 'lms',
    },
    {
        name: 'marketing',
        path: 'marketing',
    },
];

const DEFAULT_CHANNEL_TAB = {
    about: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    category: '',
    color: "",
    entityType: "",
    filter: {} as ITeamFilterModel,
    gridTitle: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    gridTitleLink: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    href: '',
    isEmpty: false,
    isLinksShow: false,
    isMain: true,
    isSortingHidden: false,
    name: [{ lang: "ru", name: "Основная страница" }, { lang: "en", name: "Main page" }],
    path: generateUniqueString(),
    topLinks: []
}

const DEFAULT_CHANNEL_LMS_TAB = {
    about: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    category: '',
    color: "",
    entityType: "",
    filter: {} as ITeamFilterModel,
    gridTitle: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    gridTitleLink: [{ lang: "ru", name: "" }, { lang: "en", name: "" }],
    href: '',
    isEmpty: false,
    isLinksShow: false,
    isMain: true,
    isSortingHidden: false,
    name: [{ lang: "ru", name: "Материалы курса" }, { lang: "en", name: "Course materials" }],
    path: generateUniqueString(),
    topLinks: []
}



export interface AddTypeValue {
    specialType?: string
}

export interface ITeamButton extends AddTypeValue {
    type: string;
    text: LangObject[];
    textMobile: LangObject[];
    href: LangObject[];
    actionType: string;
    isRequired: boolean;
    anchor?: { label: string, value: string };
    currentLang?: string;
    hidden?: boolean;
}

export interface IModalSettings {
    mode: 'mainFilter' | 'tab' | 'category' | 'lg' | 'forms' | 'group' | 'shop' | 'discipline' | 'import-groups';
    index: number
    item?: any
}

export const buttonTypesForModer: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' },
    { label: 'anchor-filled', value: 'anchor-filled' },
    { label: 'anchor-hollow', value: 'anchor-hollow' }
];
export const buttonTypes: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' },
];

export const shopButtonTypes: { label: string; value: string }[] = [
    { label: 'filled', value: 'filled' },
    { label: 'hollow', value: 'hollow' }
];

const anchorLimit = [INITIAL_ANCHOR_LIMIT, 1, 2, 3, 4];

export const linkType: { path: string; newTab: boolean } = {
    path: '',
    newTab: false
};

export const cloneValue = (langObj: LangObject[]): LangObject[] => {
    const isEmpty = langObj?.some((i) => i?.name === '');

    if (isEmpty) {
        const lang = langObj?.find((i) => i?.name !== '');
        return langObj?.map((i) => ({ ...i, name: lang?.name || '' })) as LangObject[]
    }

    return langObj
}


export const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    if (value === "") {
        return [
            { lang: 'ru', name: '' },
            { lang: 'en', name: '' }
        ];
    }
    const engValue = current.find(({ lang }) => ['en', 'En']?.includes(lang)) ?? {
        lang: 'en',
        name: '',
    };
    const ruValue = current.find(({ lang }) => ['ru', 'Ru']?.includes(lang)) ?? {
        lang: 'ru',
        name: '',
    };

    if (lang === 'ru') {
        return [{
            lang: 'ru',
            name: value,
        }, engValue];
    } else {
        return [ruValue, {
            lang: 'en',
            name: value,
        }];
    }
}
export const filterMaxLength = (
    text: string,
    maxLength: number,
    toasts: any,
    t: any
): string => {

    if (text?.length > maxLength) {
        toasts.error(t('project_edit.max_title_length_error', { length: maxLength }));
        return text?.slice(0, maxLength);
    }

    return text
}


export const allowedCharacters = (
    ev: any, callback: (val: string) => void) => {
    return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG) === -1 && callback(ev.target.value)
}

export const textAllowed = (
    ev: any, callback: (val: string) => void) => {
    const re = /[0-9A-Za-zА-Яа-я\s]/;
    if (re.test(ev.target.value) || ev.target.value === '') {
        callback(ev.target.value.trimLeft())
        return;
    }
}

export const linkAllowed = (value: string) => {
    const re = /^(http|https)(:\/\/)\w+\.(com|ru|рф)/;
    if (re.test(value)) {
        return true
    }

    return false;
}

export const validateUrlString = (ev: BaseSyntheticEvent, callback: (s: string) => void) => {
    const reg = /^(http:\/\/|https:\/\/)/;
    const prefixArray = [
        '', 'h', 'ht', 'htt', 'http', 'http:','http:/' , 'http://',
        'https', 'https:', 'https:/','https://',
    ];

    if (prefixArray.includes(ev.target.value.toLowerCase()) || reg.test(ev.target.value)) {
        callback(ev.target.value);
        return;
    }
}

export const allowedCharactersWithNumbers = (
    ev: any, callback: (val: string) => void, toasts: any, errorMessage: string) => {
    const newValue = ev.target.value
    if (newValue.length > 300) {
        toasts.error(errorMessage)
        return
    }
    return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG_WITH_NUMBERS) === -1 && callback(ev.target.value)
}

export const allowedPhoneCharacters = (
    ev: any, callback: (val: string) => void) => {
    callback(ev.target.value)
}

export const isNumber = (
    ev: any, callback: (val: string) => void) => {
    return (!!Number(ev?.target?.value) || ev?.target?.value === '') && callback(ev.target.value)
}

export const allowedMaxCount = (n: number, maxCount: number) => n <= maxCount

export const getLGbool = (button: any) => !!button.isRequired /*['longread', 'лонгрид'].includes(name)*/;

const initialColor = Colors.gal;
const initialTitlePosition = 'default';

const fixTimezoneOffsetToShow = (date: Date | undefined): Date => {
    if (!date) return new Date();
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
}

const fixTimezoneOffsetToSave = (date: Date | undefined): Date => {
    if (!date) return new Date();
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}

const translateTags = (copyArray: any[], mainArray: any[], lang: string) => {
    [...copyArray].forEach((x, index) => {
        const tabFilter = {
            ...x.filter,
            tags: null,
            requiredTags: null,
            exceptedTags: null
        };

        if (!!x.filter.tags) {
            const tabFilterTags = [...x.filter.tags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.tags = tabFilterTags;
        }

        if (!!x.filter.requiredTags) {
            const tabFilterRequiredTags = [...x.filter.requiredTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.requiredTags = tabFilterRequiredTags;
        }

        if (!!x.filter.exceptedTags) {
            const tabFilterExceptedTags = [...x.filter.exceptedTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.exceptedTags = tabFilterExceptedTags;
        }

        if (!!x.filter.ownerTags) {
            const tabFilterOwnerTags = [...x.filter.ownerTags].map((tag) => {
                const translatedTag = API.toLang(tag, lang);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            tabFilter.ownerTags = tabFilterOwnerTags;
        }

        mainArray[index].filter = tabFilter;
    });
}
const validateRequiredButtonsFields = (teamButtons: any, currentLang: string): boolean => {
    return teamButtons.every((button: any) => {
        if (!button.isRequired) return true; 
        const isTextValid = button.text.some((t: LangObject) => t.lang === currentLang && t.name.trim() !== '');
        const isAnchorValid = button.type.includes('anchor')
            ? button.anchor.value.trim() !== ''
            : true;
        const isHrefValid = button.actionType === "connect"
            ? true
            : !button.type.includes('anchor')
                ? button.href.some((h: LangObject) => h.lang === currentLang && h.name.trim() !== '')
                : true;

        return isTextValid && isAnchorValid && isHrefValid;
    });
};

const REQUIRED_BUTTONS = [
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Портфолио' }, { lang: 'en', name: 'Portfolio' }],
        textMobile: [{ lang: 'ru', name: 'Портфолио' }, { lang: 'en', name: 'Portfolio' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.longread
    },
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        textMobile: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.showcase
    }
];
const REQUIRED_BUTTONS_LMS = [
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Учебные проекты' }, { lang: 'en', name: 'Educational projects' }],
        textMobile: [{ lang: 'ru', name: 'Учебные проекты' }, { lang: 'en', name: 'Educational projects' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.longread
    },
    {
        type: 'filled',
        text: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        textMobile: [{ lang: 'ru', name: 'Подробнее' }, { lang: 'en', name: 'Learn more' }],
        href: createEmptyLangObject('#', ['ru', 'en']),
        isRequired: true,
        actionType: ActionTypes.showcase
    }
];

export const getModerationTypeName = (id: number, t: any) => t(`teams.adminPage.moderationTypes.${id}`);

export const ModerationType_List: {
    label: string;
    value: number;
}[] = Object.entries(ModerationType)
    //@ts-ignore
    .map(([label, value]) => ({ label: '', value: value as number })) // label will be set in TeamEdit
    .filter(x => !isNaN(x.value));

export enum ModuleFormat {
    'FaceToFace' = 0,
    'PreRecorded' = 1,
    'Offline' = 2,
}

const ModuleFormatNames = {
    0: 'face-to-face курсы',
    1: 'предзаписанные курсы',
    2: 'офлайн-курсы',
}


export const ModuleFormatList: {
    label: string;
    value: number;
}[] = Object.entries(ModuleFormat)
    //@ts-ignore
    .map(([label, value]) => ({ label: ModuleFormatNames[value as number], value: value as number }))
    .filter(x => !isNaN(x.value));


export enum TeamProjectsFilter {
    'all' = 0,
    'owners' = 1,
    'participants' = 2
}
export const TeamLongreadType = {
    SelfLongread: 0,
    ReplaceLongread: 1,
};

export enum ShowCaseViewType {
    'showcase' = 0,
    'landing' = 1
}

export enum ShowCaseTitleType {
    'text' = 0,
    'link' = 1
}
export enum ShowCaseFilterType {
    'showcase' = 0,
    'sections' = 1
}

export const TeamProjectsFilter_List_Raw: {
    label: string;
    value: number;
}[] = Object.entries(TeamProjectsFilter)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

const TeamEditComponent: FC = () => {
    const { t, i18n } = useTranslation();
    const profile = useProfile();
    const { id } = useParams<{ id: string }>();
    const throttle = useRef<any>();
    const switchRef = useRef<any>();
    const titleRef = useRef<any>();
    const history = useHistory();
    const modal = useModal();
    const toasts = useToasts();
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const is800 = useBreakpoint(800);
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const is1280 = useBreakpoint(LayoutConst.screen.l_12);
    const is1024 = useBreakpoint(LayoutConst.screen.m_1024);
    const dispatch = useDispatch();

    const [isChangesSaved, setIsChangesSaved] = useState(false);
    const [teamDeleted, setIsTeamDeleted] = useState(false);
    const [isFormFieldsFilled, setIsFormFieldsFilled] = useState(false);

    // ModerationType_List с локализацией
    const ModerationTypeListLocalized = useMemo(() =>
        ModerationType_List.map(item => ({
            ...item,
            label: getModerationTypeName(item.value, t)
        })),
        [t]
    );

    const [team, setTeam] = useState<Team<'Global'> & any>();
    const hasPopulatedFromTeamRef = useRef<boolean>(false);
    const [teamName, setTeamName] = useState<LangObject[]>([]);
    const [teamLongread, setTeamLongread] = useState<Longread>();
    const [teamNameExtra, setTeamNameExtra] = useState<LangObject[]>([]);
    const [teamBGLang, setImageLang] = useState<boolean>(false);
    const [teamAbout, setTeamAbout] = useState<LangObject[]>([]);
    const [teamAboutExtra, setTeamAboutExtra] = useState<LangObject[]>([]);
    const [teamRoute, setTeamRoute] = useState<string>('');
    const [teamPhone, setTeamPhone] = useState<string>('');
    const [teamEmail, setTeamEmail] = useState<string>('');
    const [teamContexts, setTeamContexts] = useState<string[]>([]);
    const [teamCompetences, setTeamCompetences] = useState<Record<string, string>>({});
    const [teamCompetenceYear, setTeamCompetenceYear] = useState<number>(2024);
    const [teamAuthors, setTeamAuthors] = useState<Designer<'Local'>[]>([]);
    const [teamOwners, setTeamOwners] = useState<Designer<'Local'>[]>([]);
    const [teamMembers, setTeamMembers] = useState<Designer<'Local'>[]>([]);
    const [teamContextName, setTeamContextName] = useState<string>('');
    const [teamAnchorLimit, setTeamAnchorLimit] = useState<string>('');
    const [teamModerationType, setTeamModerationType] = useState<{ label: string; value: number; }>(ModerationTypeListLocalized[0]);
    const [teamModerRole, setTeamModerRole] = useState<string>('');
    const [teamTags, setTeamTags] = useState<Tag[]>([]);
    const [teamOwnerTags, setTeamOwnerTags] = useState<Tag[]>([]);
    const [teamManagedTags, setTeamManagedTags] = useState<Tag[]>([]);
    const [teamEducationTags, setTeamEducationTags] = useState<Tag[]>([]);
    const [teamIsCanCreateProject, setTeamIsCanCreateProject] = useState<boolean>(false);
    const [sortingHidden, setSortingHidden] = useState<boolean>(false);
    const [teamIsShopVisible, setTeamIsShopVisible] = useState<boolean>(false);
    const [teamShowQu, setTeamShowQu] = useState<boolean>(false);
    const [teamIsLargeTabs, setTeamIsLargeTabs] = useState<boolean>(false);
    const [teamIsShowEmployeesLink, setTeamIsShowEmployeesLink] = useState<boolean>(false);
    const [teamIsShowGridFirst, setTeamIsShowGridFirst] = useState<boolean>(false);
    const [teamIsShowTeachersCheckbox, setTeamIsShowTeachersCheckbox] = useState<boolean>(false);
    const [teamSwitchButtonVisible, setTeamSwitchButtonVisible] = useState<boolean>(false);
    const [teamIsLongreadDisabled, setTeamIsLongreadDisabled] = useState<boolean>(false);
    const [teamShowLg, setTeamShowLg] = useState<boolean>(false);
    const [teamMainFilter, setTeamMainFilter] = useState<ITeamFilterModel>({} as ITeamFilterModel);
    const [teamButtons, setTeamButtons] = useState<ITeamButton[]>([]);
    const [teamNavButtons, setTeamNavButtons] = useState<ITeamButton[]>([]);
    const [teamTabs, setTeamTabs] = useState<ITeamTab[]>([]);
    const [topLinks, setTopLinks] = useState<ITeamTopLink[]>([]);
    const [teamEntityType, setTeamEntityType] = useState<string>();
    const [teamCategories, setTeamCategories] = useState<ITeamTab[]>([]);
    const [titleIsHidden, setTitleHidden] = useState<boolean>(false);
    const [longread, setLongread] = useState([]);
    const [longreadReady, setLongreadReady] = useState<boolean | null>(null);
    const [hasLongread, setHasLongread] = useState(false);
    const [coverLink, setCoverLink] = useState(linkType);
    const [coverTitle, setCoverTitle] = useState<LangObject[]>([]);
    const { isChannel, channelType } = isTeamChannel(team?.moderationType);

    const [longreadLength, setLongreadLength] = useState(0);
    const [teamLongreadType, setTeamLongreadType] = useState(TeamLongreadType.ReplaceLongread);
    const [longreadEntityLink, setLongreadEntityLink] = useState('');
    const [replaceLongreadId, setReplaceLongreadId] = useState('');
    const [projectId, setProjectId] = useState<string>('');
    const [time, setTime] = useState(Date.now());
    const [projectSource, isProjectLoading, projectError] = useProject(projectId, i18n.language, projectId + time);

    const [blackListIds, setBlackListIds] = useState<string[]>([]);
    const [whiteListIds, setWhiteListIds] = useState<string[]>([]);
    const [channelCommentClosedStatus, setChannelClosedStatus] = useState<CHAT_CLOSED_STATUS>(CHAT_CLOSED_STATUS.open);
    const [channelCommentMsg, setChannelCommentMsg] = useState<LangObject[]>([]);

    const [isCourseCompleted, setIsCourseCompleted] = useState(false);

    const teamBGLangRef = useRef(teamBGLang);
    useEffect(() => {
        teamBGLangRef.current = teamBGLang;
    }, [teamBGLang]);

    const maxFieldSize = useMemo(
        () => (isChannel ? CHANNEL_MAX_SIZE_CONTAINER : DEFAULT_MAX_SIZE_CONTAINER)
        , [isChannel])

    const fetchLongread = useCallback(() => {
        const longreadId = getTeamLgId(team, i18n.language)

        if (longreadId) {
            API.request()
                .endpoint(Endpoints.longread)
                .url('api/post/GetMany')
                .addQuery('idUser', '2')
                .addQuery('idLongread', longreadId)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setLongread(r)
                })
        }
    }, [team, i18n.language])

    const onChangeLongreadLength = useCallback((value: number) => {
        if (longreadLength > 0 && team?.moderationType === ModerationType.LMS) {
            fetchLongread()
        } 
        setLongreadLength(value)
    } , [longreadLength, team])

    const onSetAnchors = useCallback((anchors: any) => {
        //@ts-ignore
        const { visibleAnchorsLimit: limit } = team || {};
        if (anchors?.length) {
            dispatch(HseContextActions.setAnchorLinks({ anchors, limit }))
        }
    }, [dispatch, team])

    useEffect(() => {
        return () => {
            dispatch(HseContextActions.resetAnchorLinks())
        }
    }, [dispatch])


    const TeamProjectsFilter_List = TeamProjectsFilter_List_Raw.map((item: any) => ({ ...item, label: t('teams.adminPage.fields.show_works_' + item.label) }), [t]);
    const [teamProjectsValue, setTeamProjectsFilter] = useState<number>(TeamProjectsFilter_List[0].value);
    const teamProjectsFilter = useMemo(() => {
        const index = TeamProjectsFilter_List.findIndex(i => i?.value === teamProjectsValue)
        return index === -1 ? TeamProjectsFilter_List[0] : TeamProjectsFilter_List[index]
    }, [TeamProjectsFilter_List, teamProjectsValue, t])

    // SHOP
    const [shopAbout, setShopAbout] = useState<LangObject[]>([]);
    const [outOfStockMessage, setOutOfStockMessage] = useState<LangObject[]>([]);
    const [outOfStockLink, setOutOfStockLink] = useState<string>();
    const [isArchiveItemsShop, setIsArchiveItemsShop] = useState<boolean>(false);
    const [hideShopWord, setHideShopWord] = useState<boolean>(false);
    const [isHideParticipantsShop, setIsHideParticipantsShop] = useState<boolean>(false);
    const [isShowTeamEmblem, setIsShowTeamEmblem] = useState(false)
    const [shopNavButtons, setShopNavButtons] = useState<ITeamButton[]>([]);
    const [shopTabs, setShopTabs] = useState<ITeamTab[]>([]);

    const [showCaseViewType, setShowCaseViewType] = useState(ShowCaseViewType.showcase);
    const [feedViewType, setFeedViewType] = useState(0);
    const [showCaseTitleType, setShowCaseTitleType] = useState(ShowCaseTitleType.text);
    const [showCaseFilterType, setShowCaseFilterType] = useState(ShowCaseFilterType.showcase);
    const [isSmallName, setIsSmallName] = useState(false);
    const [isShowFullDescription, setIsShowFullDescription] = useState(false);
    const [isMinimalName, setIsMinimalName] = useState(false);
    const [isMainTitleHidden, setIsMainTitleHidden] = useState(false);
    const [isShowTeamLandingWithProjects, setIsShowTeamLandingWithProjects] = useState(false);
    const [isLinksInsteadTitle, setIsLinksInsteadTitle] = useState(false);
    const [statusText, setStatusText] = useState<string>('');
    const [isCreating, setIsCreating] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isForbidden, setIsForbidden] = useState<boolean>(false);
    const [isUpdateError, setIsUpdateError] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalSettings, setModalSettings] = useState<IModalSettings | null>();
    const [userColor, setUserColor] = useState<string>(initialColor);
    const [userTitlePosition, setUserTitlePosition] = useState<string>(initialTitlePosition);
    const [isPreview, setIsPreview] = useState(false);
    const [currentForm, setCurrentForm] = useState<Form<'Global'>>();
    const [currentGroup, setCurrentGroup] = useState<Group<'Global'>>();
    const [mobileEditorOpen, setMobileEditorOpen] = useState(false);
    const [mobileEditorAction, setMobileEditorAction] = useState<string>('');
    const [mobTextBlockLength, setMobTextBlockLength] = useState<number>(0);
    const [date, setDate] = useState(Date.now());
    const [currentTab, setCurrentTab] = useState(DEFAULT_TAB);
    const [additionalContent, setAdditionalContent] = useState(null);
    const [{ tab, idform }, setQueryParams] = useQueryState();
    const [showLoader, setShowLoader] = useState(false);

    const [courseType, setCourseType] = useState<CourseTypes>(CourseTypes.ONLINE);
    const [lmsCourseType, setLmsCourseType] = useState<LMSCourseTypes>(LMSCourseTypes.BachelorsDegree);
    const [lmsCourseTerm, setLmsCourseTerm] = useState<LMSCourseDurationTypes>(LMSCourseDurationTypes.short);
    const [lmsCardFormat, setLmsCardFormat] = useState<LMSCardFormatTypes>(LMSCardFormatTypes.long);
    const [coursePrice, setCoursePrice] = useState<string | undefined>();
    const [courseStartDate, setCourseStartDate] = useState<Date | undefined>();
    const [contextString, setContextsString] = useState('');
    const [competenceString, setCompetenceString] = useState('');
    const [competenceSearchResults, setCompetenceSearchResults] = useState<any[]>([]);
    const [isSearchingCompetences, setIsSearchingCompetences] = useState(false);
    const [competenceSearchError, setCompetenceSearchError] = useState<string | null>(null);
    const [allCompetenceResults, setAllCompetenceResults] = useState<any[]>([]);
    const [showAllResults, setShowAllResults] = useState(false);
    const [useCalendarEnabled, setUseCalendarEnabled] = useState(false);

    const [courseReadinessForCompletion, setCourseReadinessForCompletion] = useState<ICourseReadinessForCompletion | null>(null);

    useLocker();

    const onChangeCoursePrice = useCallback((price: string) => {

        if (Number(price) < 0) {
            toasts.error("Введите валидную стоимость курса");
            return;
        }

        if (Number(price) > MAX_COURSE_PRICE) {
            toasts.error(`Максимальная стоимость курса ${MAX_COURSE_PRICE}`);
            return;
        }

        setCoursePrice(price);

    }, [setCoursePrice, toasts]);

    const searchCompetences = useCallback(async (searchString: string) => {
        if (!searchString || searchString.length < 2) {
            setCompetenceSearchResults([]);
            setCompetenceSearchError(null);
            setAllCompetenceResults([]);
            setShowAllResults(false);
            return;
        }

        setIsSearchingCompetences(true);
        setCompetenceSearchError(null);
        setAllCompetenceResults([]);
        setShowAllResults(false);
        
        try {
            const response = await fetch(`https://api.design.hse.ru/v1.2/competencies?searchString=${encodeURIComponent(searchString)}`);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (Array.isArray(data)) {
                setAllCompetenceResults(data);
                // Ограничиваем количество результатов до 10
                const limitedResults = data.slice(0, 10);
                setCompetenceSearchResults(limitedResults);
                setShowAllResults(false);
                
                if (data.length === 0) {
                    setCompetenceSearchError('Ничего не найдено');
                } else if (data.length > 10) {
                    setCompetenceSearchError(`Найдено ${data.length} результатов. Показаны первые 10.`);
                }
            } else {
                setCompetenceSearchResults([]);
                setCompetenceSearchError('Неверный ответ от сервера');
            }
        } catch (error) {
            console.error('Error searching competences:', error);
            setCompetenceSearchResults([]);
            setCompetenceSearchError('Ошибка при поиске');
        } finally {
            setIsSearchingCompetences(false);
        }
    }, [t]);

    const courseCurrentOption = useMemo(() => COURSE_OPTIONS.find(i => i?.value === courseType) || COURSE_OPTIONS[0], [courseType, COURSE_OPTIONS])
    const lmsCourseCurrentOption = useMemo(() => LMS_COURSE_OPTIONS.find(i => i?.value === lmsCourseType) || LMS_COURSE_OPTIONS[team?.lmsCourseType], [lmsCourseType, LMS_COURSE_OPTIONS])
    const lmsDurationOption = useMemo(() => LMS_DURATION_OPTIONS.find(i => i?.value === lmsCourseTerm) || LMS_DURATION_OPTIONS[team?.lmsCourseTerm], [lmsCourseTerm, LMS_DURATION_OPTIONS])
    const lmsCardTypeOption = useMemo(() => LMS_CARDFORMAT_OPTIONS.find(i => i?.value === lmsCardFormat) || LMS_CARDFORMAT_OPTIONS[team?.lmsCardFormat], [lmsCardFormat, LMS_DURATION_OPTIONS])

    const forms = useTeamForms(team?.teamId, date)

    const { groups, refreshGroups } = useTeamGroups(team?.teamId, date, i18n.language);
    
    const [localGroups, setLocalGroups] = useState<Group<'Global'>[]>([]);
    
    useEffect(() => {
        if (groups?.length) {
            setLocalGroups(groups);
        }
    }, [groups]);

    const computedGroups = useMemo(() => (!!localGroups?.length ? localGroups?.map((g) => API.toLang<Group>(g, i18n.language || 'ru')) : []), [localGroups]);

    const vtype = useSelector((state: any) => state.vt.vtype);

    const hasCurrentUnitAdminPolicy = (p: any, teamId: string) => p && p.rolesList && Array.isArray(p.rolesList)
        && (new ProfileRole(`${HsePolicies.admin_unit_prefix}${teamId}`)).containsIn(p.rolesList);

    const hasAllUnitsAdminPolicy = (p: any) => p && p.rolesList && Array.isArray(p.rolesList)
        && (new ProfileRole(HsePolicies.access_ui_units_admin)).containsIn(p.rolesList);

    const isOwner = useMemo(
        () => profile &&
            ((team?.ownersIDs && team?.ownersIDs?.includes(profile?.accountId)) || hasCurrentUnitAdminPolicy(profile, team?.teamId))
        , [profile, team]);

    const isModer = useMemo(
        () => profile && (bProfile.isModer(profile) || profile?.rolesList?.includes('juniormoder') || hasAllUnitsAdminPolicy(profile))
        , [profile]);

    const hasAccessToTeamsAdmin = isOwner;

    useEffect(() => {
        setIsForbidden(!isModer && !isOwner && !hasAccessToTeamsAdmin)
    }, [isModer, isOwner, hasAccessToTeamsAdmin])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (competenceString && competenceString.length >= 2) {
                searchCompetences(competenceString);
            } else {
                setCompetenceSearchResults([]);
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [competenceString, searchCompetences]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.competences-search-container')) {
                setCompetenceSearchResults([]);
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setCompetenceSearchResults([]);
                setCompetenceString('');
                setCompetenceSearchError(null);
                setAllCompetenceResults([]);
                setShowAllResults(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const unloadSign = useMemo(() => (!isChangesSaved && !isCreating && !teamDeleted), [isChangesSaved, isCreating, teamDeleted]);
    const unloadCallback = (val: boolean) => {
        setIsChangesSaved(val);
    }
    const excluded = [
        `/team-longread-preview`,
        `/preview`,
        `/preview/${id}`,
        `/team-preview`,
        `/team-preview/${id}`,
        `/team-longread-preview/${id}`
    ];
    useBlockPageBeforeUnload(unloadSign, unloadCallback, excluded);

    const sipRef = useRef<any>(null);
    const teamIdRef = useRef<any>();

    const hasTeamBG = useMemo(() => (!!team?.titleImages?.length), [team]);
    const hasTeamBGEn = useMemo(() => (!!team?.titleImages_en?.length), [team]);

    const hasName = useMemo(() => (teamName?.some((i) => i?.name !== '')), [teamName]);
    const hasRoute = useMemo(() => (!!teamRoute?.length), [teamRoute]);
    const hasOwner = useMemo(() => (!!teamOwners?.length), [teamOwners]);
    const hasContext = useMemo(() => (!!teamContextName?.length), [teamContextName]);
    const requiredTopLinks = useMemo(() => (!isLinksInsteadTitle || !!topLinks.filter(topLink => !!topLink?.link?.length && !!topLink?.name?.some(({ name }) => !!name))?.length), [topLinks, isLinksInsteadTitle]);

    const hasCover = useMemo(() => {
        if (!!longread?.length) {
            return longread?.some((post: any) => post?.style === 'as_cover')
        }
    }, [longread, longreadReady]);

    const hasAnnotationPost = useMemo(() => {
        if (!!longread?.length && team?.moderationType === ModerationType.LMS) {
            return longread?.some((post: any) => post?.style === 'annotation')
        }
        return true;
    } , [longread, longreadReady, date, team])

    const canSaveLgText = useMemo(() => {

        if (isChannel) {
            return (hasName && hasOwner)
        }

        if (!requiredTopLinks) {
            return false;
        }
        if (projectError && teamLongreadType === TeamLongreadType.ReplaceLongread) {
            return false
        }
        if (modalSettings?.mode === 'group' && currentGroup) {
            const group = groups?.find((i: Group<'Global'>) => i?.id === currentGroup?.id);
            return group?.name?.some(({ name }) => !!name)
        }
        if (modalSettings?.mode === 'forms') {
            return isFormFieldsFilled
        }
        if (hasCover && !!coverLink?.path?.length) {
            return linkAllowed(coverLink?.path)
        }
        if (modalSettings && (modalSettings.mode === 'lg' || tab === 'lg') && !hasAnnotationPost) {
            return false
        }

        if (teamCategories.length) {
            return teamCategories.every(category => category.path && category.entityType && Lang(category.name, 'ru'))
        }

        if (modalSettings && (modalSettings.mode === 'lg' || tab === 'lg') && hasCover) {
            return true;
        }

        if (hasLongread && !hasAnnotationPost) {
            return false;
        }

        if (hasName && hasOwner && hasContext && teamRoute && validateRequiredButtonsFields(teamButtons, i18n.language)) {
            return true;
        }

        if (!!mobileEditorOpen && mobTextBlockLength === 0 && modalSettings && (modalSettings.mode === 'lg' || tab === 'lg')) {
            return false;
        }

        return false;
    }, [isChannel, hasAnnotationPost, hasLongread, mobTextBlockLength, isFormFieldsFilled, currentGroup, projectError, teamLongreadType, modalSettings, teamRoute, teamButtons, isMobile, tab, mobileEditorOpen, coverLink, hasName, hasRoute, hasOwner, hasCover, hasContext, requiredTopLinks, teamCategories])

    const errors = useMemo(() => {
        const errors = [];

        if (modalSettings?.mode === 'group') {
            const group = groups?.find((i: Group<'Global'>) => i?.id === currentGroup?.id);
            const emptyName = group?.name?.every(({ name }) => !name)

            if (emptyName) {
                errors.push(`${t('teams.adminPage.errors.group_name')}`);
            }
        }

        if (modalSettings?.mode === 'lg') {
            if (!hasAnnotationPost) {
                errors.push(`${t('teams.adminPage.errors.annotation_post')}`);
            }
        }
        if (modalSettings?.mode === 'forms') return [];
        if (teamCategories.length) {
            if (!teamCategories.every(category => category.path && category.entityType && Lang(category.name, 'ru'))) {
                errors.push(`${t('teams.adminPage.errors.section')}`);
            }
        }
        if (hasLongread && !hasAnnotationPost) {
            errors.push(`${t('teams.adminPage.errors.annotation_post')}`);
        }
        if (!hasContext) {
            errors.push(`${t('teams.adminPage.errors.context')}`);
        }
        if (!hasName) {
            errors.push(`${t('teams.adminPage.errors.name')}`);
        }
        if (projectError) {
            errors.push(`${t('teams.adminPage.errors.landing_link')}`);
        }
        if (!requiredTopLinks) {
            errors.push(`${t('teams.adminPage.errors.required_top_links')}`);
        }
        if (!hasOwner) {
            errors.push(`${t('teams.adminPage.errors.owners')}`);
        }
        if (hasCover && !!coverLink?.path?.length && !linkAllowed(coverLink?.path)) {
            errors.push(`${t('teams.adminPage.errors.link')}`);
        }
        return errors;
    }, [hasName, hasRoute, hasAnnotationPost, hasLongread, groups, currentGroup, hasOwner, projectError, t, modalSettings, coverLink, hasCover, longread, hasContext, requiredTopLinks, teamCategories])

    const maxButtonsCount = useMemo(() => {
        const hasLgButton = teamButtons.some((i) => !!i?.isRequired);

        if (!hasLgButton && teamButtons?.length === MAX_TEAM_BUTTONS) return true;

        else if (!!hasLgButton && teamButtons?.length + 1 > (MAX_TEAM_BUTTONS + LG_BUTTON)) return true;

        return false;

    }, [teamButtons])

    const maxShopButtonsCount = useMemo(() => {
        return shopNavButtons?.length + 1 > MAX_TEAM_BUTTONS;
    }, [shopNavButtons])

    const maxLGButtonsCount = useMemo(() => {
        return hasLongread ? MAX_TEAM_BUTTONS : MAX_TEAM_BUTTONS - 1;
    }, [hasLongread]);



    useEffect(() => {
        setIsChangesSaved(false);
    }, [
        team,
        teamName,
        coverTitle,
        teamNameExtra,
        teamAbout,
        teamRoute,
        teamContexts,
        showCaseViewType,
        feedViewType,
        showCaseTitleType,
        showCaseFilterType,
        teamAuthors,
        teamOwners,
        teamMembers,
        teamContextName,
        teamModerationType,
        teamProjectsFilter,
        teamSwitchButtonVisible,
        teamModerRole,
        teamTags,
        teamOwnerTags,
        teamManagedTags,
        teamEducationTags,
        teamIsCanCreateProject,
        sortingHidden,
        titleIsHidden,
        teamIsLargeTabs,
        teamIsShowEmployeesLink,
        teamIsShowGridFirst,
        teamIsShopVisible,
        teamIsShowTeachersCheckbox,
        teamAnchorLimit,
        teamButtons,
        teamTabs,
        topLinks,
        coverLink,
        teamCategories,
        hasLongread,
        teamMainFilter,
        teamLongread,
        isSmallName,
        isMinimalName,
        isMainTitleHidden,
        isShowTeamLandingWithProjects,
        isLinksInsteadTitle,
        // currentForm,
        teamShowLg,
        userColor,
        vtype,
    ])

    const [updatedTeam, setUpdatedTeam] = useState(false)
    
    const refreshTeamData = useCallback(() => {
        if (id) {
            TeamAPI.Get({ idTeam: id })
                .then(res => res.json())
                .then(data => {
                    setTeam(data);
                    setUpdatedTeam(false);
                    setDate(Date.now());
                })
                .catch((reason) => {
                    console.error('Error refreshing team data:', reason);
                });
        }
    }, [id]);

    const onFeedViewTypeChange = (value: any) => {
        setFeedViewType(Number(value))
    }
    
    useEffect(() => {
        if (!updatedTeam) return;
        refreshTeamData();
    }, [updatedTeam, refreshTeamData]);


    useEffect(() => {
        if (profile) {
            if (id) {
                
                TeamAPI.Get({ idTeam: id })
                    .then((value) => value.json() as Promise<Team<'Global'>>)
                    .then((value) => {
                        if (value.teamId) {
                            setTeam(value);
                            setIsError(false);
                        } else {
                            setTeam(undefined);
                            setIsError(true);
                        }
                    })
                    .catch((reason) => {
                        console.error(reason);
                        setTeam(undefined);
                        setIsError(true);
                    });
            } else {
                setIsCreating(true);
                TeamAPI.Add({
                    name: createEmptyLangObject('', ['ru', 'en']),
                    initialTab: ''
                } as Team<'Global'> & any)
                    .then((res) => res.json())
                    .then((res: any) => {
                        setTimeout(() => {
                            setIsCreating(false);
                            history.replace(CreateLinkTo.teamEdit(res));
                        }, 800);
                    });
            }
        }
    }, [id, profile, history, date]);

    useEffect(() => {
        if (team?.teamId) {
            API.request()
                .endpoint(Endpoints.geograffee)
                .url("/api/lms/IsCourseCompleted")
                .get()
                .addQuery("teamId", team.teamId)
                .send()
                .then((r) => r.json())
                .then((r) => {
                    console.log("IsCourseCompleted", r);
                    setIsCourseCompleted(r);
                })
                .catch((e) => console.error(e));
        } 
    }, [team]);

    useEffect(() => {
        if (team?.teamId) {
            teamIdRef.current = team?.teamId
        }
    }, [team])

    useEffect(() => {
        if (tab === 'lg') {
            onModalStateChange(true, { mode: "lg", index: 2 })
        }
        if (tab === 'forms' && idform?.length) {
            onModalStateChange(true, { mode: "forms", index: 2 })
            setCurrentForm(forms?.filter((i) => i?.formId === idform)[0])
        }
        if (tab === 'people') {
            setCurrentTab('people')
        }
    }, [tab, forms, idform])

    useEffect(() => {
        if (team && team.teamId && !hasPopulatedFromTeamRef.current) {
            setTeamName(team.name?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamLongread(team?.longread)
            setTeamNameExtra(!!team.nameExtra?.length ? team.nameExtra : createDefaultLangObject(''));
            setTeamAbout(team.about?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamAboutExtra(team.aboutExtra?.map((name: LangObject) => computeDataWithLang(name)));
            setTeamRoute(team.route);
            setTeamPhone(team.phone || INITIAL_PHONE);
            setTeamEmail(team.email);
            setTeamContexts(team.contexts);
            setTeamCompetences(team?.competences ? team.competences : {});
            setTeamCompetenceYear(team?.competenceYear || 0);
            //@ts-ignore
            setTeamAuthors(team.lmsCourseAuthors ? [...team.lmsCourseAuthors].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)) : []);
            setTeamOwners([...team.owners].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)));
            setTeamMembers([...team.members].map((x) => convertDesignerFromGlobalToLocal(x, i18n.language)));
            setTeamContextName(team.contextName);
            setTitleHidden(team.isTitleHidden);

            if (isChannel) {
                setBlackListIds(team.channelCommentBlackListIds)
                setWhiteListIds(team.channelCommentWhiteListIds)
                setChannelClosedStatus(team.channelCommentClosedStatus)
                setChannelCommentMsg(team.channelCommentMsg)
            }

            //@ts-ignore
            setIsSmallName(team.isSmallName);
            //@ts-ignore
            setIsShowFullDescription(team.isShowFullDescription);
            //@ts-ignore
            setIsMinimalName(team.isMinimalName);
            //@ts-ignore
            setIsMainTitleHidden(team.isMainTitleHidden);
            //@ts-ignore
            setIsShowTeamLandingWithProjects(team.isShowTeamLandingWithProjects);
            setIsLinksInsteadTitle(team.isLinksInsteadTitle);
            setTeamModerRole(team.moderRole);
            setTeamIsCanCreateProject(team.isCanCreateProject);
            setSortingHidden(team.isSortingHidden);
            setTeamIsLargeTabs(team.isLargeTabs);
            setTeamIsShowEmployeesLink(team.isShowEmployeesLink);
            setTeamSwitchButtonVisible(team.isSwitchButtonVisible);

            //@ts-ignore
            setTeamIsLongreadDisabled(team.isLongreadDisabled);
            //@ts-ignore
            setTeamIsShowGridFirst(team.isShowGridFirst);
            //@ts-ignore
            setTeamIsShopVisible(team.isShopVisible);
            //@ts-ignore
            setTeamShowQu(team.showQu);
            //@ts-ignore
            setTeamEntityType(team.mainEntityType);
            //@ts-ignore
            setIsShowTeamEmblem(team?.isShowTeamEmblem)

            //@ts-ignore
            setOutOfStockLink(team.outOfStockLink);
            //@ts-ignore
            setIsArchiveItemsShop(team.isArchiveItemsShop);
            //@ts-ignore
            setHideShopWord(team.hideShopWord);
            //@ts-ignore
            setIsHideParticipantsShop(team?.isHideParticipantsShop);
            //@ts-ignore
            setShopNavButtons([...team?.shopNavButtons].sort((a, b) => b.isRequired ? -1 : 1)?.map((button) => computeDataWithLang(button)));
            //@ts-ignore
            const shopTabs = [...team.shopTabs];
            translateTags([...team.shopTabs], shopTabs, i18n.language);
            setShopTabs(shopTabs?.map((tab) => ({ ...computeDataWithLang(tab), entityType: tab?.entityType || '' })));
            //@ts-ignore
            setOutOfStockMessage(team?.outOfStockMessage);
            //@ts-ignore
            setShopAbout(team?.shopAbout);

            //@ts-ignore
            setCourseType(team.lmsModuleFormat);
            //@ts-ignore
            setLmsCourseType(team.lmsCourseType);
            //@ts-ignore
            setLmsCourseTerm(team.lmsCourseTerm)
            //@ts-ignore
            setLmsCardFormat(team.lmsCover)
            //@ts-ignore
            setCoursePrice(team?.lmsModulePrice.toString());
            //@ts-ignore
            setTeamLongreadType(team?.longreadType || TeamLongreadType.SelfLongread);
            //@ts-ignore
            setLongreadEntityLink(team?.longreadEntityLink || '');
            //@ts-ignore
            setReplaceLongreadId(team?.replaceLongreadId || '');
            //@ts-ignore
            setCourseStartDate(fixTimezoneOffsetToShow(new Date(team?.lmsModuleStartDate || Date.now())));

            setShowCaseViewType(team.isShowGridFirst ? ShowCaseViewType.showcase : team?.isShowLongread ? ShowCaseViewType.landing : ShowCaseViewType.showcase)
            //@ts-ignore
            setFeedViewType(team?.moderationType === ModerationType.Channel ?  (!!team?.isShowFeed ? 1 : 0) : 0)
            setTeamIsShowTeachersCheckbox(team.isShowTeachersCheckbox);
            setUserColor(team?.additionalInfo?.color || initialColor);
            setUserTitlePosition(team?.additionalInfo?.titlePosition || initialTitlePosition);
            setTeamButtons([...team.buttons].sort((a, b) => b.isRequired ? 1 : -1)?.map((button) => computeDataWithLang(button)));
            setTeamNavButtons(team.navButtons?.map((button: any) => computeDataWithLang(button)));

            setTeamShowLg(team?.isShowLongread);
            setTeamAnchorLimit(team?.visibleAnchorsLimit);
            setCoverLink(team?.coverLink ?? linkType);
            setCoverTitle(!!team.coverTitle?.length ? team.coverTitle : createDefaultLangObject(''));

            setAdditionalContent(isChannel ? INIT_ADDITIONAL_CONTENT : (team?.additionalContent || INIT_ADDITIONAL_CONTENT))

            const moderationType = ModerationTypeListLocalized.find(x => x.value === team.moderationType);
            if (moderationType) {
                setTeamModerationType(moderationType);
            }

            const projectsFilter = TeamProjectsFilter_List.find(x => x.value === team.teamProjectsFilter);
            if (projectsFilter) {
                setTeamProjectsFilter(projectsFilter);
            }

            fetchLongread();

            const tags = [...team.tags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const ownerTags = [...team.ownerTags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const managedTags = [...team.managedTags].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            const educationTags = [...(team.educationTags || [])].map((tag) => {
                const translatedTag = API.toLang(tag, i18n.language);
                return {
                    //@ts-ignore
                    ...translatedTag,
                }
            });

            setTeamTags(tags);
            setTeamOwnerTags(ownerTags);
            setTeamManagedTags(managedTags);
            setTeamEducationTags(educationTags);
            setUseCalendarEnabled(team?.mainFilter?.useCalendar)

            const mainFilter = {
                ...team.mainFilter,
                tags: null,
                requiredTags: null,
                exceptedTags: null,
            };

            if (!!team.mainFilter.tags) {
                const mainFilterTags = [...team.mainFilter.tags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.tags = mainFilterTags;
            }

            if (!!team.mainFilter.requiredTags) {
                const mainFilterRequiredTags = [...team.mainFilter.requiredTags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.requiredTags = mainFilterRequiredTags;
            }

            if (!!team.mainFilter.exceptedTags) {
                const mainFilterExceptedTags = [...team.mainFilter.exceptedTags].map((tag) => {
                    const translatedTag = API.toLang(tag, i18n.language);
                    return {
                        //@ts-ignore
                        ...translatedTag,
                    }
                });

                mainFilter.exceptedTags = mainFilterExceptedTags;
            }

            setTeamMainFilter(mainFilter);


            const tabs = [...team.tabs];
            const categories = [...team.categories];
            const teamTopLinks = [...(team?.topLinks || [])];

            translateTags([...team.tabs], tabs, i18n.language);
            translateTags([...team.categories], categories, i18n.language);

            dispatch(setType(team?.longread?.viewType || DEFAULT_LG_VIEW_TYPE))
            setTeamTabs(tabs?.map((tab) => ({ ...computeDataWithLang(tab), entityType: tab?.entityType || '' })));
            setTopLinks(teamTopLinks?.map((teamTopLink) => ({ ...computeDataWithLang(teamTopLink) })));
            setTeamCategories(categories?.map((category) => ({ ...computeDataWithLang(category), entityType: category?.entityType || '' })));

            if (isChannel && !tabs?.length) {
                setTeamTabs([(channelType === ModerationType.ChannelGroupOrCourse) ? DEFAULT_CHANNEL_LMS_TAB : DEFAULT_CHANNEL_TAB])
            }
            hasPopulatedFromTeamRef.current = true;
        }
    }, [team, dispatch, longreadReady]);


    const updateLg = async () => {
        await API.request('/api/Longread/Update')
            .endpoint(Endpoints.longread)
            .post()
            .body({
                ...teamLongread,
                viewType: vtype,
            })
            .send()
    }

    const entityList = useMemo(() => {
        if (!isModer) {
            return [
                {
                    label: t('teams.adminPage.entities.projects'),
                    value: 'projects'
                },
                {
                    label: t('teams.adminPage.entities.teams'),
                    value: 'organizations',
                },
                {
                    label: t('teams.adminPage.entities.modules'),
                    value: 'modules',
                }
            ]
        }
        return [{
            label: t('teams.adminPage.entities.projects'),
            value: 'projects'
        }, {
            label: t('teams.adminPage.entities.cached_projects'),
            value: 'main'
        }, {
            label: t('teams.adminPage.entities.teams'),
            value: 'organizations',
        }, {
            label: t('teams.adminPage.entities.competitions'),
            value: 'competitions_new',
        }, {
            label: t('teams.adminPage.entities.modules'),
            value: 'modules',
        }, {
            label: t('teams.adminPage.entities.people'),
            value: 'people',
        }
        ]
    }, [t, isModer])

    useEffect(() => {
        if (team && team.teamId && isChangesSaved) {
            if (throttle.current) {
                clearTimeout(throttle.current);
                throttle.current = null;
            }

            setStatusText(t('saving'));

            throttle.current = setTimeout(() => {
                if (team && team.teamId) {
                    const courseActualPrice = coursePrice && Number(coursePrice?.replace(/\s/g, ''))
                    const computeModerationType = channelType === ModerationType.Channel ?
                        ModerationType.Channel : teamModerationType.value;
                    const computeContext = channelType === ModerationType.Channel ?
                        ['channels'] : channelType === ModerationType.ChannelGroupOrCourse ?
                            ['channel_course_and_groups']
                            : teamContexts
                    const computeEntityType = channelType === ModerationType.Channel ?
                        'channels' : channelType === ModerationType.ChannelGroupOrCourse ?
                            'channel_course_and_groups'
                            : teamEntityType
                    const copy: Team<'Global'> = { ...team };


                    copy.name = cloneValue(teamName)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    //@ts-ignore
                    copy.nameExtra = cloneValue(teamNameExtra)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    // //@ts-ignore
                    // copy.longread = teamLongread;
                    copy.about = cloneValue(teamAbout)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    //@ts-ignore
                    copy.aboutExtra = cloneValue(teamAboutExtra)?.map((i) => ({ ...i, name: i?.name?.trim() }));
                    copy.route = teamRoute;
                    //@ts-ignore
                    copy.phone = (teamPhone !== INITIAL_PHONE ? teamPhone : '');
                    //@ts-ignore
                    copy.email = teamEmail;
                    //@ts-ignore
                    copy.contexts = computeContext
                    //@ts-ignore
                    copy.lmsCourseAuthorIds = teamAuthors.map(x => x.designerId);
                    copy.ownersIDs = teamOwners.map(x => x.designerId);
                    copy.membersIDs = teamMembers.map(x => x.designerId);
                    //@ts-ignore
                    copy.isTitleHidden = titleIsHidden;
                    //@ts-ignore
                    copy.contextName = isChannel ? team?.teamId : teamContextName;
                    //@ts-ignore
                    copy.moderationType = computeModerationType;
                    //@ts-ignore
                    copy.teamProjectsFilter = teamProjectsFilter.value;
                    //@ts-ignore
                    copy.lmsModuleFormat = courseType;
                    //@ts-ignore
                    copy.lmsCourseType = lmsCourseType;
                    //@ts-ignore
                    copy.lmsCourseTerm = lmsCourseTerm;
                    //@ts-ignore
                    copy.lmsCover = lmsCardFormat;
                    //@ts-ignore
                    copy.lmsModulePrice = courseActualPrice;
                    //@ts-ignore
                    copy.lmsModuleStartDate = fixTimezoneOffsetToSave(courseStartDate);
                    //@ts-ignore
                    copy.moderRole = teamModerRole;
                    copy.tagIds = teamTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.ownerTagIds = teamOwnerTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.managedTagIds = teamManagedTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.educationTagIds = teamEducationTags.map(x => x.tagId);
                    //@ts-ignore
                    copy.isCanCreateProject = teamIsCanCreateProject;
                    //@ts-ignore
                    copy.isSortingHidden = sortingHidden;
                    //@ts-ignore
                    copy.isShowTeamEmblem = isChannel ? true : isShowTeamEmblem;
                    //@ts-ignore
                    copy.isLargeTabs = teamIsLargeTabs;
                    //@ts-ignore
                    copy.isShowEmployeesLink = teamIsShowEmployeesLink;
                    //@ts-ignore
                    copy.isShowTeachersCheckbox = teamIsShowTeachersCheckbox;
                    copy.isSwitchButtonVisible = teamSwitchButtonVisible;
                    //@ts-ignore
                    copy.isShopVisible = teamIsShopVisible;
                    //@ts-ignore
                    copy.showQu = teamShowQu;
                    //@ts-ignore
                    copy.initialTab = '';
                    //@ts-ignore
                    copy.isLongreadDisabled = teamIsLongreadDisabled;
                    //@ts-ignore
                    copy.isShowLongread = showCaseViewType === ShowCaseViewType.landing;
                    //@ts-ignore
                    copy.isShowFeed = channelType === ModerationType.Channel ? (feedViewType === 1) : Boolean(0)
                    //@ts-ignore
                    copy.isShowGridFirst = showCaseViewType === ShowCaseViewType.showcase;
                    //@ts-ignore
                    copy.visibleAnchorsLimit = teamAnchorLimit || INITIAL_ANCHOR_LIMIT;
                    //@ts-ignore
                    copy.coverLink = coverLink;
                    //@ts-ignore
                    copy.coverTitle = cloneValue(coverTitle)?.map((i) => ({ ...i, name: i?.name?.trim() }));;
                    //@ts-ignore
                    copy.isSmallName = isSmallName;
                    //@ts-ignore
                    copy.isShowFullDescription = isShowFullDescription;
                    //@ts-ignore
                    copy.isMinimalName = isMinimalName;
                    //@ts-ignore
                    copy.isMainTitleHidden = isMainTitleHidden;
                    //@ts-ignore
                    copy.isShowTeamLandingWithProjects = isShowTeamLandingWithProjects;
                    //@ts-ignore
                    copy.isLinksInsteadTitle = isLinksInsteadTitle;
                    //@ts-ignore
                    copy.mainFilter = {
                        ...teamMainFilter,
                        contexts: !!teamMainFilter.contexts?.length ? teamMainFilter.contexts : null,
                        globalTypes: !!teamMainFilter.globalTypes?.length ? teamMainFilter.globalTypes : null,
                        tagIds: !!teamMainFilter.tags?.length ? teamMainFilter.tags.map(t => t.tagId) : null,
                        requiredTagIds: !!teamMainFilter.requiredTags?.length ? teamMainFilter.requiredTags.map(t => t.tagId) : null,
                        exceptedTagIds: !!teamMainFilter.exceptedTags?.length ? teamMainFilter.exceptedTags.map(t => t.tagId) : null,
                        tags: null,
                        requiredTags: null,
                        exceptedTags: null,
                        useCalendar: teamMainFilter.useCalendar,
                    };
                    //@ts-ignore
                    copy.additionalInfo = { 
                        ...team?.additionalInfo, 
                        color: userColor, 
                        titlePosition: userTitlePosition,
                    };
                    //@ts-ignore
                    copy.buttons = teamButtons;
                    //@ts-ignore
                    copy.competences = teamCompetences;
                    //@ts-ignore
                    copy.competenceYear = teamCompetenceYear;
                    //@ts-ignore
                    copy.navButtons = teamNavButtons;
                    //@ts-ignore
                    copy.coverLink = coverLink;
                    //@ts-ignore
                    copy.mainEntityType = computeEntityType

                    //@ts-ignore
                    copy.outOfStockLink = outOfStockLink;
                    //@ts-ignore
                    copy.isArchiveItemsShop = isArchiveItemsShop;
                    //@ts-ignore
                    copy.hideShopWord = hideShopWord;
                    //@ts-ignore
                    copy.isHideParticipantsShop = isHideParticipantsShop;
                    //@ts-ignore
                    copy.shopNavButtons = shopNavButtons;
                    //@ts-ignore
                    copy.outOfStockMessage = outOfStockMessage;
                    //@ts-ignore
                    copy.shopAbout = shopAbout;
                    //@ts-ignore
                    copy.longreadType = teamLongreadType;
                    //@ts-ignore
                    copy.longreadEntityLink = longreadEntityLink;
                    //@ts-ignore
                    copy.replaceLongreadId = replaceLongreadId;

                    //@ts-ignore
                    copy.additionalContent = additionalContent;
                    //@ts-ignore
                    copy.shopTabs = shopTabs.map(x => {
                        return {
                            ...x,
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null
                            }
                        };
                    });

                    //@ts-ignore
                    copy.topLinks = topLinks.map(x => {
                        return {
                            ...x,
                        };
                    });

                    //@ts-ignore
                    copy.tabs = teamTabs?.filter((tab) => {
                        return tab?.name?.some((i) =>  i?.name !== '')
                    }).map(x => {
                        return {
                            ...x,
                            //@ts-ignore
                            color: x.color || '',
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                ownerTagIds: !!x.filter.ownerTags?.length ? x.filter.ownerTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null,
                                ownerTags: null,
                                useCalendar: x.filter.useCalendar,
                            }
                        };
                    });

                    //@ts-ignore
                    copy.categories = teamCategories.map(x => {
                        return {
                            ...x,
                            filter: {
                                ...x.filter,
                                contexts: !!x.filter.contexts?.length ? x.filter.contexts : null,
                                globalTypes: !!x.filter.globalTypes?.length ? x.filter.globalTypes : null,
                                tagIds: !!x.filter.tags?.length ? x.filter.tags.map(t => t.tagId) : null,
                                requiredTagIds: !!x.filter.requiredTags?.length ? x.filter.requiredTags.map(t => t.tagId) : null,
                                exceptedTagIds: !!x.filter.exceptedTags?.length ? x.filter.exceptedTags.map(t => t.tagId) : null,
                                tags: null,
                                requiredTags: null,
                                exceptedTags: null
                            }
                        };
                    });

                    if (isChannel) {
                        copy.channelCommentBlackListIds = blackListIds
                        copy.channelCommentWhiteListIds = whiteListIds
                        copy.channelCommentClosedStatus = channelCommentClosedStatus
                        copy.channelCommentMsg = channelCommentMsg
                    }

                    updateLg();

                    TeamAPI.Update(copy)
                        .then((e) => {
                            if (e.status !== 200) {
                                setIsUpdateError(true)
                            }
                            else {
                                if (localGroups?.length && groups?.length) {
                                    const hasOrderChanged = localGroups.some((localGroup, index) => {
                                        const originalGroup = groups[index];
                                        return !originalGroup || localGroup.id !== originalGroup.id;
                                    });
                                    
                                    if (hasOrderChanged) {
                                    const groupsToUpdate = localGroups.map((group, index) => ({ id: group.id, position: index }));
                                    
                                     const updatePromises = localGroups.map((group, index) => 
                                         //@ts-ignore
                                         GroupAPI.Update({ ...group, position: index })
                                     );
                                     
                                     Promise.all(updatePromises)
                                         .then(() => {
                                             refreshGroups();
                                         })
                                         .catch((error: any) => {
                                             console.error('Error updating group positions:', error);
                                             refreshGroups();
                                         });
                                    }
                                }
                                
                                setTimeout(() => {
                                    setStatusText(t('editing_saved'))
                                    setUpdatedTeam(true)
                                    setTeamName(copy.name)
                                }, 1000);
                            }
                        })
                        .catch(() => setIsUpdateError(true));
                }
            }, 1000);
        }
    }, [
        t,
        team,
        teamName,
        teamNameExtra,
        teamAbout,
        teamAboutExtra,
        teamRoute,
        teamContexts,
        feedViewType,
        showCaseViewType,
        coverTitle,
        teamAuthors,
        teamOwners,
        teamMembers,
        teamContextName,
        teamModerationType,
        isChannel,
        teamProjectsFilter,
        additionalContent,
        teamSwitchButtonVisible,
        teamModerRole,
        teamPhone,
        teamEmail,
        teamTags,
        teamOwnerTags,
        teamManagedTags,
        teamEducationTags,
        teamIsCanCreateProject,
        sortingHidden,
        useCalendarEnabled,
        isShowTeamEmblem,
        titleIsHidden,
        teamIsLargeTabs,
        teamIsShowEmployeesLink,
        teamIsShowGridFirst,
        teamIsShopVisible,
        teamShowQu,
        teamIsShowTeachersCheckbox,
        teamAnchorLimit,
        teamButtons,
        teamNavButtons,
        teamTabs,
        topLinks,
        teamCategories,
        coverLink,
        hasLongread,
        teamMainFilter,
        teamEntityType,
        isSmallName,
        isMinimalName,
        isMainTitleHidden,
        isShowTeamLandingWithProjects,
        isLinksInsteadTitle,
        // currentForm,
        teamShowLg,
        teamCompetenceYear,
        teamCompetences,
        userColor,
        userTitlePosition,
        vtype,
        isChangesSaved,
        courseType,
        lmsCourseType,
        lmsCourseTerm,
        lmsCardFormat,
        coursePrice,
        courseStartDate,
        teamIsLongreadDisabled,
        outOfStockLink,
        isArchiveItemsShop,
        hideShopWord,
        canSaveLgText,
        isHideParticipantsShop,
        shopNavButtons,
        shopTabs,
        outOfStockMessage,
        shopAbout,
        replaceLongreadId,
        longreadEntityLink,
        teamLongreadType
    ]);

    const anchorTypes = useMemo(() => {
        if (!!longread?.length) {
            //@ts-ignore
            return longread?.filter((post) => !!post?.anchorText?.length)?.reduce((acc, val) => {
                //@ts-ignore
                return [...acc, { label: val.anchorText, value: val?.postId }]
            }, [])
        }
    }, [longread])

    //@ts-ignore
    const hasAnchors = useMemo(() => (!!anchorTypes?.length), [longread, anchorTypes])

    const onChannelDelete = () => {
        const confirmation = window.confirm('Вы действительно хотите удалить канал?');

        if (confirmation) {
            API.request('/api/Team/UpdateStatus')
                .endpoint(Endpoints.geograffee)
                .post()
                .body({
                    "teamId": team?.teamId,
                    "status": ARCHIVE_TEAM_STATUS
                })
                .send()
                .then((r) => {
                    setIsTeamDeleted(true)
                    toasts.info('Успешно')
                    history.replace(CreateLinkTo.designer(team.ownersIDs?.[0] || ''))
                }).catch((err) => toasts.error('Возникли проблемы'))
        }
    }

    const onToggleChannelStatus = async (canPublish?: boolean) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": team?.teamId,
            "status": canPublish ? PUBLISHED_TEAM_STATUS : DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
        .catch((err) => toasts.error('Возникли проблемы'))
    }

    const onBackClick = () => {
        onModalStateChange(false, null);
        setQueryParams({ tab: null })
    }

    const backToLongread = () => {
        setQueryParams({ tab: 'lg', idform: undefined })
        onModalStateChange(true, { mode: "lg", index: 2 })
    }

    const getRedirectIfBackClick = useCallback(() => {
        if (!!mobileEditorOpen) {
            setMobileEditorAction('close');
            setMobTextBlockLength(0);
            onModalStateChange(true, { mode: "lg", index: 2 })
            setTimeout(() => {
                setMobileEditorAction('');
                setMobileEditorOpen(false);
            }, 1000)
            return;
        }

        switch (modalSettings?.mode) {
            case 'mainFilter':
            case 'tab':
            case 'category':
            case 'group':
            case 'discipline':
            case 'import-groups':
                return onModalStateChange(false, null);
            case 'lg':
            case 'shop':
                return onBackClick()
            case 'forms':
                return idform?.length ? backToLongread() : onModalStateChange(false, null);
            default:
                if (isOwner) {
                    history.push(`/teams/${teamContextName || ''}`);
                } else {
                    history.push(CreateLinkTo.teamAdmin());
                }
                return;
        }
    }, [
        idform,
        isOwner,
        history,
        modalSettings,
        mobileEditorOpen,
        teamContextName,
        onBackClick,
        backToLongread,
    ]);

    const onChannelQuit = useCallback(() => {
        history.push('/teams/' + team?.teamId)
    } , [canSaveLgText, team])


    const primaryButtonClick = useCallback((): void => {
        if (profile) {
            if (!!mobileEditorOpen) {
                setMobileEditorAction('add');
                setMobTextBlockLength(0)
                setTimeout(() => {
                    setMobileEditorAction('');
                    setMobileEditorOpen(false);
                }, 1000);
                return;
            }
            setStatusText(t('save'));
            toasts.info(t('teams.admin.msg.save'));
            setIsChangesSaved(true);

            if (!!idform?.length) {
                setTimeout(() => backToLongread(), 1000)
            }
            if (isChannel) {
                onToggleChannelStatus(true)
                setShowLoader(true);
                setTimeout(() => {
                    setShowLoader(false);
                    window.open(window.location.origin + '/teams/' + team?.teamId, '_SELF')
                }, 3000)
            }
        }
    }, [profile, history, t, mobileEditorOpen, isChannel, idform]);

    const secondaryButtonText = useMemo(() => {
        switch (modalSettings?.mode) {
            case 'lg':
            case 'tab':
            case 'category':
            case 'mainFilter':
            case 'forms':
            case 'import-groups':
                return t("nav.back")
            default:
                return t("nav.exit_other")
        }
    }, [isMobile, modalSettings, t])

    const statusPfx = useMemo(() => (modalSettings?.mode === 'lg'), [modalSettings]);

    const previewButtonVisible = useMemo(
        () => ((modalSettings?.mode === 'lg' || !modalSettings) && (isOwner || isModer || hasAccessToTeamsAdmin))
        , [modalSettings, isOwner, isModer, hasAccessToTeamsAdmin]);

    const previewButtonEnabled = useMemo(
        () => {
            const hasName = teamName?.every(({ name }) => !!name)
            return hasName;

        }, [teamName, teamAbout, hasTeamBG, hasTeamBGEn])

    const onPreviewClick = useCallback(() => {
        if (previewButtonVisible) {
            !modalSettings
                ? history.push(`/team-preview/${team.teamId}`)
                : history.push(CreateLinkTo.previewTeamLongread(team.teamId))
            setIsPreview(true)
        }
    }, [previewButtonVisible, modalSettings, history, team, hasLongread, teamContextName])


    const canEditSelfLG = useMemo
        (() => (hasLongread && teamLongreadType === TeamLongreadType.SelfLongread)
            , [hasLongread, team?.longreadEntityLink, teamLongreadType])

    const PortalMenu = useMemo(() => {
        const outer = document.getElementById('navbar-portal');

        if (!outer) {
            return null;
        }

        return createPortal(
            <NavbarCreate
                previewButtonVisible={isChannel ? false : previewButtonVisible}
                previewButtonEnabled={previewButtonEnabled}
                primaryButtonEnabled={canSaveLgText}
                primaryButtonText={t('save')}
                secondaryButtonText={secondaryButtonText}
                mobileEditorOpen={mobileEditorOpen}
                errors={errors}
                toggleMobileEditor={setMobileEditorOpen}
                stateText={statusText}
                onSecondaryClick={getRedirectIfBackClick}
                onPrimaryClick={primaryButtonClick}
                showStatusPfx={statusPfx}
                viewTypeVisible={modalSettings?.mode === 'lg'}
                onPreviewClick={onPreviewClick}
                isLMSModule={team?.moderationType == ModerationType.LMS}
                primaryButtonVisible={!isChannel}
                secondaryButtonVisible={!isChannel}
            />,
            outer,
        );
    }, [isChannel, getRedirectIfBackClick, statusText, canSaveLgText, previewButtonEnabled, mobileEditorOpen, primaryButtonClick, t, secondaryButtonText, statusPfx, modalSettings, errors]);

    const onTeamAuthorsChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamAuthors(authors);
    };

    const onTeamOwnersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamOwners(authors);
    };

    const onTeamMembersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
        setTeamMembers(authors);
        setIsChangesSaved(true);
    };

    const onTeamButtonAdd = useCallback(() => {
        if (maxButtonsCount) {
            const hasLgButton = teamButtons.some((i) => !!i?.isRequired);
            toasts.error(`Максимальное количество кнопок - ${hasLgButton ? MAX_TEAM_BUTTONS + LG_BUTTON : MAX_TEAM_BUTTONS}`);
            setTeamButtons(teamButtons.slice(0, 4));
            return;
        }
        const buttons = [...teamButtons];
        buttons.push({
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        });
        setTeamButtons(btns => [
            ...btns,
            {
                type: 'filled',
                text: createEmptyLangObject('', ['ru', 'en']),
                textMobile: createEmptyLangObject('', ['ru', 'en']),
                href: createEmptyLangObject('', ['ru', 'en']),
                isRequired: false,
                actionType: '',
                anchor: { label: '', value: '' },
            }
        ]);
    }, [teamButtons, maxButtonsCount, toasts]);

    const onTeamNavButtonAdd = useCallback(() => {
        const buttons = [...teamNavButtons];
        if (buttons.length === 0) {
            buttons.push({
                type: 'filled',
                text: createEmptyLangObject('', ['ru', 'en']),
                textMobile: createEmptyLangObject('', ['ru', 'en']),
                href: createEmptyLangObject('', ['ru', 'en']),
                isRequired: false,
                actionType: '',
                anchor: { label: '', value: '' },
            });
            setTeamNavButtons(buttons);
        }

    }, [teamButtons, maxButtonsCount, toasts]);

    const onShopNavButtonAdd = useCallback(() => {

        const buttons = [...shopNavButtons];
        buttons.push({
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        });
        setShopNavButtons(buttons.sort((a, b) => b.isRequired ? -1 : 1));

        if (maxShopButtonsCount) {
            toasts.error('Максимальное количество кнопок - 3');
            setShopNavButtons(shopNavButtons.slice(0, 4));
            return;
        }

    }, [shopNavButtons, maxShopButtonsCount, toasts]);

    const onTeamButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...teamButtons];
        buttons[index] = button;
        setTeamButtons(buttons);
    }, [teamButtons]);

    const onTeamNavButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...teamNavButtons];
        buttons[index] = button;
        setTeamNavButtons(buttons);
    }, [teamNavButtons]);

    const onShopNavButtonChange = useCallback((button: ITeamButton, index: number) => {
        const buttons = [...shopNavButtons];
        buttons[index] = button;
        setShopNavButtons(buttons);
    }, [shopNavButtons]);

    const onTeamButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...teamButtons];
            buttons.splice(index, 1);
            setTeamButtons(buttons);
        }
    }, [teamButtons]);

    const onTeamNavButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...teamNavButtons];
            buttons.splice(index, 1);
            setTeamNavButtons(buttons);
        }
    }, [teamNavButtons]);

    const onShopNavButtonDelete = useCallback((index: number) => {
        const confirmation = window.confirm('Вы действительно хотите удалить кнопку?');
        if (confirmation) {
            const buttons = [...shopNavButtons];
            buttons.splice(index, 1);
            setShopNavButtons(buttons);
        }
    }, [shopNavButtons]);


    const { catalogs, isLoading: isCatalogsLoading } = useGetCatalogs("brnd", teamOwners?.length > 0 ? teamOwners[0]?.accountId : '')
    const [colT, setColT] = useState(Date.now());
    const [isCreateColButtonDisabled, setIsCreateColButtonDisabled] = useState(false);
    const { collection, isLoading: isCollectionLoading } = useGetCollection(team?.teamId, colT)

    const onTeamTabChange = useCallback((type: TabType, tab: ITeamTab, index: number) => {
        const tabIndex: any = {
            [TabType.tab]: teamTabs,
            [TabType.category]: teamCategories,
            [TabType.shop]: shopTabs,
        };
        const editedTabs: ITeamTab[] = tabIndex[type];

        const tabs = (tab.isMain && !editedTabs[index].isMain)
            ? editedTabs.map((x, i) => ({
                ...x,
                isMain: i === index || (x.isMain && x.category !== tab.category)
            }))
            : [...editedTabs];

        tabs[index] = tab;

        if (type === TabType.tab) {
            setTeamTabs(tabs);
        }
        if (type === TabType.category) {
            setTeamCategories(tabs);
        }
        if (type === TabType.shop) {
            setShopTabs(tabs);
        }
    }, [teamTabs, teamCategories, shopTabs, teamIsLargeTabs]);



    const onTeamCoverLinkChange = ({ target }: any) => {
        const { value } = target;
        setCoverLink({ ...coverLink, path: value })
    };

    const onTeamLinkTabToggle = () => setCoverLink({ ...coverLink, newTab: !coverLink?.newTab })

    const onTeamTabSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        setTeamTabs(arrayMoveImmutable(teamTabs, oldIndex, newIndex));
    }, [teamTabs]);

    const onGroupDragEnd = useCallback((result: any) => {
        if (!result.destination || !localGroups?.length || result.source.index === result.destination.index) {
            return;
        }
        
        const newGroups = arrayMoveImmutable(localGroups, result.source.index, result.destination.index);
        setLocalGroups(newGroups);
        
        setIsChangesSaved(false);
    }, [localGroups]);

    const onTeamTabDelete = useCallback((index: number) => {
        if (window.confirm('Вы действительно хотите удалить вкладку?')) {
            setTeamTabs(teamTabs.filter((_, i) => i !== index));
        }
    }, [teamTabs]);

    /**
     * ПОКА ЧТО ОСТАВИТЬ, ЧТОБЫ МОЖНО БЫЛО УДАЛИТЬ ФОРМУ ИЗ ЛОНГРИДА
     */
    // const onDeleteLongreadFormPost = (id: string) => {
    //     //@ts-ignore
    //     const post = longread?.find((lg) => !!lg?.additionalInfo?.length ? lg?.additionalInfo?.[0]?.value === id : undefined);
    //     console.log('TEST', post)
    //     //@ts-ignore
    //     if (post?.postId) {
    //         //@ts-ignore
    //         urlApi().deleteLgPost(post?.postId)
    //     } 
    // }

    // useEffect(() => {
    //     onDeleteLongreadFormPost("7b05540b85704343866e52dbf07922d2")
    // } , [longread])
    const actualForms = forms;

    const onFormDelete = useCallback((id: string) => {
        if (window.confirm('Вы действительно хотите удалить форму и пост в лонгриде?')) {
            //@ts-ignore
            FormAPI.Delete({ formId: id }).then(() => {
                //@ts-ignore
                const post = longread?.find((lg) => lg?.additionalInfo?.[0]?.value === id);
                //@ts-ignore
                if (post?.postId) {
                    //@ts-ignore
                    urlApi().deleteLgPost(post.postId).then(() => setDate(Date.now()));
                }
                setDate(Date.now());
            });
        }
    }, [longread]);

    const onGroupDelete = (id: string) => {
        if (window.confirm('Вы действительно хотите удалить группу?')) {
            //@ts-ignore
            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/Group/Delete')
                .post()
                .addQuery('id', id)
                .send()
                .then(() => {
                    setDate(Date.now());
                    //@ts-ignore
                    onModalStateChange(undefined);
                    toasts.info('Группа удалена');
                });
        }
    }

    const onCoverLinkDelete = () => {
        if (window.confirm('Вы действительно хотите удалить ссылку для обложки?')) {
            setCoverLink(linkType);
        }
    }

    const onModalStateChange = (show: boolean, settings: IModalSettings | null) => {
        if (show && !settings) {
            setIsError(true);
        }
        else {
            window.scrollTo(0, 0);
            !show && setShowModal(show);
            setModalSettings(settings);
            show && setShowModal(show);
        }
    };
    const idRef = useRef(id);

    useEffect(() => {
        idRef.current = id;
    }, [id]);

    const updateTeam = useCallback(() => {
        if (!idRef.current) {
            console.error('No ID provided');
            return;
        }

        TeamAPI.Get({ idTeam: idRef.current })
            .then((value) => value.json() as Promise<Team<'Global'>>)
            .then((value) => {
                if (value.teamId) {
                    setTeam(value);
                    setIsError(false);
                } else {
                    setTeam(undefined);
                    setIsError(true);
                }
            })
            .catch((reason) => {
                console.error(reason);
                setTeam(undefined);
                setIsError(true);
            });
    }, []);


    const uploaderCallback = useCallback(
        // @ts-ignore
        (fileId) => {
            if (!fileId) {
                return null;
            }

            const localization = teamBGLangRef.current ? 'en' : i18n.language;

            return UploadFileAPI.Upload({
                fileId,
                profileId: teamIdRef?.current,
                service: 'geography',
                entityType: 'geographyteamavatar',
                localization,
            })
                .then((res) => {
                    sipRef.current.uploader.uploader.uppy.reset();
                    updateTeam();
                    return res;
                });
        },
        [teamIdRef, i18n.language, teamBGLang, updateTeam]
    );

    const createNewForm = () => {
        //@ts-ignore
        urlApi().createForm({ ...createDefaultForm(), teamId: team?.teamId ?? '' }).then((r) => r.json()).then((formId) => {
            setDate(Date.now())
            //@ts-ignore
            FormAPI.GetList({ teamIds: [team?.teamId], limit: 100, page: 1 })
            .then((r) => {
                return r.json()
            })
            .then((r) => {
                //@ts-ignore
                setCurrentForm(r.data.find(form => form.formId === formId))
                onModalStateChange(true, { mode: "forms", index: -1 })
            })
        })
    }

    useEffect(() => {
        if (!team) return;

        let buttons = (team.buttons as ITeamButton[]).map(btn =>
            computeDataWithLang(btn)
        );

        if (hasLongread) {
            const missing = (team?.moderationType == ModerationType.LMS ? REQUIRED_BUTTONS_LMS : REQUIRED_BUTTONS)
                .filter(rb => !team.buttons.some(b => b.actionType === rb.actionType))
                .map(rb => computeDataWithLang(rb));
            buttons = [...missing, ...buttons];
        } else {
            buttons = buttons.filter(btn => !btn.isRequired);
        }

        buttons = buttons.slice(0, hasLongread ? MAX_TEAM_BUTTONS : MAX_TEAM_BUTTONS - 1);

        setTeamButtons(buttons);
    }, [team, i18n.language, hasLongread]);

    const createGroup = () => {
        //@ts-ignore
        GroupAPI.Add({ ...createDefaultGroup(), ownerTeamId: team.teamId })
            .then((r) => r.json()).then((r) => {
                setCurrentGroup(r)
                setTimeout(() => {
                    onModalStateChange(true, { mode: "group", index: 4 });
                    setDate(Date.now())
                } , 1000)
            })
    }

    const onLandingVisibleChange = () => {
        if (teamIsShowGridFirst) {
            setTeamShowLg(true);
            setTeamIsShowGridFirst(false);
            setShowCaseViewType(ShowCaseViewType.landing);
        } else {
            setTeamIsShowGridFirst(true);
            setTeamShowLg(false);
            setShowCaseViewType(ShowCaseViewType.showcase);
        }
    }
    const onTitleVisibleChange = useCallback(() => {
        if (showCaseTitleType) {
            setShowCaseTitleType(ShowCaseTitleType.text);
            setIsLinksInsteadTitle(false);
        } else {
            setShowCaseTitleType(ShowCaseTitleType.link);
            setIsLinksInsteadTitle(true);
            if (topLinks?.length === 0) {
                setTopLinks([{
                    name: createEmptyLangObject('', ['ru', 'en']),
                    link: ''
                }]);
            }
        }
    }, [showCaseTitleType, topLinks]);

    const onToggleLgView = () => {
        modal.show('artz-legals-load', { text: "Сохранение данных" })

        setIsChangesSaved(true)

        setTimeout(() => {
            setDate(Date.now())
            modal.hide();
            onModalStateChange(true, { mode: "lg", index: 2 })
        }, 3000)
    }

    const onToggleCourseCompletionModal = () => {
        modal.show('confirmCourseCompletionModal', 
            { 
                teamId: team.teamId, 
                handleClose: () => modal.hide(), 
                handleComplete: () => {
                    API.request()
                    .endpoint(Endpoints.geograffee)
                    .url("/api/lms/CompleteCourse")
                    .get()
                    .addQuery("teamId", team.teamId)
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        modal.hide()
                        toasts.info(t('teams.adminPage.modal.confirmCourseCompletion.course_completed'))
                        setIsCourseCompleted(true);
                    })
                    .catch((e) => console.error(e));
                } 
            });
    }

    const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));

    const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
            dimensions?: boolean;
            size?: boolean;
            ratio?: boolean;
            type?: boolean;
        } = {};

        if (!isOwner && !isModer && !hasAccessToTeamsAdmin) return false;

        const loadFile = () => new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = function () { // file is loaded
                const img = new Image();

                img.onload = function () {
                    const {
                        width,
                        height,
                    } = img;
                    resolve({
                        width,
                        height,
                    })
                };

                //@ts-ignore
                img.src = fr.result; // is the data URL because called with readAsDataURL
            };
            fr.readAsDataURL(files[0]);
        })

        //@ts-ignore
        const { height, width } = await loadFile();

        if (!['image/jpeg'].includes(files?.[0]?.type)) {
            toasts.error('Допустимые форматы: jpg');
            failedChecks.size = true;
        }

        const {
            size: failedSize,
            dimensions: failedDimensions,
            ratio: failedRatio,
        } = failedChecks;

        if (failedSize || failedDimensions || failedRatio) {
            sipRef.current.uploader.inputRef.current.value = '';

            return false;
        }

        return true;
    }, [isOwner, isModer, hasAccessToTeamsAdmin]);

    const sip = useSimpleUploader(uploaderCallback, uploadValidator);
    sipRef.current = sip;

    const mainHeader = useMemo(
        () => {
            if (isChannel) {
                return t('teams.adminPage.channel_settings')
            } else if (modalSettings && modalSettings.mode === 'mainFilter') {
                return t('teams.adminPage.main_filter')
            }

            return t('teams.adminPage.main_header')

        }, [modalSettings, t, isChannel])

    const showAddDescription = useMemo(() => (modalSettings && modalSettings.mode === 'mainFilter'), [modalSettings])

    const onDeleteBG = () => {
        modal.show('confirmDeleteCoverModal', {
            teamId: team.teamId,
            teamBGLang,
            onDelete: updateTeam,
            handleClose: modal.hide,
        });
    }

    const teamBG = useMemo(() => {
        if (hasTeamBG || (teamBGLang && hasTeamBGEn)) {
            return (
                <CoverWrapper justify="flex-start" direction="column" directionMobile="column" align={'flex-start'} alignMobile="flex-start">
                    <FlexBox className={'cover-container'} direction={'row'} directionMobile="row" offsetTopMobile={10}>
                        {teamBGLang ? <TeamUploadText>{team?.titleImages_en?.[0]?.url?.split('/')?.slice(-1)}</TeamUploadText> : <TeamUploadText>{team?.titleImages?.[0]?.url?.split('/')?.slice(-1)}</TeamUploadText>}
                        <FlexBox direction="row" directionMobile="row" offsetLeft={12} offsetLeftMobile={12} style={{ position: 'relative', cursor: 'pointer' }}>
                            <EditIcon24 />
                            {/*@ts-ignore*/}
                            <TeamUploadContainer team={team} teamId={team?.teamId ?? ''} fileInput={sip} />
                        </FlexBox>
                        <FlexBox offsetLeft={8} offsetLeftMobile={8}>
                            <DeleteIcon fill={'#909090'} onClick={onDeleteBG} />
                        </FlexBox>
                    </FlexBox>

                    {!isChannel && <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetLeftMobile={0}>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isShowTeamEmblem}
                            label={''}
                            onClick={() => setIsShowTeamEmblem(!isShowTeamEmblem)}
                            isTeamEdit
                        />
                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_team_emlem')}</span>
                    </FlexBox>}

                </CoverWrapper>
            )
        }
    }, [isChannel, hasTeamBG, team, sip, teamBGLang, hasTeamBGEn]);

    const tabList = useMemo(() => {
        return TABS.filter(tab => teamModerationType?.value !== 3 ? tab.name !== 'lms' : true).reduce((res: any, { name, path }: any) => {
            return {
                ...res,
                [path]: t(`teams.adminPage.tabs.${name}`),
            }
        }, {})
    }, [TABS, t, teamModerationType]);

    const channelTabsList = useMemo(() => {
        const isPersonalChat = channelType === ModerationType.Channel
        const tabs = [{ name: 'main', path: 'about' }, { name: isPersonalChat ? 'feed' :'chat', path: isPersonalChat ? 'feed' :'chat' }];
        return tabs?.reduce((res: any, { name, path }: any) => {
            return {
                ...res,
                [path]: t(`teams.adminPage.tabs.${name}`),
            }
        }, {})
    }, [TABS, t, teamModerationType, channelType]);

    const teamContextsTypes = useMemo(() => {
        //@ts-ignore
        return teamContexts?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
    }, [teamContexts])

    const anchorLimitTypes = useMemo(() => {
        //@ts-ignore
        return anchorLimit?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
    }, [])


    const moderTypeBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <CommonInput
                    label={t('teams.adminPage.fields.moder_type')}
                    orientation="wide"
                    type={INPUT_TYPES.dropdown}
                    options={ModerationTypeListLocalized.filter(item => item.value !== 7) as any}
                    value={teamModerationType as any}
                    onChange={(item: any) => setTeamModerationType(item)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerationType, ModerationTypeListLocalized])

    const handleSetContext = (item) => {
        const slicedTeamRoute = teamRoute.split('/').pop();
        const currentContexts = item.value === 1 ? 'hsedesign' : slicedTeamRoute;
        const currentContextName = slicedTeamRoute;

        const defaultEntity = item.value === 3 ? 'modules' : 'projects';

        setTeamMainFilter({ ...teamMainFilter, contexts: [currentContexts || ''] })
        setTeamContextName(currentContextName || team?.contextName || '')
        setTeamModerationType(item)
        setTeamEntityType(defaultEntity)
    }
    const contentBlock = useMemo(() => {
        const filteredOptions = ModerationTypeListLocalized.filter(item =>
            item.value === 1 ||
            item.value === 5 ||
            item.value === 3 ||
            item.value === 6
        ).map(item => {

            let tooltipText = '';
            switch (item.value) {
                case 1:
                    tooltipText = 'Любой контент – размещение любых проектов на страницу (витрину) организации';
                    break;
                case 5:
                    tooltipText = 'Свой контент – размещение проектов администраторов и участников организации. Для организации создается собственный тег организации';
                    break;
                case 3:
                    tooltipText = 'Свои учебные курсы – размещение курсов доп. образования, т.е. проектов специального формата (учебные модули с возможностью добавлять занятия, домашние задания, экзамены и т.п.)';
                    break;
                case 6:
                    tooltipText = 'Свой контент (без тега юнита) – формат, аналогичный "Своему контенту", но без создания тега организации';
                    break;
                default:
                    tooltipText = '';
            }

            return {
                ...item,
                label: (
                    <HintTooltip
                        positionY="default"
                        text={tooltipText}
                        z={6}
                        onWhiteBg
                    >
                        <span>{item.label}</span>
                    </HintTooltip>
                )
            };
        });

        const dropdownValueOptions = ModerationTypeListLocalized.filter(item =>
            item.value === 1 ||
            item.value === 5 ||
            item.value === 3 ||
            item.value === 6
        );

        const currentValue = dropdownValueOptions.find(item => item.value === teamModerationType?.value) || dropdownValueOptions[0];

    return (
        <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
            <CommonLabel 
                label={t('teams.adminPage.fields.content_type')}
                required
            />
            <ProjectEditPageGridInput isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    options={filteredOptions as any}
                    value={currentValue as any}
                    onChange={(item: any) => handleSetContext(item)}
                />
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    )
}, [isS, t, teamModerationType, team])
    
    const coverBlock = useMemo(() => {        
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>

                <CommonLabel 
                    label={t('teams.adminPage.fields.cover')}
                    onLanguageChange={() => setImageLang(!teamBGLang)}
                    lang={teamBGLang ? 'en' : 'ru'}
                    useLangSwitcher={!isChannel}
                    {...(!isChannel ? { infoText: t('teams.adminPage.additionalFields.image_msg'), onWhiteBG: true} : { fixedHeight: true })}
                />
                <ProjectEditPageGridInput  isTeamEdit>
                    {hasTeamBG && !teamBGLang ? teamBG : teamBGLang && hasTeamBGEn ? teamBG : (
                        <UploaderWrapper onClick={() => setIsChangesSaved(true)} width={195} widthMobile={195} style={{ position: 'relative' }}>
                            <DefaultButton wh={195} whMob={195} style={{ ...(isChannel && isMobile && { marginTop: 8 }) }}>
                                {t('teams.adminPage.buttons.load')}
                            </DefaultButton>
                            {/*@ts-ignore*/}
                            <TeamUploadContainer team={team} teamId={team?.teamId ?? ''} fileInput={sip} />
                        </UploaderWrapper>
                    )}
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasTeamBG, hasTeamBGEn, teamBGLang, isChannel, isS, sip, t, team, teamBG])

    const coverLinkBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
                    {is1024 ? (
                        <ProjectEditPageGridInput gyMobile={16}  isTeamEdit directionMobile="column" justifyMobile="start" alignMobile="start">
                            <CommonInput
                                type={INPUT_TYPES.text}
                                label={t('teams.adminPage.fields.cover_link')}
                                infoText={t('teams.adminPage.additionalFields.cover_msg')} 
                                value={coverLink?.path}
                                placeholder={t('teams.adminPage.placeholders.adress')}
                                onChange={onTeamCoverLinkChange}
                            />
                            <FlexBox justify={'flex-start'}>
                                <MagicBoxRow
                                    className="checkbox checkbox-with-label"
                                    //@ts-ignore
                                    checked={coverLink?.newTab}
                                    label={t('teams.adminPage.additionalFields.new_tab')}
                                    onClick={() => onTeamLinkTabToggle()}
                                    isTeamEdit

                                />
                            </FlexBox>
                        </ProjectEditPageGridInput>
                    ) : (
                        <JustTable isTeamEdit>
                            <tr>
                                <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                        <CommonInput 
                                            type={INPUT_TYPES.text}
                                            label={t('teams.adminPage.fields.cover_link')}
                                            infoText={t('teams.adminPage.additionalFields.cover_msg')}
                                            value={coverLink?.path}
                                            placeholder={t('teams.adminPage.placeholders.adress')}
                                            onChange={onTeamCoverLinkChange}
                                        />
                                    </TableSortWrapper>
                                </td>
                                <td style={{ width: isS ? '70px' : '140px' }}>
                                    <FlexBox justify={'center'}>
                                        <MagicBoxRow
                                            className="checkbox checkbox-with-label"
                                            //@ts-ignore
                                            checked={coverLink?.newTab}
                                            label={t('teams.adminPage.additionalFields.new_tab')}
                                            onClick={() => onTeamLinkTabToggle()}
                                            isTeamEdit

                                        />
                                    </FlexBox>
                                </td>
                                <td style={{ width: isS ? '56px' : '336px' }}>
                                    <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                        {isS ? (
                                            <FlexBox offsetLeftMobile={8}>
                                                <BasketIcon fill={'#838382'} onClick={() => onCoverLinkDelete()} />
                                            </FlexBox>
                                        ) : (
                                            <DefaultButton wh={131} whMob={107} onClick={() => onCoverLinkDelete()}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                        )}

                                    </FlexBox>
                                </td>
                            </tr>
                        </JustTable>
                    )}

                </ProjectEditPageGridList>
            </ProjectEditPageGridRow>
        )
    }, [coverLink?.newTab, coverLink?.path, hasTeamBG, is1024, isMobile, isS, onTeamCoverLinkChange, onTeamLinkTabToggle, t])

    const coverTitleBlock = useMemo(() => {

        return (
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'}>
                <ProjectEditPageGridRow isTeamEdit style={{ width: '100%' }}>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        orientation="wide"
                        label={t('teams.adminPage.fields.cover_title')}
                        placeholder={''}
                        useLangSwitcher
                        //@ts-ignore
                        value={coverTitle}
                        onChange={(ev: any, lang?: string) => {
                            textAllowed(ev, (val) => setCoverTitle(
                                //@ts-ignore
                                setTextByLang(coverTitle, lang, val)
                            ))
                        }}
                    />
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [coverTitle, isS, t])

    const officeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} align="flex-start" center={!!teamTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.office')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamTags(tagsRaw);
                            },
                            ctx: ['cities'],
                            max: CITY_TAGS_COUNT,
                            isEdit: true,
                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={
                                !!teamTags?.length
                                    ? t('project_edit.change_cities')
                                    : t('project_edit.add_city')
                            }
                            reverse
                        />
                    </AddButton>

                    {!!teamTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        key={value.tagId}
                                        educational={value?.isEducationTag}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamTags])

    const phoneBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.phone')}
                    orientation="wide"
                    type={INPUT_TYPES.phone}
                    value={teamPhone}
                    onChange={(formattedValue: any) => {
                        setTeamPhone(formattedValue as string)
                    }}
                /> 
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamPhone])

    const emailBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.email')}
                    orientation="wide"
                    value={teamEmail}
                    onChange={(ev: any) => setTeamEmail(ev.target.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamEmail])

    const typeUnitBlock = useMemo(() => {

        if (isModer) {
            return (
                <ProjectEditPageGridRow isTeamEdit style={{marginTop: isS ? 24 : 40}} center={false} align={'flex-start'} alignMobile="flex-start">
                    <TeamContextInputWrapper 
                        direction={'row'} 
                        directionMobile="row" 
                        style={{ flexWrap: 'wrap' }}
                    >
                        <FlexBox direction="row" directionMobile="row" width={'100%'} align="center" alignMobile="center">
                            <CommonInput 
                                type={INPUT_TYPES.text}
                                value={contextString}
                                onChange={(ev: any) => setContextsString(ev.target.value)}
                                orientation="wide"
                                label={t('teams.adminPage.fields.type')}
                                resultComponent={<>
                                    {!!teamContextsTypes?.length && (
                                        <FlexBox direction='row' wrap={'wrap'} width={'100%'} offsetTop={24} offsetTopMobile={16} >
                                            {/*@ts-ignore*/}
                                            {teamContextsTypes?.map((item) =>
                                                <Item
                                                    
                                                    text={item?.value}
                                                    onClick={() => {
                                                        //@ts-ignore
                                                        setTeamContexts(
                                                        //@ts-ignore
                                                        teamContextsTypes?.map(({ value }) => value)?.filter((i: any) => {
                                                            return i !== item?.value
                                                        })
                                                        )
                                                    }}
                                                />
                                            )}
                                    </FlexBox>
                                )}
                            </>}
                            />
                            {!!contextString?.length && (
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                //@ts-ignore
                                setTeamContexts(
                                    //@ts-ignore
                                    [...(teamContextsTypes ? Object.values(teamContextsTypes)?.map(({ value }) => value) : []), contextString]
                                );
                                setContextsString('');
                            }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                            )}
                        </FlexBox>
                    </TeamContextInputWrapper>
                </ProjectEditPageGridRow>
            )
        }

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <TeamEditLabel isTeamEdit>
                    {t('teams.adminPage.fields.type')}
                </TeamEditLabel>
                <ProjectEditPageGridInput direction="column" directionMobile="column" isTeamEdit>
                    <Input.Dropdown
                        isMulti
                        value={teamContextsTypes}
                        onChange={(ev: any) => setTeamContexts(ev?.map((ctx: any) => ctx.value))}
                        options={TEAM_TYPES}
                        placeholder={t('teams.adminPage.fields.select_placeholder')}
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamContextsTypes, contextString])

    const handlePathBlur = useCallback(() => {
        if (!teamRoute) return;

        let newRoute = teamRoute.trim();

        if (/^https?:\/\//.test(newRoute)) {
            setTeamRoute(newRoute);
            return;
        }

        const currentBaseUrl = !isModer ? `https://${window.location.host}/teams/` : `https://`;

        if (!newRoute.startsWith(currentBaseUrl)) {
            const cleanPath = newRoute.replace(/^https?:\/\//, '').replace(/^\//, '');
            newRoute = currentBaseUrl + cleanPath;
        }

        setTeamRoute(newRoute);
    }, [teamRoute, setTeamRoute, isModer]);

    const pathBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    maxLength={1000}
                    label={t('teams.adminPage.fields.path')}
                    orientation="wide"
                    placeholder={t('teams.adminPage.placeholders.route')}
                    value={teamRoute}
                    onChange={(ev: any) => allowedCharactersWithNumbers(ev, setTeamRoute, toasts, t('teams.adminPage.errors.url_too_long'))}
                    onBlur={handlePathBlur}
                />
            </ProjectEditPageGridRow>
        )
    }, [handlePathBlur, isS, t, teamRoute, toasts])

    const privateBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.private')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamSwitchButtonVisible}
                        label={isS ? '' : t('teams.adminPage.additionalFields.private_msg')}
                        onClick={() => setTeamSwitchButtonVisible(!teamSwitchButtonVisible)}
                        component={isS ? '' : <InfoIcon msg={t('teams.adminPage.additionalFields.private_info')} stc />}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, t, teamSwitchButtonVisible])

    const disabledBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.longread_disabled')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsLongreadDisabled}
                        label={''}
                        onClick={() => setTeamIsLongreadDisabled(!teamIsLongreadDisabled)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, t, teamIsLongreadDisabled])


    const anchorLimitBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.anchor_limit')}
                    value={{ label: teamAnchorLimit, value: teamAnchorLimit }}
                    onChange={(ev: any) => setTeamAnchorLimit(ev.value)}
                    options={anchorLimitTypes as any}
                    orientation="wide"
                />
            </ProjectEditPageGridRow>
        )
    }, [anchorLimitTypes, hasLongread, isS, t, teamAnchorLimit])

    const teamContextBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.team_context')}
                    orientation="wide"
                    infoText={t('teams.adminPage.additionalFields.team_context_msg')}
                    value={teamContextName}
                    onChange={(value: any) => {
                        if (value.target.value.length > 300) {
                            toasts.error(t('teams.adminPage.errors.teamContextName_too_long'))
                            return
                        }
                        setTeamContextName(value.target.value)
                    }}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamContextName, toasts])

    const showWorksBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.show_works')}
                    orientation="wide"
                    options={TeamProjectsFilter_List}
                    value={teamProjectsFilter}
                    onChange={(item: any) => setTeamProjectsFilter(item?.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerationType.value, teamProjectsFilter, TeamProjectsFilter_List])

    const moderRoleBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.moder_role')}
                    orientation="wide"
                    value={teamModerRole}
                    onChange={(value: any) => setTeamModerRole(value.target.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamModerRole])

    const tagAppoitmentBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} align="flex-start" center={!teamOwnerTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <TeamEditLabel isTeamEdit style={{ whiteSpace: 'normal' }} align={'start'} alignMobile={'start'} offsetBottomMobile={!!teamOwnerTags?.length ? 0 : 16} className={'required-label'}>
                    {t('teams.adminPage.fields.tag_appoitment')}
                </TeamEditLabel>
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamOwnerTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamOwnerTags(tagsRaw);
                            },
                            isEdit: true,
                            global: true,
                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                        />
                    </AddButton>

                    {!!teamOwnerTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamOwnerTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamOwnerTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamOwnerTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        educational={value?.isEducationTag}
                                        key={value.tagId}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamOwnerTags])

    const tagForAddTeamBlock = useMemo(() => {
        const disabled = !isModer && teamModerationType.value === 1
        const handleClick = () => {
            if (disabled) return;
            modal.show('tags', {
                value: [...teamManagedTags],
                onChange: (tagsRaw: Tag[]) => {
                    setTeamManagedTags(tagsRaw);
                },
                isEdit: true,
                global: true,
            });
        };

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} center={!teamManagedTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.tag_for_add_team')} 
                    fixedHeight
                    onWhiteBG 
                    infoText={t('teams.adminPage.additionalFields.tag_msg')}
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={handleClick}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit

                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                            disable={disabled}
                        />
                    </AddButton>

                    {!!teamManagedTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamManagedTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamManagedTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamManagedTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        key={value.tagId}
                                        educational={value?.isEducationTag}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamManagedTags, teamModerationType, isModer])
    
    const competencesBlock = useMemo(() => {
        return (
            <FlexBox 
              offsetTop={24} 
              direction="column" 
              directionMobile="column" 
              width={'100%'} 
              align="center" 
              alignMobile="center"
              className="competences-search-container"
            >
              <FlexBox width={'100%'} gx={16}>
                <FlexBox direction="column" width="100%">
                  <CommonInput 
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.competences')}
                    value={competenceString}
                    orientation="wide"
                    placeholder={'Начните вводить название компетенции для поиска...'}
                    onChange={(ev: any) => {
                      setCompetenceString(ev.target.value);
                      if (competenceSearchError) {
                        setCompetenceSearchError(null);
                      }
                      if (allCompetenceResults.length > 0) {
                        setAllCompetenceResults([]);
                        setShowAllResults(false);
                      }
                    }}
                  />
                  {isSearchingCompetences && (
                    <span style={{ 
                      fontSize: '12px', 
                      color: '#666', 
                      marginTop: '4px',
                      fontStyle: 'italic'
                    }}>
                    Поиск...
                    </span>
                  )}
                </FlexBox>
              </FlexBox>
              
              {!!competenceSearchResults?.length && (
                <FlexBox width={'100%'} offsetTop={16} direction="column">
                  <FlexBox width={'100%'} align="center" gy={8}>
                    {allCompetenceResults.length > 10 && (
                        <DefaultButton 
                            wh={120} 
                            whMob={120}
                            onClick={() => setShowAllResults(!showAllResults)}
                        >
                            {showAllResults ? 'Скрыть' : 'Показать все'}
                        </DefaultButton>
                    )}
                  </FlexBox>
                  <FlexBox width={'100%'} offsetTop={8} direction="column" gy={8}>
                    {(showAllResults ? allCompetenceResults : competenceSearchResults).map((competence, index) => (
                      <CompetenceResult 
                        key={competence.id || index} 
                        width={'100%'} 
                        gx={8} 
                        align="center"
                        onClick={() => {
                          setTeamCompetences({ ...teamCompetences, [competence.id]: competence.name });
                          setCompetenceString('');
                          setCompetenceSearchResults([]);
                          setCompetenceSearchError(null);
                          setAllCompetenceResults([]);
                          setShowAllResults(false);
                          setStatusText(t('save'));
                          toasts.info(t('teams.admin.msg.save'));
                          setIsChangesSaved(true);
                        }}
                      >
                        <span style={{ flex: 1, fontSize: '14px' }}>{competence.name}</span>
                        <span style={{ fontSize: '12px', color: '#666' }}>+</span>
                      </CompetenceResult>
                    ))}
                  </FlexBox>
                </FlexBox>
              )}
              
              {competenceSearchError && (
                <FlexBox width={'100%'} offsetTop={16} align="center">
                  <span style={{ fontSize: '14px', color: '#d32f2f' }}>
                    {competenceSearchError}
                  </span>
                </FlexBox>
              )}
              
              {!!Object.keys(teamCompetences).length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <FlexBox wrap="wrap" style={{gap: '10px'}}>
                    {Object.entries(teamCompetences).map(([id, name], index) =>
                      <CompetenceItem
                        key={id}
                        onClick={() => {
                          const newCompetences = { ...teamCompetences };
                          delete newCompetences[id];
                          setTeamCompetences(newCompetences);
                          setStatusText(t('save'));
                          toasts.info(t('teams.admin.msg.save'));
                          setIsChangesSaved(true);
                        }}><FlexBox justify="space-between" gx={12}>
                            <span>{name}</span>
                            <span style={{ fontSize: '12px', color: '#909090' }}>x</span>
                        </FlexBox></CompetenceItem>
                    )}
                  </FlexBox>
                </FlexBox>
              )}
            </FlexBox>
        )
    }, [isS, t, teamCompetences, competenceString, competenceSearchResults, isSearchingCompetences, competenceSearchError, allCompetenceResults, showAllResults])
    
    const addCompetenceYearBlock = (ev: any) => {
        const inputValue = ev.target.value;
        if (inputValue === '' || /^\d+$/.test(inputValue)) {
          setTeamCompetenceYear(inputValue);
          if ( inputValue.trim() <= new Date().getFullYear() && inputValue.trim() > 2000) {
            setStatusText(t('save'));
            toasts.info(t('teams.admin.msg.save'));
            setIsChangesSaved(true);
            }
        }
    }
    const competenceYearBlock = useMemo(() => {
        return (
             <FlexBox offsetTop={24} direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
              <FlexBox width={'100%'} gx={24} gxMobile={16}>
                <CommonInput
                  type={INPUT_TYPES.text}
                  label={t('teams.adminPage.fields.competenceYear')}
                  value={teamCompetenceYear}
                  orientation="wide"
                  onChange={addCompetenceYearBlock}
                    onKeyPress={(ev: React.KeyboardEvent<HTMLInputElement>) => {
                        if (!/^\d$/.test(ev.key)) {
                            ev.preventDefault();
                        }
                    }}
                />
              </FlexBox>
            </FlexBox>
        )
    }, [isS, t, teamCompetenceYear])

    const [isImportLoading, setIsImportLoading] = useState(false);
    const [importGroups, setImportGroups] = useState<string[]>([]);


    const handleCheckImportTTData = useCallback(async () => {
        if (!team?.teamId) {
            return;
        }

        setIsImportLoading(true);
        try {
            const response = await API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/CheckImportTTData')
                .get()
                .addQuery('teamId', team.teamId)
                .send();

            const data = await response.json();
            
            if (data && Array.isArray(data)) {
                setImportGroups(data);
                onModalStateChange(true, { mode: 'import-groups', index: 0, item: { groups: data } });
            } else if (data?.status === 200 || data?.success) {
                toasts.info(t('teams.adminPage.import.success'));
            } else {
                toasts.error(t('teams.adminPage.import.error') || 'Ошибка при проверке импорта');
            }
        } catch (error) {
            console.error('Error checking import TT data:', error);
            toasts.error(t('teams.adminPage.import.error') || 'Ошибка при проверке импорта');
        } finally {
            setIsImportLoading(false);
        }
    }, [team?.teamId, toasts, t]);

    const importBlock = useMemo(() => {
        return (
             <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit align="flex-start">
                  <CommonLabel 
                    label={t('teams.adminPage.import.title')} 
                    fixedHeight
                    onWhiteBG 
                />
                    <ProjectEditPageGridInput>
                        <DefaultButton wh={195} whMob={195} onClick={handleCheckImportTTData} disabled={isImportLoading}>
                            {isImportLoading ? (t('teams.adminPage.import.loading') || 'Загрузка...') : (t('teams.adminPage.import.startButton') || 'Начать импорт')}
                        </DefaultButton>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
        )
    }, [isS, t, teamCompetenceYear, teamModerationType?.value])
    const tagEducationTagBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} align="flex-start" center={!teamEducationTags?.length} className={'tags-wrapper mobile-block-6'} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.tag_education_tab')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '558px'}>
                    <AddButton
                        onClick={() => modal.show('tags', {
                            value: [...teamEducationTags],
                            onChange: (tagsRaw: Tag[]) => {
                                setTeamEducationTags(tagsRaw);
                            },
                            isEdit: true,
                            global: true,
                            maxEducationalTags: 1,
                            max: 1,
                            educational: true,
                            requiredTags: false,
                            projectTags: false,
                            maxProjectTags: 0,
                            maxPlacesTags: 0,

                        })}
                        style={{
                            marginLeft: 0,
                            marginBottom: "auto",
                            marginTop: "auto",
                            width: '100% !important'
                        }}
                        fs={true}
                        isTeamEdit
                    >
                        <ProjectAddButton
                            text={t('teams.adminPage.buttons.add_or_edit')}
                            reverse
                        />
                    </AddButton>

                    {!!teamEducationTags?.length && (
                        <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
                            <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                                {teamEducationTags.map((value: any) => (
                                    <BTag
                                        tag={value}
                                        removable
                                        onClick={() => modal.show('tags', {
                                            value: [...teamEducationTags],
                                            onChange: (tagsRaw: Tag[]) => {
                                                setTeamEducationTags(tagsRaw);
                                            },
                                            isEdit: true,
                                            global: true,
                                        })}
                                        educational={value?.isEducationTag}
                                        key={value.tagId}
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                ))}
                            </BTagsGridNew>
                        </ContentAddContainer>
                    )}
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, modal, t, teamEducationTags])


    const courseEndBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.course_completion')}
                    fixedHeight
                    onWhiteBG
                />

                <DefaultButton wh={195} whMob={160} hasLongread disabled={isCourseCompleted} onClick={onToggleCourseCompletionModal}>
                    {t('teams.adminPage.buttons.complete_course')}
                </DefaultButton>
                
            </ProjectEditPageGridRow>
        )
    }, [courseStartDate, i18n.language, isMobile, isS, t, isCourseCompleted])

    const canCreateProjectBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.can_create_project')}
                    fixedHeight
                    onWhiteBG
                    infoText={t('teams.adminPage.additionalFields.can_create_project_msg')}
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamModerationType.value === ModerationType.LMS ? false : teamIsCanCreateProject}
                        label={''}
                        onClick={() => setTeamIsCanCreateProject(!teamIsCanCreateProject)}
                        isTeamEdit
                        disabled={teamModerationType.value === ModerationType.LMS}
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsCanCreateProject, teamModerationType.value])

    const employeesFilterBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.employees_filter')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsShowTeachersCheckbox}
                        label={is800 ? '' : t('teams.adminPage.additionalFields.employees_filter_info')}
                        onClick={() => setTeamIsShowTeachersCheckbox(!teamIsShowTeachersCheckbox)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [is800, isS, t, teamIsShowTeachersCheckbox])

    const tabEntityBlock = useMemo(() => {
        const entityListWithTooltips = entityList.map(item => {
            let tooltipText = '';
            switch (item.value) {
                case 'projects':
                    tooltipText = 'список проектов';
                    break;
                case 'organizations':
                    tooltipText = 'список организаций на странице';
                    break;
                case 'modules':
                    tooltipText = 'учебные модули для образовательных курсов';
                    break;
                default:
                    tooltipText = '';
            }

            return {
                ...item,
                label: (
                    <HintTooltip
                        positionY="default"
                        text={tooltipText}
                        z={6}
                        onWhiteBg
                    >
                        <span>{item.label}</span>
                    </HintTooltip>
                )
            };
        });
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    label={t('teams.adminPage.fields.tab_entity')}
                    required
                    onWhiteBG
                    infoText={t('teams.adminPage.additionalFields.entity_msg')}
                    options={entityListWithTooltips as any}
                    value={entityList.find(({ value }) => value === teamEntityType)}
                    onChange={(item: any) => setTeamEntityType(item?.value)}
                    placeholder={t('teams.adminPage.fields.select_placeholder')}
                    orientation={'wide'}
                />
            </ProjectEditPageGridRow>
        )
    }, [entityList, isS, t, teamEntityType, isModer])

    const handleFilterTypeChange = (type: ShowCaseFilterType) => {
        setShowCaseFilterType(type);
    };

    const filterTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: 24}} isTeamEdit switchValue={showCaseFilterType} >
                <CommonLabel 
                    label={'Структура страницы'}
                    infoText={t('teams.adminPage.additionalFields.structure_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                <span className={'input-span'}> Витрина организации</span>
                                <Switch className={'showcase-switcher'} value={showCaseFilterType} onChange={handleFilterTypeChange} />
                                <span className={'input-span'}> Разделы страницы</span>
                            </FlexBox>
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, handleFilterTypeChange, showCaseFilterType, t])




    const canSortingProject = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.sorting')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={sortingHidden}
                        label={''}
                        onClick={() => setSortingHidden(!sortingHidden)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, sortingHidden])

    const courseTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.course_type')}
                    orientation="wide"
                    type={INPUT_TYPES.dropdown}
                    value={courseCurrentOption as any}
                    onChange={(ev: any) => {
                        setCourseType(ev?.value)
                    }}
                    options={COURSE_OPTIONS as any}

                />
            </ProjectEditPageGridRow>
        )
    }, [courseCurrentOption, isS, t])

    const courseLevelBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.course_level')}
                    value={lmsCourseCurrentOption as any}
                    onChange={(ev: any) => {
                        setLmsCourseType(ev?.value)
                    }}
                    options={LMS_COURSE_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsCourseCurrentOption, t])

    const handleDateChange = (value: Date) => {
        setCourseStartDate(value);
    };

    const onAdditionalContentChange = (data: any) => {
        setAdditionalContent(data)
    }

    const handleBlur = useCallback(() => {
        if (courseStartDate === undefined) {
            setCourseStartDate(fixTimezoneOffsetToShow(new Date(team?.lmsModuleStartDate || Date.now())));
        }
    }, [courseStartDate]);

    const courseStartBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.course_start')}
                    fixedHeight
                    onWhiteBG
                />
                <DatePickerTeamWrapper>
                    <CustomDateTimePicker
                        value={courseStartDate}
                        className="date-input"
                        calendarIcon={isMobile ? <Date24Icon /> : <Date32Icon />}
                        clearIcon={null}
                        format="dd-MM-yyyy"
                        maxDate={addYears(new Date(), 5)}
                        locale={i18n.language}
                        onChange={handleDateChange}
                        onCalendarClose={handleBlur}
                    />
                </DatePickerTeamWrapper>
            </ProjectEditPageGridRow>
        )
    }, [courseStartDate, handleBlur, i18n.language, isMobile, isS, t])

    const coursePriceBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    label={t('teams.adminPage.fields.course_price')}
                    orientation="wide"
                    type={INPUT_TYPES.text}
                    maxLength={9}
                    placeholder={'0'}
                    value={coursePrice || ''}
                    onChange={(ev: any) => onChangeCoursePrice(ev?.target?.value)}
                />
            </ProjectEditPageGridRow>
        )
    }, [coursePrice, isS, onChangeCoursePrice, t])

    const courseDurationBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.course_duration')}
                    infoText={t('teams.adminPage.additionalFields.lms_duration_msg')}
                    value={lmsDurationOption as any}
                    onChange={(ev: any) => {
                        setLmsCourseTerm(ev?.value)
                    }}
                    options={LMS_DURATION_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsDurationOption, t])

    const courseCardCover = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.dropdown}
                    orientation="wide"
                    label={t('teams.adminPage.fields.card_format')}
                    infoText={t('teams.adminPage.additionalFields.lms_cardType_msg')}
                    value={lmsCardTypeOption as any}
                    onChange={(ev: any) => {
                        setLmsCardFormat(ev?.value)
                    }}
                    options={LMS_CARDFORMAT_OPTIONS as any}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, lmsCardTypeOption, t])



    const ownersAndParticipantsBlock = useMemo(() => {

        return (
            <ProjectAuthorsWrapper isTeamEdit direction={"column"} directionMobile={"column"} style={{ marginTop: isS ? 24 : 40 }} className={'author-wrapper mobile-block-2'}>

                <ProjectAuthorsEdit
                    label={t('teams.adminPage.fields.authors')}
                    value={teamAuthors}
                    onChange={onTeamAuthorsChange}
                    placeholder={t('search_by_name')}
                    isTeamEdit
                    isAdminPage
                    orientation="wide"
                    errorMsg={t('teams.adminPage.errors.equal_owners')}
                    teamModerationType={teamModerationType.value}
                />
                <FlexBox style={{ marginTop: 24, justifyContent: 'space-between' }} align="flex-start" alignMobile="flex-start">
                    <ProjectAuthorsEdit
                        label={t('teams.adminPage.fields.owners')}
                        value={teamOwners}
                        required
                        onChange={onTeamOwnersChange}
                        placeholder={t('search_by_name')}
                        isTeamEdit
                        isAdminPage
                        orientation="wide"
                        errorMsg={t('teams.adminPage.errors.equal_owners')}
                        teamModerationType={teamModerationType.value}
                    />
                </FlexBox>
                <FlexBox style={{ marginTop: 24, justifyContent: 'space-between' }} align="flex-start" alignMobile="flex-start">
                    <ProjectAuthorsEdit
                        label={t('teams.adminPage.fields.members')}
                        value={teamMembers}
                        isTeamMembers
                        orientation="wide"
                        onChange={onTeamMembersChange}
                        placeholder={t('search_by_name')}
                        isTeamEdit
                        isAdminPage
                        errorMsg={t('teams.adminPage.errors.equal_participants')}
                        teamModerationType={teamModerationType.value}
                    // showList
                    />
                </FlexBox>
            </ProjectAuthorsWrapper>
        )
    }, [isS, t, teamMembers, teamModerationType.value, teamAuthors, teamOwners])

    const linkParticipantsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.link_for_participants')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox checkbox-with-label'}
                        checked={teamIsShowEmployeesLink}
                        label={isS ? '' : t('teams.adminPage.additionalFields.link_for_participants_info')}
                        onClick={() => setTeamIsShowEmployeesLink(!teamIsShowEmployeesLink)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsShowEmployeesLink])

    const channelsParams = useMemo(() => {
        return {
            lmsGroupChannelsIds: team?.additionalInfo?.lmsGroupChannelsIds,
            courseChannelId: team?.additionalInfo?.courseChannelId,
            getChannelid: (id: string) => {
                const groupList = team?.additionalInfo?.lmsGroupChannelsIds ?
                    JSON.parse(team?.additionalInfo?.lmsGroupChannelsIds || '{}') : {}
                return groupList[id]
            },
        }
    }, [team])

    const getAutoChannelButton = useCallback((id: string) => {
        if (channelType !== ModerationType.LMS) return null;
        return <AutoChannelButton
            type={ENTITY_COURSES_TYPE.group}
            entityId={id} 
            channelId={channelsParams?.getChannelid(id)}
            onUpdate={() => setDate(Date.now())}
        />
    } , [channelsParams, channelType, date, status])

    const groupsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.groups')}
                    fixedHeight
                    onWhiteBG
                />
                {!!teamOwners?.length ? (
                    <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
                        <ProjectEditPageGridInput isTeamEdit direction={!!computedGroups?.length ? 'column' : 'row'}
                            // @ts-ignore
                            style={{ flexDirection: isMobile ? 'column' : '' }}>
                            {!!computedGroups?.length && (
                                <JustTable isTeamEdit style={{ userSelect: 'none' }}>
                                    <thead style={{ userSelect: 'none' }}>
                                        <tr>
                                            <th style={{ width: '45%', paddingTop: 0, userSelect: 'none' }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                                            <th style={{ width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0, userSelect: 'none' }}></th>
                                            {!isS && (
                                                <th style={{ width: isS ? 0 : '30%', paddingTop: 0, userSelect: 'none' }}></th>
                                            )}
                                        </tr>
                                    </thead>
                                    <DraggableTable 
                                        computedGroups={computedGroups}
                                        onGroupDragEnd={onGroupDragEnd}
                                        getAutoChannelButton={getAutoChannelButton}
                                        onModalStateChange={onModalStateChange}
                                        setCurrentGroup={setCurrentGroup}
                                        groups={groups}
                                    />
                                </JustTable>
                            )}
                            <FlexBox style={{ marginTop: !groups?.length ? 0 : isSmallMob ? 10 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => {
                                    createGroup();

                                    onModalStateChange(true, { mode: "group", index: -1 });
                                }}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridInput>
                    </FlexBox>
                ) : (
                    <span style={{ paddingTop: 8 }}>{t('teams.adminPage.additionalFields.add_owner_info')}</span>
                )}

            </ProjectEditPageGridRow>
        )
    }, [computedGroups, createGroup, groups, date, i18n.language, isMobile, isS, isSmallMob, onGroupDragEnd, t, teamOwners?.length, setCurrentGroup])

    const feedbackFormsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.forms')}
                    infoText={t('teams.adminPage.additionalFields.form_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <FlexBox direction="column" directionMobile="column" justify={ !forms?.length ? 'center' : 'normal'}>
                    <ProjectEditPageGridInput  isTeamEdit direction={!!forms?.length ? 'column' : 'row'} directionMobile="column">
                        {!!forms?.length && (
                            <JustTable isTeamEdit>
                                <SortableList as={'tbody'} onSortEnd={onTeamTabSortEnd}>
                                    {actualForms?.map((form, index: number) => {
                                        //@ts-ignore
                                        const name = Lang(form.techName, i18n.language) || form.formId;
                                        return (
                                            <tr>
                                                <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                        <CommonInput 
                                                            type={INPUT_TYPES.text}
                                                            value={name}
                                                            disable={true}
                                                            onChange={() => null}
                                                        />
                                                    </TableSortWrapper>
                                                </td>
                                                <td style={{ width: isS ? '56px' : '336px' }}>
                                                    <FlexBox align={'center'} alignMobile="center" direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                        {isS ? (
                                                            <EditIcon24 onClick={() => {
                                                                onModalStateChange(true, { mode: "forms", index: index })
                                                                //@ts-ignore
                                                                setCurrentForm(forms?.filter((i) => i?.formId === form?.formId)[0])
                                                            }} />
                                                        ) : (
                                                            <DefaultButton wh={181} whMob={157} onClick={() => {
                                                                onModalStateChange(true, { mode: "forms", index: index });
                                                                //@ts-ignore
                                                                setCurrentForm(forms?.filter((i) => i?.formId === form?.formId)[0])
                                                            }}>
                                                                {t('teams.adminPage.buttons.edit')}
                                                            </DefaultButton>
                                                        )}
                                                        {isS ? (
                                                            <FlexBox offsetLeftMobile={8}>
                                                                <BasketIcon fill={'#838382'} onClick={() => onFormDelete(form?.formId)} />
                                                            </FlexBox>
                                                        ) : (
                                                            <DefaultButton wh={131} whMob={107} onClick={() => onFormDelete(form?.formId)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                        )}

                                                    </FlexBox>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </SortableList>
                            </JustTable>
                        )}
                        <FlexBox style={{ marginTop: !forms?.length ? 0 : 14 }}>
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                createNewForm();
                            }}>
                                <PlusSvg />
                                {t('teams.adminPage.buttons.add')}
                            </DefaultButton>
                        </FlexBox>
                    </ProjectEditPageGridInput>
                </FlexBox>


            </ProjectEditPageGridRow>
        )
    }, [actualForms, createNewForm, forms, i18n.language, isMobile, isS, onFormDelete, onTeamTabSortEnd, t])

    const showQuBlock = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.show_qu')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamShowQu}
                        label={''}
                        onClick={() => setTeamShowQu(!teamShowQu)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamShowQu])

    const goodsBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: !(teamModerationType?.value === 2 && (isModer || hasAccessToTeamsAdmin)) ? 0 : isS ? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.goods')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit>
                    <FlexBox gx={isMobile ? 0 : 26} directionMobile={"column"} gy={isMobile ? 16 : 0} align="center">
                        {!collection && !isCollectionLoading && !isCatalogsLoading && <DefaultButton wh={214} whMob={107} onClick={() => {
                            if (isCreateColButtonDisabled) return;
                            setIsCreateColButtonDisabled(true)
                            API.request()
                                .endpoint(Endpoints.cardsMnePw)
                                .url('/api/Collection/Add')
                                .post()
                                .body({
                                    referenceCollectionId: catalogs?.length > 0 ? catalogs[0]?.cardCollectionId : "",
                                    cardCollectionId: team?.teamId,
                                    artistId: teamOwners?.length > 0 ? teamOwners[0]?.accountId : "",
                                    name: teamName,
                                })
                                .send()
                                .then((r) => r.json())
                                .then((r) => {
                                    setColT(Date.now());
                                    setIsCreateColButtonDisabled(false);
                                })
                                .catch((e) => console.error(e))
                        }}>
                            {t('teams.adminPage.buttons.create_collection')}
                        </DefaultButton>}
                        {collection && !isCollectionLoading && <DefaultButton wh={131} whMob={107} onClick={() => {
                            API.request()
                                .endpoint(Endpoints.cardsMnePw)
                                .url('/api/Card/AddCard')
                                .post()
                                .body({
                                    typeCard: "product",
                                    museumId: team?.teamId,
                                    userId: teamOwners?.length > 0 ? teamOwners[0]?.accountId : "",
                                })
                                .send()
                                .then((r) => r.json())
                                .then((r) => {
                                    setTimeout(() => {
                                        window.open(process.env.REACT_APP_URL_GALLERY + '/card/' + r + '?shouldForcedLogin=true&saveLoginUrl=true', '_blank')
                                    })
                                })
                                .catch((e) => console.error(e))
                        }}>
                            {t('teams.adminPage.buttons.create')}
                        </DefaultButton>}
                        <DefaultButton wh={159} whMob={107} onClick={() => {
                            history.push(`/teams/${team?.teamId}/shop`)
                        }}>
                            {t('teams.adminPage.buttons.view')}
                        </DefaultButton>
                        {//кнопка к товарам, раскомментить, когда появится айдишник магазина
                        /* <DefaultButton wh={369} whMob={369} onClick={() => {
                            history.push(`/teams/${team?.teamId}/shop`)
                        }}>
                            {t('teams.adminPage.buttons.go_to_shop')}
                        </DefaultButton> */}
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [catalogs, collection, hasAccessToTeamsAdmin, history, isCatalogsLoading, isCollectionLoading, isCreateColButtonDisabled, isMobile, isModer, isS, t, teamModerationType, team?.moderationType, team?.teamId, teamName, teamOwners])

    const showShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.show_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={teamIsShopVisible}
                        label={''}
                        onClick={() => setTeamIsShopVisible(!teamIsShopVisible)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t, teamIsShopVisible])

    const mainFilterBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.main_filter')}
                    infoText={t('teams.adminPage.additionalFields.main_filter_msg')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput  isTeamEdit>
                    <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} align="center" alignMobile="center">
                        <DefaultButton wh={195} whMob={195} onClick={() => onModalStateChange(true, { mode: "mainFilter", index: -1 })}>
                            {t('teams.adminPage.buttons.edit')}
                        </DefaultButton>
                        <span className="text">{t('teams.adminPage.additionalFields.main_filter_info')}</span>
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isS, t])

    useEffect(() => {
        const match = longreadEntityLink.match(/\/project\/(([a-z0-9]+\-)*([a-z0-9]+))/);
        if (match) {
            setProjectId(match[1]);
        } else {
            setProjectId(longreadEntityLink);
        }
    }, [longreadEntityLink]);

    useEffect(() => {
        if (projectSource) {
            setReplaceLongreadId(projectSource?.longreadId)
        }
    }, [projectSource]);

    useEffect(() => {
        const longreadSign = (
            REPLACE_LONGREAD_REG.test(longreadEntityLink) &&
            teamLongreadType === TeamLongreadType.ReplaceLongread)
            || longread?.length > 0
            ;

        setHasLongread(longreadSign)
    }, [longreadEntityLink, longread, teamLongreadType])

    const titleTypeBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseTitleType} >
            <CommonLabel 
                label={t('teams.adminPage.additionalFields.header_show')}
                fixedHeight
                onWhiteBG
            />
                <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_text')}</span>
                                <Switch className={'showcase-switcher'} value={showCaseTitleType} onChange={onTitleVisibleChange} />
                                <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_link')}</span>
                            </FlexBox>
                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [isS, onTitleVisibleChange, showCaseTitleType, t])

    const feedOrMediaBlock = useMemo(() => {

        if (channelType !== ModerationType.Channel) return null;

        return (
            <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40, placeItems: 'baseline'}} isTeamEdit switchValue={feedViewType} >
            <CommonLabel 
                label={t('teams.adminPage.fields.default_page')}
                fixedHeight
                onWhiteBG
            />
            <FlexBox direction="column">
                <FlexBox direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                    <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                        <span className={'input-span'}> {t('teams.adminPage.additionalFields.media')}</span>
                        <Switch className={'showcase-switcher'} value={feedViewType} onChange={onFeedViewTypeChange} />
                        <span className={'input-span'}> {t('teams.adminPage.additionalFields.feed')}</span>
                    </FlexBox>
                </FlexBox>
            </FlexBox>
            </ProjectEditPageGridRow>
        )
    } , [feedViewType, t, i18n.language, channelType])

    const longreadBlock = useMemo(() => {

        return (
                <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseViewType} >
                    <CommonLabel 
                        label={t('teams.adminPage.fields.longread')}
                        fixedHeight
                        onWhiteBG
                    />
                    <FlexBox direction="column">
                        <FlexBox ref={switchRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                            <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                                 <HintTooltip positionY="top" text={'Сетка – страница в виде "плитки" проектов'} z={6} onWhiteBg={true}>
                                    <span className={'input-span'}> {t('teams.adminPage.additionalFields.grid')}</span>
                                 </HintTooltip>
                                <Switch className={'showcase-switcher'} value={showCaseViewType} onChange={onLandingVisibleChange} />
                                <HintTooltip positionY="top" text={'Лендинг – страница в виде лонгрида'} z={6} onWhiteBg={true}>
                                    <span className={'input-span'}> {t('teams.adminPage.additionalFields.landing')}</span>
                                </HintTooltip>
                            </FlexBox>
                        </FlexBox>
                        {/* {showCaseViewType ? */}
                        <FlexBox direction="column" style={{maxWidth: '600px'}}>
                            <div style={{marginTop: '8px', color: '#909090'}}>{t('teams.adminPage.fields.link_description')}</div>
                            <FlexBox align="center">
                                <FlexBox direction={'column'} offsetTop={8} offsetRight={32}>
                                    <CheckLongreadRadioButton
                                        onChange={() => setTeamLongreadType(TeamLongreadType.ReplaceLongread)}
                                        name="longreadLink"
                                        title={t('teams.adminPage.fields.enter_link')}
                                        checked={teamLongreadType === TeamLongreadType.ReplaceLongread}
                                    />
                                    <CheckLongreadRadioButton
                                        onChange={() => setTeamLongreadType(TeamLongreadType.SelfLongread)}
                                        name="longreadLink"
                                        title={t('teams.adminPage.fields.create_link')}
                                        checked={teamLongreadType === TeamLongreadType.SelfLongread}
                                    />
                                </FlexBox>
                                {
                                    teamLongreadType === TeamLongreadType.ReplaceLongread ?
                                    <LongreadLinkWrapper>
                                        <Input.Text
                                            //@ts-ignore
                                            value={longreadEntityLink}
                                            placeholder={t('teams.adminPage.fields.placeholder_link')}
                                            onChange={(ev: any) => setLongreadEntityLink(ev.target.value)}
                                        />
                                        {isProjectLoading && (
                                            <span className={'loading-text'}>{t('teams.adminPage.fields.loading_link')}</span>
                                        )}
                                        {projectError && !isProjectLoading && (
                                            <span className={'not-allowed-text'}>{t('teams.adminPage.fields.error_link')}</span>
                                        )}
                                    </LongreadLinkWrapper>
                                    :
                                    <>
                                        {canEditSelfLG ? (
                                            <DefaultButton wh={215} hasLongread onClick={onToggleLgView}>
                                                {t('teams.adminPage.buttons.edit_lg')}
                                            </DefaultButton>
                                        ) : (
                                            <DefaultButton wh={195} whMob={160} hasLongread onClick={onToggleLgView}>
                                                {t('teams.adminPage.buttons.add_lg')}
                                            </DefaultButton>
                                        )}
                                    </>
                            }
                        </FlexBox>
                        <FlexBox offsetTop={12} direction="row" directionMobile="row" justify="flex-start" align="center">
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={isShowTeamLandingWithProjects}
                                label={''}
                                onClick={() => setIsShowTeamLandingWithProjects(!isShowTeamLandingWithProjects)}
                                isTeamEdit
                            />
                            <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_team_project_list')}</span>
                        </FlexBox>
                        {isShowTeamLandingWithProjects && !!team?.teamLandingProjectId && (
                            <FlexBox offsetTop={8}>
                                <ProjectAvailableText>{t('teams.adminPage.additionalFields.project_available_text')}</ProjectAvailableText>
                                <ProjectAvailableLink
                                    onClick={() => {
                                        window.open(CreateLinkTo.project(team?.teamLandingProjectId), '_blank');
                                    }}
                                >
                                    {t('teams.adminPage.additionalFields.project_available_link')}
                                </ProjectAvailableLink>
                            </FlexBox>
                        )}
                    </FlexBox>
                    {/* : null} */}


                </FlexBox>
            </ProjectEditPageGridRow>
        )
    }, [hasLongread, isS, showCaseViewType, longreadEntityLink, projectId, setLongreadEntityLink, projectSource, onLandingVisibleChange, onToggleLgView, showCaseViewType, t, isShowTeamLandingWithProjects])

    const onSetIsLinksInsteadTitle = useCallback((val: any) => {
        if (val && topLinks?.length === 0) setTopLinks([{
            name: createEmptyLangObject('', ['ru', 'en']),
            link: ''
        }])
        setIsLinksInsteadTitle(val)
    }, [topLinks])

    const onTeamNameChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamName(
            setTextByLang(
                teamName,
                lang || 'ru',
                filterMaxLength(val, 100, toasts, t)
            )
        ))
    }, [teamName])

    const onTeamAboutChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamAbout(
            setTextByLang(
                teamAbout,
                lang || 'ru',
                filterMaxLength(val, 1000, toasts, t)
            )
        ))
    }, [teamAbout])

    const onTeamAboutExtraChange = useCallback((ev: BaseSyntheticEvent, lang?: string) => {
        textAllowed(ev, (val) => setTeamAboutExtra(
            setTextByLang(
                teamAboutExtra,
                lang || 'ru',
                filterMaxLength(val, 1500, toasts, t)
            )
        ))
    }, [teamAboutExtra])

    const teamNameBlock = useMemo(() => {
        return (
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                <ProjectEditPageGridRow style={{ width: '100%' }} isTeamEdit>
                    <ProjectEditPageGridInput style={{ width: '100%' }} isTeamEdit direction="column" directionMobile="column">
                        {!isLinksInsteadTitle && <>
                            <CommonInput
                                type={INPUT_TYPES.text}
                                placeholder={''}
                                orientation='wide'
                                label={t('teams.adminPage.fields.name')}
                                value={teamName}
                                required
                                useLangSwitcher
                                onChange={(ev: any, lang?: string) => onTeamNameChange(ev, lang)}
                            />

                            {!isChannel && <FlexBox justify="space-between" width={'100%'} direction="row">
                                <FlexBox style={{ width: 'calc(100% - 585px)' }} />
                                <FlexBox direction="column" justify="flex-start" style={{ width: '600px' }}>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isSmallName}
                                            label={''}
                                            onClick={() => setIsSmallName(!isSmallName)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.small_title_info')}</span>
                                    </FlexBox>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isMinimalName}
                                            label={''}
                                            onClick={() => setIsMinimalName(!isMinimalName)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.minimalism_title_info')}</span>
                                    </FlexBox>
                                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center">
                                        <MagicBoxRow
                                            className={'checkbox'}
                                            checked={isMainTitleHidden}
                                            label={''}
                                            onClick={() => setIsMainTitleHidden(!isMainTitleHidden)}
                                            isTeamEdit
                                        />
                                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.hide_title')}</span>
                                    </FlexBox>
                                </FlexBox>
                            </FlexBox>}

                        </>}
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [onSetIsLinksInsteadTitle, isLinksInsteadTitle, teamName, isChangesSaved, isSmallName, isMinimalName, isMainTitleHidden, isShowTeamLandingWithProjects, isChannel])

    const aboutBlock = useMemo(() => {

        return (
            <>
                <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                    <CommonInput
                        type={INPUT_TYPES.textarea}
                        placeholder={''}
                        orientation='wide'
                        infoText={t('teams.adminPage.additionalFields.about_msg')}
                        label={t('teams.adminPage.fields.about')}
                        value={teamAbout}
                        maxLength={1000}
                        minHeight={285}
                        onWhiteBG
                        useLangSwitcher
                        onChange={(ev: any, lang?: string) => onTeamAboutChange(ev, lang)}
                    />
                </LangBlockWrapper>
                <ProjectEditPageGridRow>
                    <FlexBox />
                    <FlexBox direction="row" directionMobile="row" justify="flex-start" align="center" offsetTop={5} offsetTopMobile={5}>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isShowFullDescription}
                            label={''}
                            onClick={() => setIsShowFullDescription(!isShowFullDescription)}
                            isTeamEdit
                        />
                        <span className="small-caption" style={{ color: 'rgba(144, 144, 144, 1)' }}>{t('teams.adminPage.additionalFields.show_full_description')}</span>
                    </FlexBox>
                </ProjectEditPageGridRow>
            </>
        )
    }, [teamAbout, isMobile, isS, isShowFullDescription])

    const aboutExtraBlock = useMemo(() => {

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'} maxSize={maxFieldSize}>
                <CommonInput 
                    type={INPUT_TYPES.textarea}
                    useLangSwitcher
                    label={t('teams.adminPage.fields.about_extra')}
                    onChange={(ev: any, lang?: string) => onTeamAboutExtraChange(ev, lang)}
                    value={teamAboutExtra}
                    infoText={t('teams.adminPage.additionalFields.about_extra_msg')}
                    maxLength={1500}
                    placeholder={''}
                    orientation="wide"
                />
            </LangBlockWrapper>
        )
    }, [teamAboutExtra, isMobile, isS])

    // SHOP
    const shopButtonsBlock = useMemo(() => {
        const currentLang = shopNavButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
                <CommonLabel 
                    label={t('teams.adminPage.fields.navButtons_shop')}
                    useLangSwitcher
                    lang={currentLang}
                    onLanguageChange={() => onLocalLangChange(shopNavButtons, currentLang, (val) => setShopNavButtons(val))}
                />
                <ProjectEditPageGridRow directionMobile={!!shopNavButtons?.length ? "column" : 'row'} isTeamEdit>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        {!shopNavButtons?.length && (
                            <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !shopNavButtons?.length ? 0 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => onShopNavButtonAdd()}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                        {(!!shopNavButtons?.length) && (
                            <>
                                {isMobile ? (
                                    <>
                                        {shopNavButtons.map((button, index) => {
                                            return (
                                                <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                                    {isS && (
                                                        <GridMobileNamed>
                                                            <span>{`Кнопка ${index + 1}`}</span>
                                                            {!getLGbool(button) && (
                                                                <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)} isTablet>Удалить</DefaultButton>
                                                            )}
                                                        </GridMobileNamed>
                                                    )}
                                                    <TeamsMobGridList cols={repeat(2, '306.5px')}>
                                                        <FlexBox directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                orientation="column"
                                                                value={{ label: button.type, value: button.type }}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                options={shopButtonTypes}
                                                                label={t('teams.adminPage.additionalFields.td_style')}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                orientation="column"
                                                                label={t('teams.adminPage.additionalFields.td_text')}
                                                                value={Lang(button.text, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column">
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                                orientation="column"
                                                                value={Lang(button.textMobile, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                            />
                                                        </FlexBox>
                                                        <FlexBox  directionMobile="column" style={{ marginBottom: 8}}>
                                                            <CommonLabel 
                                                                label={t('teams.adminPage.additionalFields.td_href')}
                                                                fixedHeight
                                                                onWhiteBG
                                                                
                                                            />
                                                                {button.type?.includes('anchor') ? (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.dropdown}
                                                                        value={{ label: button.type, value: button.type }}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                        options={shopButtonTypes}
                                                                    />
                                                                ) : (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.href, currentLang)}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, href: setTextByLang(button.href, currentLang, value.target.value) }, index)}
                                                                    />
                                                                )}
                                                        </FlexBox>
                                                    </TeamsMobGridList>
                                                    {!isS && !getLGbool(button) && (
                                                        <FlexBox alignMobile="end">
                                                            <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)}>Удалить</DefaultButton>
                                                        </FlexBox>
                                                    )}
                                                </MobileButtonsWrapper>
                                            )
                                        })}
                                    </>
                                ) : (
                                    <JustTable isTeamEdit>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '20%' }}>{t('teams.adminPage.additionalFields.td_style')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                                <th style={{ width: '25%' }}>{t('teams.adminPage.additionalFields.td_href')}</th>
                                            </tr>
                                        </thead>
                                        <TBody>
                                            {shopNavButtons.map((button, index) => {
                                                return (
                                                    <tr>
                                                        <td style={{width: '195px'}}>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                value={{ label: button.type, value: button.type }}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, type: value.value }, index)}
                                                                options={shopButtonTypes}
                                                            />
                                                        </td>
                                                        <td style={{width: '180px'}}>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                value={Lang(button.text, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value) }, index)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <CommonInput 
                                                                type={INPUT_TYPES.text}
                                                                value={Lang(button.textMobile, currentLang)}
                                                                onChange={(value: any) => onShopNavButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value) }, index)}
                                                            />
                                                        </td>
                                                        <>
                                                            <td>
                                                                {button.type?.includes('anchor') ? (
                                                                    <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                                ) : (
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={!!button?.isRequired ? '' : Lang(button.href, currentLang)}
                                                                        disable={!!button?.isRequired}
                                                                        onChange={(value: any) => onShopNavButtonChange({ ...button, href: setTextByLang(button.href, currentLang, value.target.value)}, index)}
                                                                    />
                                                                )}
                                                            </td>

                                                            <td>
                                                                {!!button?.isRequired ? (
                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                ) : (
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => onShopNavButtonDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                )}
                                                            </td>
                                                        </>
                                                    </tr>
                                                );
                                            })}
                                        </TBody>
                                    </JustTable>
                                )}
                            </>
                        )}
                        {!!shopNavButtons?.length && (
                            <FlexBox style={{ marginTop: !shopNavButtons?.length ? 0 : 24 }}>
                                <DefaultButton wh={195} whMob={195} onClick={() => onShopNavButtonAdd()}>
                                    <PlusSvg />
                                    {t('teams.adminPage.buttons.create')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [shopNavButtons, isS, is1280])

    const ShopAboutBlock = useMemo(() => {
        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    label={t('teams.adminPage.fields.shop_about')}
                    useLangSwitcher
                    orientation="wide"    
                    type={INPUT_TYPES.textarea}
                    maxLength={800}
                    value={shopAbout}
                    onChange={(value: any, lang?: any) => setShopAbout(setTextByLang(shopAbout, lang, value.target.value))}
                />
            </LangBlockWrapper>
        )
    }, [shopAbout, isS, t, isMobile])

    const OutOfStockMessageBlock = useMemo(() => {
        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    useLangSwitcher
                    label={t('teams.adminPage.fields.out_of_stock_message')}
                    value={outOfStockMessage}
                    onChange={(ev: any, lang?: string) => setOutOfStockMessage(setTextByLang(outOfStockMessage, lang ?? 'ru', filterMaxLength(ev.target.value, 100, toasts, t)))}
                />
            </LangBlockWrapper>
        )
    }, [outOfStockMessage, isS, t, toasts])

    const OutOfStockLinkBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    label={t('teams.adminPage.fields.out_of_stock_link')}
                    placeholder={t('teams.adminPage.placeholders.route')}
                    value={outOfStockLink}
                        // @ts-ignore
                    onChange={(ev: any) => allowedCharactersWithNumbers(ev, setOutOfStockLink)}
                />
            </ProjectEditPageGridRow>
        )
    }, [isS, t, outOfStockLink])

    const IsArchiveItemsShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.is_archive_items_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isArchiveItemsShop}
                        label={''}
                        onClick={() => setIsArchiveItemsShop(!isArchiveItemsShop)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isArchiveItemsShop, isS, t])

    const HideShopWordBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.hide_shop_word')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={hideShopWord}
                        label={''}
                        onClick={() => setHideShopWord(!hideShopWord)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [hideShopWord, isS, t])

    const IsHideParticipantsShopBlock = useMemo(() => {

        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.is_hide_participants_shop')}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isHideParticipantsShop}
                        label={''}
                        onClick={() => setIsHideParticipantsShop(!isHideParticipantsShop)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isHideParticipantsShop, isS, t])

    const additionalNameBlock = useMemo(() => {
        return (
            <LangBlockWrapper gyMobile={isS ? 8 : 0} align="center" offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row" directionMobile={isS ? 'column' : 'row'}>
                <ProjectEditPageGridRow isTeamEdit style={{ width: '100%' }}>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.additional_name')}
                        orientation='wide'
                        placeholder={''}
                        useLangSwitcher
                        infoText={t('teams.adminPage.additionalFields.additionalName_msg')}
                        onChange={(value: any, lang?: string) => textAllowed(value, (val) => setTeamNameExtra(
                            setTextByLang(teamNameExtra, lang || 'ru', filterMaxLength(val, 100, toasts, t))) 
                        ) }
                        value={teamNameExtra}
                        onWhiteBG
                    />
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [isS, t, teamNameExtra, toasts])

    const buttonsBlock = useMemo(() => {
        const currentLang = teamButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
            <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
                <CommonLabel 
                    label={t('teams.adminPage.fields.page_buttons')}
                    onLanguageChange={() => onLocalLangChange(teamButtons, currentLang, (val) => setTeamButtons(val))}
                    lang={currentLang}
                    useLangSwitcher={!!teamButtons?.length}
                    fixedHeight
                    onWhiteBG
                />
                <ProjectEditPageGridRow directionMobile={!!teamButtons?.length ? "column" : 'row'} isTeamEdit>
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        <ButtonEditGroup
                            buttons={teamButtons}
                            currentLang={currentLang}
                            buttonTypes={isModer ? buttonTypesForModer : buttonTypes}
                            onChange={onTeamButtonChange}
                            OnDelete={onTeamButtonDelete}
                            OnAdd={onTeamButtonAdd}
                            forms={actualForms}
                            hasAnchors={hasAnchors}
                            anchorTypes={anchorTypes}
                        />
                        {!!teamButtons?.length && teamButtons?.length < maxLGButtonsCount && (
                            <FlexBox style={{ marginTop: !teamButtons?.length ? 0 : 24 }}>
                                <HintTooltip positionY="default" text={'Вы можете добавить до 3-х кнопок под Описанием компании'} z={6} onWhiteBg>
                                    <DefaultButton wh={195} whMob={195} onClick={() => onTeamButtonAdd()}>
                                        <PlusSvg />
                                        {t('teams.adminPage.buttons.add')}
                                    </DefaultButton>
                                </HintTooltip>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [teamButtons, isS, is1280, anchorTypes, isModer, maxLGButtonsCount])

    const navButtonsBlock = useMemo(() => {
        const currentLang = teamNavButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';

        return (
          <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
              <CommonLabel 
                label={t('teams.adminPage.fields.navButtons')} 
                lang={currentLang}
                onLanguageChange={() => {
                    onLocalLangChange(teamNavButtons, currentLang, (val) => setTeamNavButtons(val))
                }}
                useLangSwitcher={!!teamNavButtons?.length}
                infoText={t('teams.adminPage.additionalFields.navButtons_msg')}
                fixedHeight
                onWhiteBG
              />
              <ProjectEditPageGridRow directionMobile={!!teamNavButtons?.length ? "column" : 'row' } isTeamEdit>
                  <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                    <ButtonEditGroup
                      buttons={teamNavButtons}
                      currentLang={currentLang}
                      buttonTypes={isModer ? buttonTypesForModer : buttonTypes}
                      onChange={onTeamNavButtonChange}
                      OnDelete={onTeamNavButtonDelete}
                      OnAdd={onTeamNavButtonAdd}
                      forms={actualForms}
                      anchorTypes={anchorTypes}
                      createButtonText={t('teams.adminPage.buttons.add')}
                    />
                    </ProjectEditPageGridList>
                </ProjectEditPageGridRow>
            </LangBlockWrapper>
        )
    }, [teamNavButtons, isS, is1280, anchorTypes])

    const onSetTeamTabs = useCallback((val: any) => {
        if (val?.length > MAX_TABS_COUNT && val) {
            toasts.error(`Максимальное количество вкладок: ${MAX_TABS_COUNT}`);
            return;
        }
        if (val?.length > MAX_TABS_FOR_LARGE_TABS_VIEW || !val?.length) {
            setTeamIsLargeTabs(false)
        }
        setTeamTabs(val)
    }, [])

    const onSetTopLinks = useCallback((val: any) => {
        if (val?.length > MAX_TOP_LINKS_COUNT && val) {
            toasts.error(`Максимальное количество заглавных ссылок: ${MAX_TOP_LINKS_COUNT}`);
            return;
        }
        setTopLinks(val)
    }, [])

    const tabsBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.tab}
                isChannel={isChannel}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={teamTabs}
                setTabs={onSetTeamTabs}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
                onTabChange={(tab: ITeamTab, index: number) => onTeamTabChange(TabType.tab, tab, index)}
                hasHint
                hintMgs={t('teams.adminPage.additionalFields.tabs_msg')}
            />
        )
    }, [teamTabs, isMobile, isS, is1280, onSetTeamTabs, isChannel])

    const topLinksBlock = useMemo(() => {
        return (
            <TeamTopLinksBlock
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                topLinks={topLinks}
                setTopLinks={onSetTopLinks}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
            />
        )
    }, [topLinks, isMobile, isS, is1280, onSetTopLinks])

    const categoriesBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.category}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={teamCategories}
                setTabs={setTeamCategories}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
                hasHint
                hintMgs={t('teams.adminPage.additionalFields.categories_msg')}
            />
        )
    }, [teamCategories, isMobile, isS, is1280])

    const shopTabsBlock = useMemo(() => {
        return (
            <TeamTabsBlock
                type={TabType.shop}
                isMobile={isMobile}
                isS={isS}
                is1280={is1280}
                tabs={shopTabs}
                setTabs={setShopTabs}
                onModalStateChange={onModalStateChange}
                onLocalLangChange={onLocalLangChange}
            />
        )
    }, [shopTabs, isMobile, isS, is1280])

    const sectionsBlock = useMemo(() => {

        if (showCaseFilterType === ShowCaseFilterType.showcase) return;
        if (showCaseFilterType === ShowCaseFilterType.sections) return (
            <>
                {categoriesBlock}
            </>
        );

    }, [categoriesBlock, mainFilterBlock, showCaseFilterType, tabsBlock]);

    const aboutTab = useMemo(() => {

        if (isModer) return <>
            {moderTypeBlock}
            {teamNameBlock}
            {titleTypeBlock}
            {isLinksInsteadTitle && topLinksBlock}
            {!isLinksInsteadTitle && aboutBlock}
            {aboutExtraBlock}
            {!isLinksInsteadTitle && additionalNameBlock}
            {coverTitleBlock}
            {coverBlock}
            {hasTeamBG && coverLinkBlock}
            {officeBlock}
            {phoneBlock}
            {emailBlock}
            {navButtonsBlock}

            {typeUnitBlock}
            {pathBlock}
            {longreadBlock}
            {canEditSelfLG && privateBlock}
            {hasLongread && disabledBlock}
            {canEditSelfLG && anchorLimitBlock}
            {feedbackFormsBlock}
            {showQuBlock}
            {buttonsBlock}
        </>

        return <>
            {teamNameBlock}
            {titleTypeBlock}
            {isLinksInsteadTitle && topLinksBlock}
            {!isLinksInsteadTitle && aboutBlock}
            {aboutExtraBlock}
            {!isLinksInsteadTitle && additionalNameBlock}
            {coverTitleBlock}
            {coverBlock}
            {hasTeamBG && coverLinkBlock}
            {officeBlock}
            {phoneBlock}
            {emailBlock}

            {pathBlock}
            {longreadBlock}
            {canEditSelfLG && anchorLimitBlock}
            {feedbackFormsBlock}
            {showQuBlock}
            {buttonsBlock}
        </>
    }, [aboutBlock, topLinksBlock, additionalNameBlock, anchorLimitBlock, buttonsBlock, coverBlock, coverLinkBlock, isLinksInsteadTitle, showCaseTitleType,
        disabledBlock, hasLongread, canEditSelfLG, hasTeamBG, isModer, longreadBlock, moderTypeBlock, navButtonsBlock,
        officeBlock, pathBlock, phoneBlock, privateBlock, teamNameBlock, titleTypeBlock, typeUnitBlock, feedbackFormsBlock, showQuBlock])

    const projectsTab = useMemo(() => {

        if (isModer) return <>
            {teamContextBlock}
            {[ModerationType.Own, ModerationType.OwnWithoutTag]?.includes(teamModerationType.value) && showWorksBlock}
            {moderRoleBlock}
            {tagForAddTeamBlock}
            {canCreateProjectBlock}
            {employeesFilterBlock}
            {tabEntityBlock}
            {canSortingProject}
            {mainFilterBlock}
            {tabsBlock}
            {categoriesBlock}
        </>

        return <>
            {contentBlock}
            {tagForAddTeamBlock}
            {tabEntityBlock}
            {filterTypeBlock}
            {mainFilterBlock}
            {sectionsBlock}
            {tabsBlock}
        </>
    }, [canCreateProjectBlock, contentBlock, filterTypeBlock, sectionsBlock, categoriesBlock, employeesFilterBlock, isModer, mainFilterBlock, moderRoleBlock,
        showWorksBlock, tabEntityBlock, tabsBlock, tagAppoitmentBlock, tagForAddTeamBlock, canSortingProject,
        teamContextBlock, teamModerationType.value])

    const lmsTab = useMemo(() => {
        return <>
            {courseTypeBlock}
            {courseLevelBlock}
            {courseStartBlock}
            {coursePriceBlock}
            {courseDurationBlock}
            {courseCardCover}
            <Disciplines onModalStateChange={onModalStateChange} teamId={team?.teamId ?? ''} />
            <ModulesOrder onModalStateChange={onModalStateChange} teamId={team?.teamId ?? ''} />
            {competencesBlock}
            {competenceYearBlock}
            {importBlock}
            {tagEducationTagBlock}
            {/* {courseEndBlock} */}
        </>
    }, [courseLevelBlock, coursePriceBlock, courseDurationBlock, competencesBlock, competenceYearBlock, courseCardCover, courseStartBlock, courseTypeBlock, tagEducationTagBlock, team?.teamId])

    const peopleTab = useMemo(() => {

        if (isModer) return <>
            {ownersAndParticipantsBlock}
            {linkParticipantsBlock}
            {groupsBlock}
        </>

        return <>
            {ownersAndParticipantsBlock}
            {linkParticipantsBlock}
            {groupsBlock}
        </>
    }, [groupsBlock, isModer, linkParticipantsBlock, ownersAndParticipantsBlock])

    const marketingTab = useMemo(() => {

        if (isModer) return <>
            {teamModerationType.value === 2 && (isModer || hasAccessToTeamsAdmin) && goodsBlock}
            {teamModerationType.value === 2 && (isModer || hasAccessToTeamsAdmin) && showShopBlock}
            {shopTabsBlock}
            {shopButtonsBlock}
            {ShopAboutBlock}
            {OutOfStockMessageBlock}
            {OutOfStockLinkBlock}
            {IsArchiveItemsShopBlock}
            {HideShopWordBlock}
            {IsHideParticipantsShopBlock}
        </>

        return <>
            {teamModerationType?.value === 2 && (isModer || hasAccessToTeamsAdmin) && goodsBlock}
        </>
    }, [HideShopWordBlock, IsArchiveItemsShopBlock, IsHideParticipantsShopBlock, OutOfStockLinkBlock, OutOfStockMessageBlock,
        ShopAboutBlock, goodsBlock, hasAccessToTeamsAdmin, isModer, shopButtonsBlock, shopTabsBlock,
        showShopBlock, teamModerationType?.value])

    const onChannelChatPermissionChange = (data: any, fieldName?: string) => {

        if (fieldName === 'whiteListIds') {
            const dublicate = data?.find((i: string) => blackListIds?.includes(i))

            if (dublicate) {
                setBlackListIds(blackListIds?.filter((i) => i !== dublicate))
            }
            setWhiteListIds(data)
        }
        if (fieldName === 'blackListIds') {
            const dublicate = data?.find((i: string) => whiteListIds?.includes(i))

            if (dublicate) {
                setWhiteListIds(whiteListIds?.filter((i) => i !== dublicate))
            }
            setBlackListIds(data)
        }

        switch (fieldName) {
            case 'channelCommentMsg':
                return setChannelCommentMsg(data)
            case 'status':
                return setChannelClosedStatus(data)
            default:
                return
        }
    }

    const channelTab = useMemo(() => {

        if (['main', 'about']?.includes(currentTab)) {
            return (
                <>
                    {teamNameBlock}
                    {aboutBlock}
                    {feedOrMediaBlock}
                    {coverBlock}
                    {tabsBlock}
                </>
            )
        }

        return <>
            <ChatPermissionEdit
                channelType={channelType}
                whiteListIds={whiteListIds}
                blackListIds={blackListIds}
                status={channelCommentClosedStatus}
                channelCommentsMsg={channelCommentMsg}
                onChange={onChannelChatPermissionChange}
            />
        </>

    }, [teamNameBlock, feedOrMediaBlock, channelType, aboutBlock, whiteListIds, blackListIds, channelCommentMsg, coverBlock, channelCommentClosedStatus, currentTab, tabsBlock])

    const tabsWrapper = useMemo(() => {
        const tabs = {
            'about': aboutTab,
            'projects': projectsTab,
            'lms': lmsTab,
            'people': peopleTab,
            'marketing': marketingTab,
        }

        const currentTabKey = currentTab as keyof typeof tabs;

        return <FlexBox direction="column" directionMobile="column" offsetBottom={104} style={{ maxWidth: 804 }}>
            {tabs?.[currentTabKey] || null}
        </FlexBox>
    }, [aboutTab, currentTab, lmsTab, marketingTab, peopleTab, projectsTab])

    if (isUpdateError) {
        return <ProjectEditFrameUpdateError id={id} />;
    }

    if (isError) {
        return <ProjectEditFrameError id={id} />;
    }

    if (isCreating) {
        return <ProjectEditFrameCreating id={id} />;
    }


    if (!team || !profile || !team.teamId) {
        return <ProjectEditFrameLoading id={id} />;
    }

    if (isForbidden) {
        return <ProjectEditFrameForbidden id={id} />;
    }

    if (showModal && modalSettings) {
        const { mode } = modalSettings;
        if (mode === 'mainFilter') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <TeamFilterEdit
                        filter={teamMainFilter}
                        onChange={setTeamMainFilter}
                        isMainFilter
                        isModer={isModer || hasAccessToTeamsAdmin}
                    />
                </PageViewportLayout>
            );
        }
        else if (['tab', 'category', 'shop'].includes(mode)) {
            const tabsIndex: any = {
                tab: teamTabs,
                category: teamCategories,
                shop: shopTabs,
            }
            const tabs = tabsIndex[mode];
            if (!!tabs[modalSettings.index]) {
                return (
                    <PageViewportLayout offsetTop={40}>
                        {PortalMenu}
                        <TeamTabEdit
                            isModer={isModer || hasAccessToTeamsAdmin}
                            type={mode as TabType}
                            categories={teamCategories}
                            tab={tabs[modalSettings.index]}
                            tabIndex={modalSettings.index}
                            teamId={team?.teamId}
                            team={team}
                            anchorTypes={anchorTypes}
                            actualForms={actualForms}
                            maxLGButtonsCount={maxLGButtonsCount}
                            updateTeam={updateTeam}
                            setIsChangesSaved={setIsChangesSaved}
                            onChange={(tab: ITeamTab) => onTeamTabChange(mode as TabType, tab, modalSettings.index)}
                        />
                    </PageViewportLayout>
                );
            }
        }
        else if (modalSettings.mode === 'forms') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <TeamFormsEdit
                        form={currentForm}
                        onUpdate={(val: any) => setDate(val)}
                        onStatusSet={(val: string) => setStatusText(val)}
                        isChangesSaved={isChangesSaved}
                        setIsFormFieldsFilled={setIsFormFieldsFilled}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'discipline') {
            return (
                <PageViewportLayout isDiscipline style={{ width: 'auto' }} offsetTop={40}>
                    {PortalMenu}
                    <TeamDisciplineEdit
                        discipline={modalSettings?.item || null}
                        onUpdate={(val: any) => setDate(val)}
                        onStatusSet={(val: string) => setStatusText(val)}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'import-groups') {
            return (
                <PageViewportLayout offsetTop={40}>
                    {PortalMenu}
                    <ImportGroupsModal 
                        groups={modalSettings?.item?.groups || []} 
                        teamId={team?.teamId || ''}
                        onClose={() => onModalStateChange(false, null)}
                        onGroupsChange={() => {}}
                        onUpdate={(val: any) => setDate(val)}
                        onTeamDataRefresh={refreshTeamData}
                        onGroupsRefresh={refreshGroups}
                    />
                </PageViewportLayout>
            );
        }
        else if ((modalSettings.mode === 'group' || tab === 'group') && currentGroup) {
            return (
                <PageViewportLayout offsetTop={40}>
                    <TeamGroupEdit
                        // teamModerationType={teamModerationType}
                        channelType={channelType}
                        teamId={team?.teamId}
                        actualTeamOwners={teamOwners}
                        actualTeamMembers={teamMembers}
                        group={currentGroup}
                        channelId={channelsParams?.getChannelid(currentGroup?.id)}
                        mobileEditorOpen={mobileEditorOpen}
                        onUpdate={(val: any) => {
                            setShowModal(false)
                            setDate(val)
                        }}
                        onResetGroup={() => setCurrentGroup(undefined)}
                        onDelete={onGroupDelete}
                        onBackClick={() => {
                            onModalStateChange(false, null)
                            setShowModal(false)
                        }}
                        onStatusSet={(val: string) => setStatusText(val)}
                        status={statusText}
                    />
                </PageViewportLayout>
            );
        }
        else if (modalSettings.mode === 'lg' || tab === 'lg') {

            return (
                <PageViewportLayout offsetTop={0} vtype={'fluid-wide'}>
                    {PortalMenu}
                    <TeamLgEdit
                        team={computeTeam(team)}
                        teamFilter={teamMainFilter}
                        managedTags={teamManagedTags}
                        teamTags={teamTags}
                        hasCover={hasCover}
                        onTagsChange={setTeamTags}
                        onManagedTagChange={setTeamManagedTags}
                        onAdditionalContentChange={onAdditionalContentChange}
                        tab={teamTabs[modalSettings.index]}
                        // @ts-ignore
                        additionalContent={additionalContent}
                        onChange={(tab: ITeamTab) => onTeamTabChange(TabType.tab, tab, modalSettings.index)}
                        changeColor={(val: any) => setUserColor(val)}
                        changeTitlePosition={(val: any) => setUserTitlePosition(val)}
                        titlePosition={userTitlePosition}
                        color={{
                            userColor: userColor
                        }}
                        longreadLength={longreadLength}
                        titleIsHidden={titleIsHidden}
                        onTitleHiddenClick={(val: boolean) => setTitleHidden(val)}
                        onSetLgLength={(val: number) => {
                            setHasLongread(val > 0)
                            onChangeLongreadLength(val)
                        }}
                        onSetMobTextLength={setMobTextBlockLength}
                        onSetMobileEditor={(val: boolean) => setMobileEditorOpen(val)}
                        mobileEditorAction={mobileEditorAction}
                        isPreview={isPreview}
                        longreadReady={longreadReady}
                        setLongreadReady={setLongreadReady}
                        isModer={isModer || hasAccessToTeamsAdmin}
                        vtype={team?.longread?.viewType}
                        onUpdate={(val: number) => setDate(val)}
                        onSetAnchors={onSetAnchors}
                    />
                </PageViewportLayout>
            );
        }
        else {
            return <ProjectEditFrameError id={id} />;
        }
    }

    if (isChannel) {
        return <PageViewportLayout offsetTop={16} offsetTopMobile={24}>
            {PortalMenu}
            {!showLoader && (
                <CommonContainer isTeamPage>
                    <ProjectEditPageGridRow style={{ placeItems: 'center' }} width={'100%'} justify="space-between" align={'center'} offsetBottomMobile={8}>
                        <MainHeader>{mainHeader}</MainHeader>
                        {channelType === ModerationType.Channel && (
                            <ChannelDescription
                                style={{
                                    cursor: 'pointer',
                                    ...(isMobile && { marginBottom: 8 })
                                }
                                }
                                onClick={onChannelDelete}
                            >
                                {t('teams.adminPage.additionalFields.channel_delete')}
                            </ChannelDescription>
                        )}

                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow offsetBottom={16} offsetBottomMobile={8}>
                        <ChannelDescription >
                            {t('teams.adminPage.additionalFields.channel_title')}
                        </ChannelDescription>
                    </ProjectEditPageGridRow>

                    <ProjectEditPageGridRow>
                        <MainTabsWrapper>
                            <SlideNavigation
                                activeIndexKey={currentTab}
                                onChange={(tab) => {
                                    setCurrentTab(tab as string);
                                    setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                                    sessionStorage.setItem('lastTab', tab)
                                }}
                                items={channelTabsList}
                                dropdownWhiteTheme
                                isLoading={false}
                            />
                        </MainTabsWrapper>
                    </ProjectEditPageGridRow>

                </CommonContainer>
            )}

            <ChannelEdit 
                channelTab={channelTab} 
                isLoading={showLoader} 
                onCancel={onChannelQuit} 
                onSave={primaryButtonClick} 
                canSaveLgText={canSaveLgText} 
                setIsTeamDeleted={setIsTeamDeleted} 
            />
        </PageViewportLayout>
    }

    return (
        <PageViewportLayout offsetTop={16} offsetTopMobile={24}>
            {PortalMenu}
            <CommonContainer isTeamPage>
                <ProjectEditPageGridRow offsetBottom={56} offsetBottomMobile={24}>
                    <MainHeader>{mainHeader}</MainHeader>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow>
                    <MainTabsWrapper>
                        <SlideNavigation
                            activeIndexKey={currentTab}
                            onChange={(tab) => {
                                setCurrentTab(tab as string);
                                setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                                sessionStorage.setItem('lastTab', tab)
                            }}
                            items={tabList}
                            dropdownWhiteTheme
                            isLoading={false}
                        />
                    </MainTabsWrapper>
                </ProjectEditPageGridRow>

                {tabsWrapper}

            </CommonContainer>
        </PageViewportLayout>
    );
};


export const TeamEdit = (props: any) => {
    const formMethods = useForm();
    const { handleSubmit } = formMethods;

    const onSubmit = () => {}

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <TeamEditComponent {...props} />
            </form>
        </FormProvider>
    )
}

export default TeamEdit;